var Ir = (i) => {
  throw TypeError(i);
};
var Ei = (i, e, t) => e.has(i) || Ir("Cannot " + t);
var p = (i, e, t) => (Ei(i, e, "read from private field"), t ? t.call(i) : e.get(i)), T = (i, e, t) => e.has(i) ? Ir("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(i) : e.set(i, t), P = (i, e, t, r) => (Ei(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $ = (i, e, t) => (Ei(i, e, "access private method"), t);
var ni = (i, e, t, r) => ({
  set _(s) {
    P(i, e, s, t);
  },
  get _() {
    return p(i, e, r);
  }
});
import { jsx as y, jsxs as A, Fragment as Li } from "react/jsx-runtime";
import { Checkbox as Jn, ActionMenu as Zn, LanguageCodeEnum as ki, Modal as bi, PrimaryButton as ti, SecondaryButton as Us, FieldErrorAndDescription as ui, ActionMenuItem as wi, FormInputSearch as ea, FormSelectMultiple as Mr, Loader as ta, toast as ye, CheckBoxSwitcher as ia, useWindowSize as ra, FormInput as sa, ModalSizeEnum as na } from "@systemeio/ui";
import * as ce from "react";
import Oe, { createContext as $s, useContext as aa, useState as W, useRef as be, useEffect as Ee, useCallback as oa, Children as la, memo as ca } from "react";
import { twMerge as ie } from "tailwind-merge";
import { CloseIcon as Tr, InfoIcon as ua, BinIcon as ha, PenIcon as da, DownloadIcon as fa, CloseCircleIcon as Lr, SmallPenIcon as pa, UploadIcon as ga } from "@systemeio/ui/icons";
import { getTFuncWithNamespace as ma, getUseLocoTranslation as va, createHttpClient as ya, getUseBaseFetch as ba, RequestMethodsEnum as mt, BadRequest as wa } from "@systemeio/util";
import { flushSync as xa } from "react-dom";
import fr from "axios";
var ze = /* @__PURE__ */ ((i) => (i.Docx = ".docx", i.Doc = ".doc", i.Ttf = ".ttf", i.AD_PRT = ".AD_PRT", i.AD_SMP = ".AD_SMP", i.AD_ASM = ".AD_ASM", i.AD_DRW = ".AD_DRW", i))(ze || {}), X = /* @__PURE__ */ ((i) => (i.Editor = "editor", i.Community = "community", i.BlockPreview = "block_preview", i.Membership = "membership", i.Marketplace = "marketplace", i.Settings = "settings", i.Email = "email", i.Ckeditor = "ckeditor", i.TextEditor = "text_editor", i.BlogPost = "blog_post", i.PageTemplate = "page_template", i.PageTemplatePreview = "page_template_preview", i.BlogTemplatePreview = "blog_template_preview", i.EmailTemplate = "email_template", i.WebsiteTemplate = "website_template", i.Product = "product", i.FunnelTemplatePreview = "funnel_template_preview", i.DigitalStore = "digital_store", i.DigitalProductResource = "digital_product_resource", i.CalendarHostAvatar = "calendar_host_avatar", i.FileManager = "file_manager", i.WhiteLabel = "white_label", i))(X || {}), Y = /* @__PURE__ */ ((i) => (i.Image = "image", i.ImageOther = "image_other", i.Video = "video", i.Audio = "audio", i.Font = "font", i.Document = "document", i))(Y || {});
const Ca = (i) => {
  if (typeof i != "object" || i === null) return !1;
  const e = i;
  return typeof e.id == "number" && typeof e.name == "string" && typeof e.filename == "string" && typeof e.path == "string" && (typeof e.thumbnail == "string" || e.thumbnail === null) && Object.values(X).includes(e.source) && typeof e.size == "number" && Object.values(Y).includes(e.type) && typeof e.createdAt == "string";
}, Sa = {
  [X.Editor]: "file_manager.file_source.editor",
  [X.Community]: "file_manager.file_source.community",
  [X.BlockPreview]: "file_manager.file_source.block_preview",
  [X.Membership]: "file_manager.file_source.membership",
  [X.Marketplace]: "file_manager.file_source.marketplace",
  [X.Settings]: "file_manager.file_source.settings",
  [X.Email]: "file_manager.file_source.email",
  [X.Ckeditor]: "file_manager.file_source.ckeditor",
  [X.BlogPost]: "file_manager.file_source.blog_post",
  [X.PageTemplate]: "file_manager.file_source.page_template",
  [X.PageTemplatePreview]: "file_manager.file_source.page_template_preview",
  [X.BlogTemplatePreview]: "file_manager.file_source.blog_template_preview",
  [X.EmailTemplate]: "file_manager.file_source.email_template",
  [X.Product]: "file_manager.file_source.product",
  [X.FunnelTemplatePreview]: "file_manager.file_source.funnel_template_preview",
  [X.DigitalStore]: "file_manager.file_source.digital_store",
  [X.DigitalProductResource]: "file_manager.file_source.digital_product_resource",
  [X.CalendarHostAvatar]: "file_manager.file_source.calendar_host_avatar",
  [X.FileManager]: "file_manager.file_source.file_manager",
  [X.TextEditor]: "file_manager.file_source.text_editor",
  [X.WhiteLabel]: "file_manager.file_source.white_label",
  [X.WebsiteTemplate]: "file_manager.file_source.website_template"
}, Oa = {
  [Y.Image]: "file_manager.file_type.image",
  [Y.ImageOther]: "file_manager.file_type.image_other",
  [Y.Video]: "file_manager.file_type.video",
  [Y.Audio]: "file_manager.file_type.audio",
  [Y.Font]: "file_manager.file_type.font",
  [Y.Document]: "file_manager.file_type.document"
};
var pr = /* @__PURE__ */ ((i) => (i.Next = "next", i.Prev = "prev", i))(pr || {}), Bs = /* @__PURE__ */ ((i) => (i.Asc = "ASC", i.Desc = "DESC", i))(Bs || {});
function Ea(i) {
  return /* @__PURE__ */ y(
    "svg",
    {
      id: "Layer_1",
      enableBackground: "new 0 0 28 28",
      height: "512",
      viewBox: "0 0 28 28",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...i,
      children: /* @__PURE__ */ y("g", { id: "_x35_3", children: /* @__PURE__ */ y("path", { d: "m4.6 8.7c-.2.5-.3 1-.3 1.5v12.2c0 2 1.6 3.6 3.6 3.6h12.2c2 0 3.6-1.6 3.6-3.6v-16.8c0-2-1.6-3.6-3.6-3.6h-7.6c-.5 0-1 .1-1.5.3-.4.2-.7.4-1 .7l-4.6 4.6c-.3.3-.6.7-.8 1.1zm8.1 5.7c.3 0 .7.1 1 .2v-6c0-.4.2-.8.6-.9.4-.2.8-.1 1.1.2l2.7 2.7c.4.4.4 1 0 1.4s-1 .4-1.4 0l-1-1v6.3c0 1.7-1.4 3-3 3-1.7 0-3-1.3-3-3 0-1.6 1.3-2.9 3-2.9z" }) })
    }
  );
}
function kr(i) {
  return /* @__PURE__ */ A(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      id: "Capa_1",
      enableBackground: "new 0 0 512 512",
      height: "512",
      viewBox: "0 0 512 512",
      width: "512",
      ...i,
      children: [
        /* @__PURE__ */ y("path", { d: "m106 512h300c24.814 0 45-20.186 45-45v-317h-105c-24.814 0-45-20.186-45-45v-105h-195c-24.814 0-45 20.186-45 45v422c0 24.814 20.186 45 45 45zm60-301h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h120c8.291 0 15 6.709 15 15s-6.709 15-15 15h-120c-8.291 0-15-6.709-15-15s6.709-15 15-15z" }),
        /* @__PURE__ */ y("path", { d: "m346 120h96.211l-111.211-111.211v96.211c0 8.276 6.724 15 15 15z" })
      ]
    }
  );
}
function Na(i) {
  return /* @__PURE__ */ A(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: "512pt",
      viewBox: "0 -64 512 512",
      width: "512pt",
      ...i,
      children: [
        /* @__PURE__ */ y("path", { d: "m149.332031 106.667969c0 23.5625-19.101562 42.664062-42.664062 42.664062-23.566407 0-42.667969-19.101562-42.667969-42.664062 0-23.566407 19.101562-42.667969 42.667969-42.667969 23.5625 0 42.664062 19.101562 42.664062 42.667969zm0 0" }),
        /* @__PURE__ */ y("path", { d: "m448 0h-384c-35.285156 0-64 28.714844-64 64v256c0 1.195312.296875 2.324219.363281 3.519531-.300781 2.558594-.171875 5.140625.765625 7.574219 5.269532 29.996094 31.382813 52.90625 62.871094 52.90625h384c35.285156 0 64-28.714844 64-64v-256c0-35.285156-28.714844-64-64-64zm-384 42.667969h384c11.753906 0 21.332031 9.578125 21.332031 21.332031v169.367188l-112.210937-112.214844c-14.59375-14.59375-38.335938-14.59375-52.90625 0l-101.546875 101.546875-26.882813-26.878907c-14.589844-14.59375-38.335937-14.59375-52.90625 0l-80.210937 80.210938v-212.03125c0-11.753906 9.578125-21.332031 21.332031-21.332031zm0 0" })
      ]
    }
  );
}
function _a(i) {
  return /* @__PURE__ */ A(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      id: "Capa_1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 467.968 467.968",
      ...i,
      children: [
        /* @__PURE__ */ y("g", { children: /* @__PURE__ */ y("g", { children: /* @__PURE__ */ y("path", { d: "M264.704,96.512H51.2c-28.16,0-51.2,23.04-51.2,51.2v172.544c0,28.16,23.04,51.2,51.2,51.2h213.504    c28.16,0,51.2-23.04,51.2-51.2V147.712C315.904,119.04,292.864,96.512,264.704,96.512z" }) }) }),
        /* @__PURE__ */ y("g", { children: /* @__PURE__ */ y("g", { children: /* @__PURE__ */ y("path", { d: "M430.08,124.672c-3.072,0.512-6.144,2.048-8.704,3.584l-79.872,46.08V293.12l80.384,46.08    c14.848,8.704,33.28,3.584,41.984-11.264c2.56-4.608,4.096-9.728,4.096-15.36V154.368    C467.968,135.424,450.048,120.064,430.08,124.672z" }) }) }),
        /* @__PURE__ */ y("g", {}),
        /* @__PURE__ */ y("g", {}),
        /* @__PURE__ */ y("g", {}),
        /* @__PURE__ */ y("g", {}),
        /* @__PURE__ */ y("g", {}),
        /* @__PURE__ */ y("g", {}),
        /* @__PURE__ */ y("g", {}),
        /* @__PURE__ */ y("g", {}),
        /* @__PURE__ */ y("g", {}),
        /* @__PURE__ */ y("g", {}),
        /* @__PURE__ */ y("g", {}),
        /* @__PURE__ */ y("g", {}),
        /* @__PURE__ */ y("g", {}),
        /* @__PURE__ */ y("g", {}),
        /* @__PURE__ */ y("g", {})
      ]
    }
  );
}
function Ra(i) {
  switch (i) {
    case Y.Audio:
      return /* @__PURE__ */ y(Ea, { className: "fill-text-secondary", width: 40, height: 40 });
    case Y.Image:
    case Y.ImageOther:
      return /* @__PURE__ */ y(Na, { className: "fill-text-secondary", width: 40, height: 40 });
    case Y.Video:
      return /* @__PURE__ */ y(_a, { className: "fill-text-secondary", width: 40, height: 40 });
    case Y.Font:
    case Y.Document:
      return /* @__PURE__ */ y(kr, { className: "fill-text-secondary", width: 40, height: 40 });
    default:
      return /* @__PURE__ */ y(kr, { className: "fill-text-secondary", width: 40, height: 40 });
  }
}
const Lt = /* @__PURE__ */ new Set(), kt = /* @__PURE__ */ new Set(), ot = Oe.memo(
  ({
    src: i,
    fileType: e,
    alt: t,
    className: r,
    isThumbnail: s = !1,
    width: n,
    height: a,
    title: o
  }) => {
    const [l, c] = Oe.useState(kt.has(i)), [h, d] = Oe.useState(Lt.has(i));
    return /* @__PURE__ */ A(
      "div",
      {
        className: ie("flex items-center justify-center", r),
        style: {
          width: n,
          height: a,
          minHeight: a
        },
        title: o,
        children: [
          e !== Y.Video && /* @__PURE__ */ y(
            "img",
            {
              src: i,
              alt: t,
              className: ie(
                "flex-2 w-full rounded-md object-cover",
                s && "h-full object-cover",
                !l && h ? "block" : "hidden"
              ),
              onLoad: () => {
                d(!0), Lt.add(i), kt.delete(i);
              },
              onError: () => {
                c(!0), Lt.delete(i), kt.add(i);
              }
            }
          ),
          e === Y.Video && /* @__PURE__ */ y(
            "video",
            {
              src: i,
              className: ie(
                "flex-2 w-full rounded-md object-cover",
                s && "h-full object-cover",
                !l && h ? "block" : "hidden"
              ),
              onLoadedData: () => {
                d(!0), Lt.add(i), kt.delete(i);
              },
              onError: () => {
                c(!0), Lt.delete(i), kt.add(i);
              },
              controls: !s
            }
          ),
          /* @__PURE__ */ y(
            "div",
            {
              className: ie(
                "flex-2 flex items-center justify-center rounded-md",
                !s && "min-h-[300px]",
                !i || l ? "flex" : "hidden"
              ),
              children: Ra(e)
            }
          )
        ]
      }
    );
  }
);
ot.displayName = "FilePreview";
function Da({
  fileType: i,
  src: e,
  alt: t,
  name: r,
  secondaryText: s,
  style: n,
  selected: a,
  actionMenu: o,
  className: l,
  imageWidth: c,
  imageHeight: h,
  onSelect: d
}) {
  const u = Oe.useRef(null), f = Oe.useRef(null);
  return /* @__PURE__ */ A(
    "div",
    {
      className: ie("relative flex flex-col cursor-pointer", l),
      style: n,
      onClick: (g) => {
        var b;
        u.current && !((b = f.current) != null && b.contains(g.target)) && u.current.click();
      },
      children: [
        /* @__PURE__ */ y(
          ot,
          {
            src: e ?? "",
            fileType: i,
            alt: t,
            width: c,
            height: h,
            className: ie(
              "relative -top-[2px] -left-[2px] flex-1 rounded-lg border-2 border-transparent box-content",
              a && "border-brand-primary"
            ),
            isThumbnail: !0
          }
        ),
        /* @__PURE__ */ y("div", { ref: f, className: "absolute top-1 left-1", children: /* @__PURE__ */ y(Jn, { inputRef: u, value: a, onChange: d }) }),
        /* @__PURE__ */ y("div", { onClick: (g) => g.stopPropagation(), children: /* @__PURE__ */ y(
          Zn,
          {
            toggleOnHover: !0,
            menuButtonClassName: "absolute top-1 right-1 p-1 h-[20px] w-[26px]",
            menuItemsClassName: "z-30",
            ...o,
            menuItems: (o == null ? void 0 : o.menuItems) ?? []
          }
        ) }),
        /* @__PURE__ */ y(
          "div",
          {
            className: "truncate overflow-clip text-base text-text-primary mt-1",
            title: r,
            children: r
          }
        ),
        /* @__PURE__ */ y(
          "div",
          {
            className: "truncate overflow-clip text-sm text-text-secondary mt-1",
            title: s,
            children: s
          }
        )
      ]
    }
  );
}
const Pa = (i, e, t) => {
  const r = i[e];
  return r ? typeof r == "function" ? r() : Promise.resolve(r) : new Promise((s, n) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      n.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + e + (e.split("/").length !== t ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, L = (i) => typeof i == "string", At = () => {
  let i, e;
  const t = new Promise((r, s) => {
    i = r, e = s;
  });
  return t.resolve = i, t.reject = e, t;
}, Ar = (i) => i == null ? "" : "" + i, Fa = (i, e, t) => {
  i.forEach((r) => {
    e[r] && (t[r] = e[r]);
  });
}, Ia = /###/g, jr = (i) => i && i.indexOf("###") > -1 ? i.replace(Ia, ".") : i, zr = (i) => !i || L(i), Ht = (i, e, t) => {
  const r = L(e) ? e.split(".") : e;
  let s = 0;
  for (; s < r.length - 1; ) {
    if (zr(i)) return {};
    const n = jr(r[s]);
    !i[n] && t && (i[n] = new t()), Object.prototype.hasOwnProperty.call(i, n) ? i = i[n] : i = {}, ++s;
  }
  return zr(i) ? {} : {
    obj: i,
    k: jr(r[s])
  };
}, Ur = (i, e, t) => {
  const {
    obj: r,
    k: s
  } = Ht(i, e, Object);
  if (r !== void 0 || e.length === 1) {
    r[s] = t;
    return;
  }
  let n = e[e.length - 1], a = e.slice(0, e.length - 1), o = Ht(i, a, Object);
  for (; o.obj === void 0 && a.length; )
    n = `${a[a.length - 1]}.${n}`, a = a.slice(0, a.length - 1), o = Ht(i, a, Object), o && o.obj && typeof o.obj[`${o.k}.${n}`] < "u" && (o.obj = void 0);
  o.obj[`${o.k}.${n}`] = t;
}, Ma = (i, e, t, r) => {
  const {
    obj: s,
    k: n
  } = Ht(i, e, Object);
  s[n] = s[n] || [], s[n].push(t);
}, hi = (i, e) => {
  const {
    obj: t,
    k: r
  } = Ht(i, e);
  if (t)
    return t[r];
}, Ta = (i, e, t) => {
  const r = hi(i, t);
  return r !== void 0 ? r : hi(e, t);
}, Hs = (i, e, t) => {
  for (const r in e)
    r !== "__proto__" && r !== "constructor" && (r in i ? L(i[r]) || i[r] instanceof String || L(e[r]) || e[r] instanceof String ? t && (i[r] = e[r]) : Hs(i[r], e[r], t) : i[r] = e[r]);
  return i;
}, ut = (i) => i.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var La = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const ka = (i) => L(i) ? i.replace(/[&<>"'\/]/g, (e) => La[e]) : i;
class Aa {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const t = this.regExpMap.get(e);
    if (t !== void 0)
      return t;
    const r = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, r), this.regExpQueue.push(e), r;
  }
}
const ja = [" ", ",", "?", "!", ";"], za = new Aa(20), Ua = (i, e, t) => {
  e = e || "", t = t || "";
  const r = ja.filter((a) => e.indexOf(a) < 0 && t.indexOf(a) < 0);
  if (r.length === 0) return !0;
  const s = za.getRegExp(`(${r.map((a) => a === "?" ? "\\?" : a).join("|")})`);
  let n = !s.test(i);
  if (!n) {
    const a = i.indexOf(t);
    a > 0 && !s.test(i.substring(0, a)) && (n = !0);
  }
  return n;
}, Ai = function(i, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!i) return;
  if (i[e]) return i[e];
  const r = e.split(t);
  let s = i;
  for (let n = 0; n < r.length; ) {
    if (!s || typeof s != "object")
      return;
    let a, o = "";
    for (let l = n; l < r.length; ++l)
      if (l !== n && (o += t), o += r[l], a = s[o], a !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof a) > -1 && l < r.length - 1)
          continue;
        n += l - n + 1;
        break;
      }
    s = a;
  }
  return s;
}, di = (i) => i && i.replace("_", "-"), $a = {
  type: "logger",
  log(i) {
    this.output("log", i);
  },
  warn(i) {
    this.output("warn", i);
  },
  error(i) {
    this.output("error", i);
  },
  output(i, e) {
    console && console[i] && console[i].apply(console, e);
  }
};
class fi {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, t);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = t.prefix || "i18next:", this.logger = e || $a, this.options = t, this.debug = t.debug;
  }
  log() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, t, r, s) {
    return s && !this.debug ? null : (L(e[0]) && (e[0] = `${r}${this.prefix} ${e[0]}`), this.logger[t](e));
  }
  create(e) {
    return new fi(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new fi(this.logger, e);
  }
}
var Te = new fi();
class xi {
  constructor() {
    this.observers = {};
  }
  on(e, t) {
    return e.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const s = this.observers[r].get(t) || 0;
      this.observers[r].set(t, s + 1);
    }), this;
  }
  off(e, t) {
    if (this.observers[e]) {
      if (!t) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(t);
    }
  }
  emit(e) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
      r[s - 1] = arguments[s];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((a) => {
      let [o, l] = a;
      for (let c = 0; c < l; c++)
        o(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((a) => {
      let [o, l] = a;
      for (let c = 0; c < l; c++)
        o.apply(o, [e, ...r]);
    });
  }
}
class $r extends xi {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const t = this.options.ns.indexOf(e);
    t > -1 && this.options.ns.splice(t, 1);
  }
  getResource(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const n = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, a = s.ignoreJSONStructure !== void 0 ? s.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let o;
    e.indexOf(".") > -1 ? o = e.split(".") : (o = [e, t], r && (Array.isArray(r) ? o.push(...r) : L(r) && n ? o.push(...r.split(n)) : o.push(r)));
    const l = hi(this.data, o);
    return !l && !t && !r && e.indexOf(".") > -1 && (e = o[0], t = o[1], r = o.slice(2).join(".")), l || !a || !L(r) ? l : Ai(this.data && this.data[e] && this.data[e][t], r, n);
  }
  addResource(e, t, r, s) {
    let n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const a = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let o = [e, t];
    r && (o = o.concat(a ? r.split(a) : r)), e.indexOf(".") > -1 && (o = e.split("."), s = t, t = o[1]), this.addNamespaces(t), Ur(this.data, o, s), n.silent || this.emit("added", e, t, r, s);
  }
  addResources(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const n in r)
      (L(r[n]) || Array.isArray(r[n])) && this.addResource(e, t, n, r[n], {
        silent: !0
      });
    s.silent || this.emit("added", e, t, r);
  }
  addResourceBundle(e, t, r, s, n) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, o = [e, t];
    e.indexOf(".") > -1 && (o = e.split("."), s = r, r = t, t = o[1]), this.addNamespaces(t);
    let l = hi(this.data, o) || {};
    a.skipCopy || (r = JSON.parse(JSON.stringify(r))), s ? Hs(l, r, n) : l = {
      ...l,
      ...r
    }, Ur(this.data, o, l), a.silent || this.emit("added", e, t, r);
  }
  removeResourceBundle(e, t) {
    this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
  }
  hasResourceBundle(e, t) {
    return this.getResource(e, t) !== void 0;
  }
  getResourceBundle(e, t) {
    return t || (t = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, t)
    } : this.getResource(e, t);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const t = this.getDataByLanguage(e);
    return !!(t && Object.keys(t) || []).find((s) => t[s] && Object.keys(t[s]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Ws = {
  processors: {},
  addPostProcessor(i) {
    this.processors[i.name] = i;
  },
  handle(i, e, t, r, s) {
    return i.forEach((n) => {
      this.processors[n] && (e = this.processors[n].process(e, t, r, s));
    }), e;
  }
};
const Br = {};
class pi extends xi {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Fa(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Te.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const r = this.resolve(e, t);
    return r && r.res !== void 0;
  }
  extractFromKey(e, t) {
    let r = t.nsSeparator !== void 0 ? t.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const s = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let n = t.ns || this.options.defaultNS || [];
    const a = r && e.indexOf(r) > -1, o = !this.options.userDefinedKeySeparator && !t.keySeparator && !this.options.userDefinedNsSeparator && !t.nsSeparator && !Ua(e, r, s);
    if (a && !o) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: L(n) ? [n] : n
        };
      const c = e.split(r);
      (r !== s || r === s && this.options.ns.indexOf(c[0]) > -1) && (n = c.shift()), e = c.join(s);
    }
    return {
      key: e,
      namespaces: L(n) ? [n] : n
    };
  }
  translate(e, t, r) {
    if (typeof t != "object" && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), typeof t == "object" && (t = {
      ...t
    }), t || (t = {}), e == null) return "";
    Array.isArray(e) || (e = [String(e)]);
    const s = t.returnDetails !== void 0 ? t.returnDetails : this.options.returnDetails, n = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator, {
      key: a,
      namespaces: o
    } = this.extractFromKey(e[e.length - 1], t), l = o[o.length - 1], c = t.lng || this.language, h = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (h) {
        const N = t.nsSeparator || this.options.nsSeparator;
        return s ? {
          res: `${l}${N}${a}`,
          usedKey: a,
          exactUsedKey: a,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(t)
        } : `${l}${N}${a}`;
      }
      return s ? {
        res: a,
        usedKey: a,
        exactUsedKey: a,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(t)
      } : a;
    }
    const d = this.resolve(e, t);
    let u = d && d.res;
    const f = d && d.usedKey || a, g = d && d.exactUsedKey || a, b = Object.prototype.toString.apply(u), v = ["[object Number]", "[object Function]", "[object RegExp]"], O = t.joinArrays !== void 0 ? t.joinArrays : this.options.joinArrays, C = !this.i18nFormat || this.i18nFormat.handleAsObject, E = !L(u) && typeof u != "boolean" && typeof u != "number";
    if (C && u && E && v.indexOf(b) < 0 && !(L(O) && Array.isArray(u))) {
      if (!t.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const N = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(f, u, {
          ...t,
          ns: o
        }) : `key '${a} (${this.language})' returned an object instead of string.`;
        return s ? (d.res = N, d.usedParams = this.getUsedParamsDetails(t), d) : N;
      }
      if (n) {
        const N = Array.isArray(u), R = N ? [] : {}, m = N ? g : f;
        for (const S in u)
          if (Object.prototype.hasOwnProperty.call(u, S)) {
            const w = `${m}${n}${S}`;
            R[S] = this.translate(w, {
              ...t,
              joinArrays: !1,
              ns: o
            }), R[S] === w && (R[S] = u[S]);
          }
        u = R;
      }
    } else if (C && L(O) && Array.isArray(u))
      u = u.join(O), u && (u = this.extendTranslation(u, e, t, r));
    else {
      let N = !1, R = !1;
      const m = t.count !== void 0 && !L(t.count), S = pi.hasDefaultValue(t), w = m ? this.pluralResolver.getSuffix(c, t.count, t) : "", x = t.ordinal && m ? this.pluralResolver.getSuffix(c, t.count, {
        ordinal: !1
      }) : "", _ = m && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), F = _ && t[`defaultValue${this.options.pluralSeparator}zero`] || t[`defaultValue${w}`] || t[`defaultValue${x}`] || t.defaultValue;
      !this.isValidLookup(u) && S && (N = !0, u = F), this.isValidLookup(u) || (R = !0, u = a);
      const H = (t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && R ? void 0 : u, z = S && F !== u && this.options.updateMissing;
      if (R || N || z) {
        if (this.logger.log(z ? "updateKey" : "missingKey", c, l, a, z ? F : u), n) {
          const k = this.resolve(a, {
            ...t,
            keySeparator: !1
          });
          k && k.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let M = [];
        const ee = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && ee && ee[0])
          for (let k = 0; k < ee.length; k++)
            M.push(ee[k]);
        else this.options.saveMissingTo === "all" ? M = this.languageUtils.toResolveHierarchy(t.lng || this.language) : M.push(t.lng || this.language);
        const ae = (k, q, G) => {
          const K = S && G !== u ? G : H;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(k, l, q, K, z, t) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(k, l, q, K, z, t), this.emit("missingKey", k, l, q, u);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && m ? M.forEach((k) => {
          const q = this.pluralResolver.getSuffixes(k, t);
          _ && t[`defaultValue${this.options.pluralSeparator}zero`] && q.indexOf(`${this.options.pluralSeparator}zero`) < 0 && q.push(`${this.options.pluralSeparator}zero`), q.forEach((G) => {
            ae([k], a + G, t[`defaultValue${G}`] || F);
          });
        }) : ae(M, a, F));
      }
      u = this.extendTranslation(u, e, t, d, r), R && u === a && this.options.appendNamespaceToMissingKey && (u = `${l}:${a}`), (R || N) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? u = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${a}` : a, N ? u : void 0) : u = this.options.parseMissingKeyHandler(u));
    }
    return s ? (d.res = u, d.usedParams = this.getUsedParamsDetails(t), d) : u;
  }
  extendTranslation(e, t, r, s, n) {
    var a = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || s.usedLng, s.usedNS, s.usedKey, {
        resolved: s
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const c = L(e) && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let h;
      if (c) {
        const u = e.match(this.interpolator.nestingRegexp);
        h = u && u.length;
      }
      let d = r.replace && !L(r.replace) ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), e = this.interpolator.interpolate(e, d, r.lng || this.language || s.usedLng, r), c) {
        const u = e.match(this.interpolator.nestingRegexp), f = u && u.length;
        h < f && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && s && s.res && (r.lng = this.language || s.usedLng), r.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var u = arguments.length, f = new Array(u), g = 0; g < u; g++)
          f[g] = arguments[g];
        return n && n[0] === f[0] && !r.context ? (a.logger.warn(`It seems you are nesting recursively key: ${f[0]} in key: ${t[0]}`), null) : a.translate(...f, t);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const o = r.postProcess || this.options.postProcess, l = L(o) ? [o] : o;
    return e != null && l && l.length && r.applyPostProcessor !== !1 && (e = Ws.handle(l, e, t, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...s,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), e;
  }
  resolve(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, s, n, a, o;
    return L(e) && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(r)) return;
      const c = this.extractFromKey(l, t), h = c.key;
      s = h;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const u = t.count !== void 0 && !L(t.count), f = u && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), g = t.context !== void 0 && (L(t.context) || typeof t.context == "number") && t.context !== "", b = t.lngs ? t.lngs : this.languageUtils.toResolveHierarchy(t.lng || this.language, t.fallbackLng);
      d.forEach((v) => {
        this.isValidLookup(r) || (o = v, !Br[`${b[0]}-${v}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(o) && (Br[`${b[0]}-${v}`] = !0, this.logger.warn(`key "${s}" for languages "${b.join(", ")}" won't get resolved as namespace "${o}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), b.forEach((O) => {
          if (this.isValidLookup(r)) return;
          a = O;
          const C = [h];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(C, h, O, v, t);
          else {
            let N;
            u && (N = this.pluralResolver.getSuffix(O, t.count, t));
            const R = `${this.options.pluralSeparator}zero`, m = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (u && (C.push(h + N), t.ordinal && N.indexOf(m) === 0 && C.push(h + N.replace(m, this.options.pluralSeparator)), f && C.push(h + R)), g) {
              const S = `${h}${this.options.contextSeparator}${t.context}`;
              C.push(S), u && (C.push(S + N), t.ordinal && N.indexOf(m) === 0 && C.push(S + N.replace(m, this.options.pluralSeparator)), f && C.push(S + R));
            }
          }
          let E;
          for (; E = C.pop(); )
            this.isValidLookup(r) || (n = E, r = this.getResource(O, v, E, t));
        }));
      });
    }), {
      res: r,
      usedKey: s,
      exactUsedKey: n,
      usedLng: a,
      usedNS: o
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, r, s) : this.resourceStore.getResource(e, t, r, s);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = e.replace && !L(e.replace);
    let s = r ? e.replace : e;
    if (r && typeof e.count < "u" && (s.count = e.count), this.options.interpolation.defaultVariables && (s = {
      ...this.options.interpolation.defaultVariables,
      ...s
    }), !r) {
      s = {
        ...s
      };
      for (const n of t)
        delete s[n];
    }
    return s;
  }
  static hasDefaultValue(e) {
    const t = "defaultValue";
    for (const r in e)
      if (Object.prototype.hasOwnProperty.call(e, r) && t === r.substring(0, t.length) && e[r] !== void 0)
        return !0;
    return !1;
  }
}
const Ni = (i) => i.charAt(0).toUpperCase() + i.slice(1);
class Hr {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Te.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = di(e), !e || e.indexOf("-") < 0) return null;
    const t = e.split("-");
    return t.length === 2 || (t.pop(), t[t.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(t.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = di(e), !e || e.indexOf("-") < 0) return e;
    const t = e.split("-");
    return this.formatLanguageCode(t[0]);
  }
  formatLanguageCode(e) {
    if (L(e) && e.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let s = Intl.getCanonicalLocales(e)[0];
          if (s && this.options.lowerCaseLng && (s = s.toLowerCase()), s) return s;
        } catch {
        }
      const t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = e.split("-");
      return this.options.lowerCaseLng ? r = r.map((s) => s.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = Ni(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = Ni(r[1].toLowerCase())), t.indexOf(r[2].toLowerCase()) > -1 && (r[2] = Ni(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e) return null;
    let t;
    return e.forEach((r) => {
      if (t) return;
      const s = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(s)) && (t = s);
    }), !t && this.options.supportedLngs && e.forEach((r) => {
      if (t) return;
      const s = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(s)) return t = s;
      t = this.options.supportedLngs.find((n) => {
        if (n === s) return n;
        if (!(n.indexOf("-") < 0 && s.indexOf("-") < 0) && (n.indexOf("-") > 0 && s.indexOf("-") < 0 && n.substring(0, n.indexOf("-")) === s || n.indexOf(s) === 0 && s.length > 1))
          return n;
      });
    }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t;
  }
  getFallbackCodes(e, t) {
    if (!e) return [];
    if (typeof e == "function" && (e = e(t)), L(e) && (e = [e]), Array.isArray(e)) return e;
    if (!t) return e.default || [];
    let r = e[t];
    return r || (r = e[this.getScriptPartFromCode(t)]), r || (r = e[this.formatLanguageCode(t)]), r || (r = e[this.getLanguagePartFromCode(t)]), r || (r = e.default), r || [];
  }
  toResolveHierarchy(e, t) {
    const r = this.getFallbackCodes(t || this.options.fallbackLng || [], e), s = [], n = (a) => {
      a && (this.isSupportedCode(a) ? s.push(a) : this.logger.warn(`rejecting language code not found in supportedLngs: ${a}`));
    };
    return L(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && n(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && n(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && n(this.getLanguagePartFromCode(e))) : L(e) && n(this.formatLanguageCode(e)), r.forEach((a) => {
      s.indexOf(a) < 0 && n(this.formatLanguageCode(a));
    }), s;
  }
}
let Ba = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Ha = {
  1: (i) => +(i > 1),
  2: (i) => +(i != 1),
  3: (i) => 0,
  4: (i) => i % 10 == 1 && i % 100 != 11 ? 0 : i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 10 || i % 100 >= 20) ? 1 : 2,
  5: (i) => i == 0 ? 0 : i == 1 ? 1 : i == 2 ? 2 : i % 100 >= 3 && i % 100 <= 10 ? 3 : i % 100 >= 11 ? 4 : 5,
  6: (i) => i == 1 ? 0 : i >= 2 && i <= 4 ? 1 : 2,
  7: (i) => i == 1 ? 0 : i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 10 || i % 100 >= 20) ? 1 : 2,
  8: (i) => i == 1 ? 0 : i == 2 ? 1 : i != 8 && i != 11 ? 2 : 3,
  9: (i) => +(i >= 2),
  10: (i) => i == 1 ? 0 : i == 2 ? 1 : i < 7 ? 2 : i < 11 ? 3 : 4,
  11: (i) => i == 1 || i == 11 ? 0 : i == 2 || i == 12 ? 1 : i > 2 && i < 20 ? 2 : 3,
  12: (i) => +(i % 10 != 1 || i % 100 == 11),
  13: (i) => +(i !== 0),
  14: (i) => i == 1 ? 0 : i == 2 ? 1 : i == 3 ? 2 : 3,
  15: (i) => i % 10 == 1 && i % 100 != 11 ? 0 : i % 10 >= 2 && (i % 100 < 10 || i % 100 >= 20) ? 1 : 2,
  16: (i) => i % 10 == 1 && i % 100 != 11 ? 0 : i !== 0 ? 1 : 2,
  17: (i) => i == 1 || i % 10 == 1 && i % 100 != 11 ? 0 : 1,
  18: (i) => i == 0 ? 0 : i == 1 ? 1 : 2,
  19: (i) => i == 1 ? 0 : i == 0 || i % 100 > 1 && i % 100 < 11 ? 1 : i % 100 > 10 && i % 100 < 20 ? 2 : 3,
  20: (i) => i == 1 ? 0 : i == 0 || i % 100 > 0 && i % 100 < 20 ? 1 : 2,
  21: (i) => i % 100 == 1 ? 1 : i % 100 == 2 ? 2 : i % 100 == 3 || i % 100 == 4 ? 3 : 0,
  22: (i) => i == 1 ? 0 : i == 2 ? 1 : (i < 0 || i > 10) && i % 10 == 0 ? 2 : 3
};
const Wa = ["v1", "v2", "v3"], Va = ["v4"], Wr = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Ka = () => {
  const i = {};
  return Ba.forEach((e) => {
    e.lngs.forEach((t) => {
      i[t] = {
        numbers: e.nr,
        plurals: Ha[e.fc]
      };
    });
  }), i;
};
class Qa {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = t, this.logger = Te.create("pluralResolver"), (!this.options.compatibilityJSON || Va.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Ka(), this.pluralRulesCache = {};
  }
  addRule(e, t) {
    this.rules[e] = t;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const r = di(e === "dev" ? "en" : e), s = t.ordinal ? "ordinal" : "cardinal", n = JSON.stringify({
        cleanedCode: r,
        type: s
      });
      if (n in this.pluralRulesCache)
        return this.pluralRulesCache[n];
      let a;
      try {
        a = new Intl.PluralRules(r, {
          type: s
        });
      } catch {
        if (!e.match(/-|_/)) return;
        const l = this.languageUtils.getLanguagePartFromCode(e);
        a = this.getRule(l, t);
      }
      return this.pluralRulesCache[n] = a, a;
    }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(e, t);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, r).map((s) => `${t}${s}`);
  }
  getSuffixes(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(e, t);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((s, n) => Wr[s] - Wr[n]).map((s) => `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${s}`) : r.numbers.map((s) => this.getSuffix(e, s, t)) : [];
  }
  getSuffix(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const s = this.getRule(e, r);
    return s ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${s.select(t)}` : this.getSuffixRetroCompatible(s, t) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, t) {
    const r = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t));
    let s = e.numbers[r];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (s === 2 ? s = "plural" : s === 1 && (s = ""));
    const n = () => this.options.prepend && s.toString() ? this.options.prepend + s.toString() : s.toString();
    return this.options.compatibilityJSON === "v1" ? s === 1 ? "" : typeof s == "number" ? `_plural_${s.toString()}` : n() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? n() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !Wa.includes(this.options.compatibilityJSON);
  }
}
const Vr = function(i, e, t) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, n = Ta(i, e, t);
  return !n && s && L(t) && (n = Ai(i, t, r), n === void 0 && (n = Ai(e, t, r))), n;
}, _i = (i) => i.replace(/\$/g, "$$$$");
class qa {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Te.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((t) => t), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: t,
      escapeValue: r,
      useRawValueToEscape: s,
      prefix: n,
      prefixEscaped: a,
      suffix: o,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: h,
      unescapePrefix: d,
      nestingPrefix: u,
      nestingPrefixEscaped: f,
      nestingSuffix: g,
      nestingSuffixEscaped: b,
      nestingOptionsSeparator: v,
      maxReplaces: O,
      alwaysFormat: C
    } = e.interpolation;
    this.escape = t !== void 0 ? t : ka, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = s !== void 0 ? s : !1, this.prefix = n ? ut(n) : a || "{{", this.suffix = o ? ut(o) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = h ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : h || "", this.nestingPrefix = u ? ut(u) : f || ut("$t("), this.nestingSuffix = g ? ut(g) : b || ut(")"), this.nestingOptionsSeparator = v || ",", this.maxReplaces = O || 1e3, this.alwaysFormat = C !== void 0 ? C : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (t, r) => t && t.source === r ? (t.lastIndex = 0, t) : new RegExp(r, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, t, r, s) {
    let n, a, o;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (f) => {
      if (f.indexOf(this.formatSeparator) < 0) {
        const O = Vr(t, l, f, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(O, void 0, r, {
          ...s,
          ...t,
          interpolationkey: f
        }) : O;
      }
      const g = f.split(this.formatSeparator), b = g.shift().trim(), v = g.join(this.formatSeparator).trim();
      return this.format(Vr(t, l, b, this.options.keySeparator, this.options.ignoreJSONStructure), v, r, {
        ...s,
        ...t,
        interpolationkey: b
      });
    };
    this.resetRegExp();
    const h = s && s.missingInterpolationHandler || this.options.missingInterpolationHandler, d = s && s.interpolation && s.interpolation.skipOnVariables !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (f) => _i(f)
    }, {
      regex: this.regexp,
      safeValue: (f) => this.escapeValue ? _i(this.escape(f)) : _i(f)
    }].forEach((f) => {
      for (o = 0; n = f.regex.exec(e); ) {
        const g = n[1].trim();
        if (a = c(g), a === void 0)
          if (typeof h == "function") {
            const v = h(e, n, s);
            a = L(v) ? v : "";
          } else if (s && Object.prototype.hasOwnProperty.call(s, g))
            a = "";
          else if (d) {
            a = n[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${g} for interpolating ${e}`), a = "";
        else !L(a) && !this.useRawValueToEscape && (a = Ar(a));
        const b = f.safeValue(a);
        if (e = e.replace(n[0], b), d ? (f.regex.lastIndex += a.length, f.regex.lastIndex -= n[0].length) : f.regex.lastIndex = 0, o++, o >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s, n, a;
    const o = (l, c) => {
      const h = this.nestingOptionsSeparator;
      if (l.indexOf(h) < 0) return l;
      const d = l.split(new RegExp(`${h}[ ]*{`));
      let u = `{${d[1]}`;
      l = d[0], u = this.interpolate(u, a);
      const f = u.match(/'/g), g = u.match(/"/g);
      (f && f.length % 2 === 0 && !g || g.length % 2 !== 0) && (u = u.replace(/'/g, '"'));
      try {
        a = JSON.parse(u), c && (a = {
          ...c,
          ...a
        });
      } catch (b) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, b), `${l}${h}${u}`;
      }
      return a.defaultValue && a.defaultValue.indexOf(this.prefix) > -1 && delete a.defaultValue, l;
    };
    for (; s = this.nestingRegexp.exec(e); ) {
      let l = [];
      a = {
        ...r
      }, a = a.replace && !L(a.replace) ? a.replace : a, a.applyPostProcessor = !1, delete a.defaultValue;
      let c = !1;
      if (s[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(s[1])) {
        const h = s[1].split(this.formatSeparator).map((d) => d.trim());
        s[1] = h.shift(), l = h, c = !0;
      }
      if (n = t(o.call(this, s[1].trim(), a), a), n && s[0] === e && !L(n)) return n;
      L(n) || (n = Ar(n)), n || (this.logger.warn(`missed to resolve ${s[1]} for nesting ${e}`), n = ""), c && (n = l.reduce((h, d) => this.format(h, d, r.lng, {
        ...r,
        interpolationkey: s[1].trim()
      }), n.trim())), e = e.replace(s[0], n), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const Ya = (i) => {
  let e = i.toLowerCase().trim();
  const t = {};
  if (i.indexOf("(") > -1) {
    const r = i.split("(");
    e = r[0].toLowerCase().trim();
    const s = r[1].substring(0, r[1].length - 1);
    e === "currency" && s.indexOf(":") < 0 ? t.currency || (t.currency = s.trim()) : e === "relativetime" && s.indexOf(":") < 0 ? t.range || (t.range = s.trim()) : s.split(";").forEach((a) => {
      if (a) {
        const [o, ...l] = a.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), h = o.trim();
        t[h] || (t[h] = c), c === "false" && (t[h] = !1), c === "true" && (t[h] = !0), isNaN(c) || (t[h] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: t
  };
}, ht = (i) => {
  const e = {};
  return (t, r, s) => {
    let n = s;
    s && s.interpolationkey && s.formatParams && s.formatParams[s.interpolationkey] && s[s.interpolationkey] && (n = {
      ...n,
      [s.interpolationkey]: void 0
    });
    const a = r + JSON.stringify(n);
    let o = e[a];
    return o || (o = i(di(r), s), e[a] = o), o(t);
  };
};
class Xa {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Te.create("formatter"), this.options = e, this.formats = {
      number: ht((t, r) => {
        const s = new Intl.NumberFormat(t, {
          ...r
        });
        return (n) => s.format(n);
      }),
      currency: ht((t, r) => {
        const s = new Intl.NumberFormat(t, {
          ...r,
          style: "currency"
        });
        return (n) => s.format(n);
      }),
      datetime: ht((t, r) => {
        const s = new Intl.DateTimeFormat(t, {
          ...r
        });
        return (n) => s.format(n);
      }),
      relativetime: ht((t, r) => {
        const s = new Intl.RelativeTimeFormat(t, {
          ...r
        });
        return (n) => s.format(n, r.range || "day");
      }),
      list: ht((t, r) => {
        const s = new Intl.ListFormat(t, {
          ...r
        });
        return (n) => s.format(n);
      })
    }, this.init(e);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = t.interpolation.formatSeparator || ",";
  }
  add(e, t) {
    this.formats[e.toLowerCase().trim()] = t;
  }
  addCached(e, t) {
    this.formats[e.toLowerCase().trim()] = ht(t);
  }
  format(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const n = t.split(this.formatSeparator);
    if (n.length > 1 && n[0].indexOf("(") > 1 && n[0].indexOf(")") < 0 && n.find((o) => o.indexOf(")") > -1)) {
      const o = n.findIndex((l) => l.indexOf(")") > -1);
      n[0] = [n[0], ...n.splice(1, o)].join(this.formatSeparator);
    }
    return n.reduce((o, l) => {
      const {
        formatName: c,
        formatOptions: h
      } = Ya(l);
      if (this.formats[c]) {
        let d = o;
        try {
          const u = s && s.formatParams && s.formatParams[s.interpolationkey] || {}, f = u.locale || u.lng || s.locale || s.lng || r;
          d = this.formats[c](o, f, {
            ...h,
            ...s,
            ...u
          });
        } catch (u) {
          this.logger.warn(u);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return o;
    }, e);
  }
}
const Ga = (i, e) => {
  i.pending[e] !== void 0 && (delete i.pending[e], i.pendingCount--);
};
class Ja extends xi {
  constructor(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = t, this.services = r, this.languageUtils = r.languageUtils, this.options = s, this.logger = Te.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = s.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = s.maxRetries >= 0 ? s.maxRetries : 5, this.retryTimeout = s.retryTimeout >= 1 ? s.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, s.backend, s);
  }
  queueLoad(e, t, r, s) {
    const n = {}, a = {}, o = {}, l = {};
    return e.forEach((c) => {
      let h = !0;
      t.forEach((d) => {
        const u = `${c}|${d}`;
        !r.reload && this.store.hasResourceBundle(c, d) ? this.state[u] = 2 : this.state[u] < 0 || (this.state[u] === 1 ? a[u] === void 0 && (a[u] = !0) : (this.state[u] = 1, h = !1, a[u] === void 0 && (a[u] = !0), n[u] === void 0 && (n[u] = !0), l[d] === void 0 && (l[d] = !0)));
      }), h || (o[c] = !0);
    }), (Object.keys(n).length || Object.keys(a).length) && this.queue.push({
      pending: a,
      pendingCount: Object.keys(a).length,
      loaded: {},
      errors: [],
      callback: s
    }), {
      toLoad: Object.keys(n),
      pending: Object.keys(a),
      toLoadLanguages: Object.keys(o),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, t, r) {
    const s = e.split("|"), n = s[0], a = s[1];
    t && this.emit("failedLoading", n, a, t), !t && r && this.store.addResourceBundle(n, a, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = t ? -1 : 2, t && r && (this.state[e] = 0);
    const o = {};
    this.queue.forEach((l) => {
      Ma(l.loaded, [n], a), Ga(l, e), t && l.errors.push(t), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        o[c] || (o[c] = {});
        const h = l.loaded[c];
        h.length && h.forEach((d) => {
          o[c][d] === void 0 && (o[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", o), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, a = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length) return a(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: t,
        fcName: r,
        tried: s,
        wait: n,
        callback: a
      });
      return;
    }
    this.readingCalls++;
    const o = (c, h) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && h && s < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, t, r, s + 1, n * 2, a);
        }, n);
        return;
      }
      a(c, h);
    }, l = this.backend[r].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(e, t);
        c && typeof c.then == "function" ? c.then((h) => o(null, h)).catch(o) : o(null, c);
      } catch (c) {
        o(c);
      }
      return;
    }
    return l(e, t, o);
  }
  prepareLoading(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
    L(e) && (e = this.languageUtils.toResolveHierarchy(e)), L(t) && (t = [t]);
    const n = this.queueLoad(e, t, r, s);
    if (!n.toLoad.length)
      return n.pending.length || s(), null;
    n.toLoad.forEach((a) => {
      this.loadOne(a);
    });
  }
  load(e, t, r) {
    this.prepareLoading(e, t, {}, r);
  }
  reload(e, t, r) {
    this.prepareLoading(e, t, {
      reload: !0
    }, r);
  }
  loadOne(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = e.split("|"), s = r[0], n = r[1];
    this.read(s, n, "read", void 0, void 0, (a, o) => {
      a && this.logger.warn(`${t}loading namespace ${n} for language ${s} failed`, a), !a && o && this.logger.log(`${t}loaded namespace ${n} for language ${s}`, o), this.loaded(e, a, o);
    });
  }
  saveMissing(e, t, r, s, n) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${t}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...a,
          isUpdate: n
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let h;
            c.length === 5 ? h = c(e, t, r, s, l) : h = c(e, t, r, s), h && typeof h.then == "function" ? h.then((d) => o(null, d)).catch(o) : o(null, h);
          } catch (h) {
            o(h);
          }
        else
          c(e, t, r, s, o, l);
      }
      !e || !e[0] || this.store.addResource(e[0], t, r, s);
    }
  }
}
const Kr = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (i) => {
    let e = {};
    if (typeof i[1] == "object" && (e = i[1]), L(i[1]) && (e.defaultValue = i[1]), L(i[2]) && (e.tDescription = i[2]), typeof i[2] == "object" || typeof i[3] == "object") {
      const t = i[3] || i[2];
      Object.keys(t).forEach((r) => {
        e[r] = t[r];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (i) => i,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Qr = (i) => (L(i.ns) && (i.ns = [i.ns]), L(i.fallbackLng) && (i.fallbackLng = [i.fallbackLng]), L(i.fallbackNS) && (i.fallbackNS = [i.fallbackNS]), i.supportedLngs && i.supportedLngs.indexOf("cimode") < 0 && (i.supportedLngs = i.supportedLngs.concat(["cimode"])), i), ai = () => {
}, Za = (i) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(i)).forEach((t) => {
    typeof i[t] == "function" && (i[t] = i[t].bind(i));
  });
};
class Vt extends xi {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Qr(e), this.services = {}, this.logger = Te, this.modules = {
      external: []
    }, Za(this), t && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, t), this;
      setTimeout(() => {
        this.init(e, t);
      }, 0);
    }
  }
  init() {
    var e = this;
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof t == "function" && (r = t, t = {}), !t.defaultNS && t.defaultNS !== !1 && t.ns && (L(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const s = Kr();
    this.options = {
      ...s,
      ...this.options,
      ...Qr(t)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...s.interpolation,
      ...this.options.interpolation
    }), t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const n = (h) => h ? typeof h == "function" ? new h() : h : null;
    if (!this.options.isClone) {
      this.modules.logger ? Te.init(n(this.modules.logger), this.options) : Te.init(null, this.options);
      let h;
      this.modules.formatter ? h = this.modules.formatter : typeof Intl < "u" && (h = Xa);
      const d = new Hr(this.options);
      this.store = new $r(this.options.resources, this.options);
      const u = this.services;
      u.logger = Te, u.resourceStore = this.store, u.languageUtils = d, u.pluralResolver = new Qa(d, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), h && (!this.options.interpolation.format || this.options.interpolation.format === s.interpolation.format) && (u.formatter = n(h), u.formatter.init(u, this.options), this.options.interpolation.format = u.formatter.format.bind(u.formatter)), u.interpolator = new qa(this.options), u.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, u.backendConnector = new Ja(n(this.modules.backend), u.resourceStore, u, this.options), u.backendConnector.on("*", function(f) {
        for (var g = arguments.length, b = new Array(g > 1 ? g - 1 : 0), v = 1; v < g; v++)
          b[v - 1] = arguments[v];
        e.emit(f, ...b);
      }), this.modules.languageDetector && (u.languageDetector = n(this.modules.languageDetector), u.languageDetector.init && u.languageDetector.init(u, this.options.detection, this.options)), this.modules.i18nFormat && (u.i18nFormat = n(this.modules.i18nFormat), u.i18nFormat.init && u.i18nFormat.init(this)), this.translator = new pi(this.services, this.options), this.translator.on("*", function(f) {
        for (var g = arguments.length, b = new Array(g > 1 ? g - 1 : 0), v = 1; v < g; v++)
          b[v - 1] = arguments[v];
        e.emit(f, ...b);
      }), this.modules.external.forEach((f) => {
        f.init && f.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = ai), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const h = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      h.length > 0 && h[0] !== "dev" && (this.options.lng = h[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((h) => {
      this[h] = function() {
        return e.store[h](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((h) => {
      this[h] = function() {
        return e.store[h](...arguments), e;
      };
    });
    const l = At(), c = () => {
      const h = (d, u) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(u), r(d, u);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return h(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, h);
    };
    return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), l;
  }
  loadResources(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ai;
    const s = L(e) ? e : this.language;
    if (typeof e == "function" && (r = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (s && s.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return r();
      const n = [], a = (o) => {
        if (!o || o === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(o).forEach((c) => {
          c !== "cimode" && n.indexOf(c) < 0 && n.push(c);
        });
      };
      s ? a(s) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => a(l)), this.options.preload && this.options.preload.forEach((o) => a(o)), this.services.backendConnector.load(n, this.options.ns, (o) => {
        !o && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(o);
      });
    } else
      r(null);
  }
  reloadResources(e, t, r) {
    const s = At();
    return typeof e == "function" && (r = e, e = void 0), typeof t == "function" && (r = t, t = void 0), e || (e = this.languages), t || (t = this.options.ns), r || (r = ai), this.services.backendConnector.reload(e, t, (n) => {
      s.resolve(), r(n);
    }), s;
  }
  use(e) {
    if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && Ws.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let t = 0; t < this.languages.length; t++) {
        const r = this.languages[t];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(e, t) {
    var r = this;
    this.isLanguageChangingTo = e;
    const s = At();
    this.emit("languageChanging", e);
    const n = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, a = (l, c) => {
      c ? (n(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, s.resolve(function() {
        return r.t(...arguments);
      }), t && t(l, function() {
        return r.t(...arguments);
      });
    }, o = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const c = L(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || n(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (h) => {
        a(h, c);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? o(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(o) : this.services.languageDetector.detect(o) : o(e), s;
  }
  getFixedT(e, t, r) {
    var s = this;
    const n = function(a, o) {
      let l;
      if (typeof o != "object") {
        for (var c = arguments.length, h = new Array(c > 2 ? c - 2 : 0), d = 2; d < c; d++)
          h[d - 2] = arguments[d];
        l = s.options.overloadTranslationOptionHandler([a, o].concat(h));
      } else
        l = {
          ...o
        };
      l.lng = l.lng || n.lng, l.lngs = l.lngs || n.lngs, l.ns = l.ns || n.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || r || n.keyPrefix);
      const u = s.options.keySeparator || ".";
      let f;
      return l.keyPrefix && Array.isArray(a) ? f = a.map((g) => `${l.keyPrefix}${u}${g}`) : f = l.keyPrefix ? `${l.keyPrefix}${u}${a}` : a, s.t(f, l);
    };
    return L(e) ? n.lng = e : n.lngs = e, n.ns = t, n.keyPrefix = r, n;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = t.lng || this.resolvedLanguage || this.languages[0], s = this.options ? this.options.fallbackLng : !1, n = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode") return !0;
    const a = (o, l) => {
      const c = this.services.backendConnector.state[`${o}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (t.precheck) {
      const o = t.precheck(this, a);
      if (o !== void 0) return o;
    }
    return !!(this.hasResourceBundle(r, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || a(r, e) && (!s || a(n, e)));
  }
  loadNamespaces(e, t) {
    const r = At();
    return this.options.ns ? (L(e) && (e = [e]), e.forEach((s) => {
      this.options.ns.indexOf(s) < 0 && this.options.ns.push(s);
    }), this.loadResources((s) => {
      r.resolve(), t && t(s);
    }), r) : (t && t(), Promise.resolve());
  }
  loadLanguages(e, t) {
    const r = At();
    L(e) && (e = [e]);
    const s = this.options.preload || [], n = e.filter((a) => s.indexOf(a) < 0 && this.services.languageUtils.isSupportedCode(a));
    return n.length ? (this.options.preload = s.concat(n), this.loadResources((a) => {
      r.resolve(), t && t(a);
    }), r) : (t && t(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e) return "rtl";
    const t = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new Hr(Kr());
    return t.indexOf(r.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    return new Vt(e, t);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ai;
    const r = e.forkResourceStore;
    r && delete e.forkResourceStore;
    const s = {
      ...this.options,
      ...e,
      isClone: !0
    }, n = new Vt(s);
    return (e.debug !== void 0 || e.prefix !== void 0) && (n.logger = n.logger.clone(e)), ["store", "services", "language"].forEach((o) => {
      n[o] = this[o];
    }), n.services = {
      ...this.services
    }, n.services.utils = {
      hasLoadedNamespace: n.hasLoadedNamespace.bind(n)
    }, r && (n.store = new $r(this.store.data, s), n.services.resourceStore = n.store), n.translator = new pi(n.services, s), n.translator.on("*", function(o) {
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), h = 1; h < l; h++)
        c[h - 1] = arguments[h];
      n.emit(o, ...c);
    }), n.init(s, t), n.translator.options = s, n.translator.backendConnector.services.utils = {
      hasLoadedNamespace: n.hasLoadedNamespace.bind(n)
    }, n;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const re = Vt.createInstance();
re.createInstance = Vt.createInstance;
re.createInstance;
re.dir;
re.init;
re.loadResources;
re.reloadResources;
re.use;
re.changeLanguage;
re.getFixedT;
const eo = re.t;
re.exists;
re.setDefaultNamespace;
re.hasLoadedNamespace;
re.loadNamespaces;
re.loadLanguages;
function Kt(i) {
  "@babel/helpers - typeof";
  return Kt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Kt(i);
}
function to(i, e) {
  if (Kt(i) != "object" || !i) return i;
  var t = i[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(i, e);
    if (Kt(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(i);
}
function Vs(i) {
  var e = to(i, "string");
  return Kt(e) == "symbol" ? e : e + "";
}
function Ks(i, e, t) {
  return (e = Vs(e)) in i ? Object.defineProperty(i, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[e] = t, i;
}
function io(i, e) {
  if (!(i instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function ro(i, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(i, Vs(r.key), r);
  }
}
function so(i, e, t) {
  return e && ro(i.prototype, e), Object.defineProperty(i, "prototype", {
    writable: !1
  }), i;
}
var no = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, ao = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, oo = function(e) {
  return ao[e];
}, lo = function(e) {
  return e.replace(no, oo);
};
function qr(i, e) {
  var t = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(i);
    e && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(i, s).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Yr(i) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? qr(Object(t), !0).forEach(function(r) {
      Ks(i, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t)) : qr(Object(t)).forEach(function(r) {
      Object.defineProperty(i, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return i;
}
var ji = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: lo
}, Qs, co = $s();
function uo() {
  var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  ji = Yr(Yr({}, ji), i);
}
function ho() {
  return ji;
}
var fo = (function() {
  function i() {
    io(this, i), this.usedNamespaces = {};
  }
  return so(i, [{
    key: "addUsedNamespaces",
    value: function(t) {
      var r = this;
      t.forEach(function(s) {
        r.usedNamespaces[s] || (r.usedNamespaces[s] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), i;
})();
function po(i) {
  Qs = i;
}
function go() {
  return Qs;
}
var mo = {
  type: "3rdParty",
  init: function(e) {
    uo(e.options.react), po(e);
  }
};
function vo() {
  if (console && console.warn) {
    for (var i, e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    typeof t[0] == "string" && (t[0] = "react-i18next:: ".concat(t[0])), (i = console).warn.apply(i, t);
  }
}
var Xr = {};
function zi() {
  for (var i = arguments.length, e = new Array(i), t = 0; t < i; t++)
    e[t] = arguments[t];
  typeof e[0] == "string" && Xr[e[0]] || (typeof e[0] == "string" && (Xr[e[0]] = /* @__PURE__ */ new Date()), vo.apply(void 0, e));
}
function Gr(i, e, t) {
  i.loadNamespaces(e, function() {
    if (i.isInitialized)
      t();
    else {
      var r = function s() {
        setTimeout(function() {
          i.off("initialized", s);
        }, 0), t();
      };
      i.on("initialized", r);
    }
  });
}
function yo(i, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = e.languages[0], s = e.options ? e.options.fallbackLng : !1, n = e.languages[e.languages.length - 1];
  if (r.toLowerCase() === "cimode") return !0;
  var a = function(l, c) {
    var h = e.services.backendConnector.state["".concat(l, "|").concat(c)];
    return h === -1 || h === 2;
  };
  return t.bindI18n && t.bindI18n.indexOf("languageChanging") > -1 && e.services.backendConnector.backend && e.isLanguageChangingTo && !a(e.isLanguageChangingTo, i) ? !1 : !!(e.hasResourceBundle(r, i) || !e.services.backendConnector.backend || e.options.resources && !e.options.partialBundledLanguages || a(r, i) && (!s || a(n, i)));
}
function bo(i, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!e.languages || !e.languages.length)
    return zi("i18n.languages were undefined or empty", e.languages), !0;
  var r = e.options.ignoreJSONStructure !== void 0;
  return r ? e.hasLoadedNamespace(i, {
    precheck: function(n, a) {
      if (t.bindI18n && t.bindI18n.indexOf("languageChanging") > -1 && n.services.backendConnector.backend && n.isLanguageChangingTo && !a(n.isLanguageChangingTo, i)) return !1;
    }
  }) : yo(i, e, t);
}
function wo(i) {
  if (Array.isArray(i)) return i;
}
function xo(i, e) {
  var t = i == null ? null : typeof Symbol < "u" && i[Symbol.iterator] || i["@@iterator"];
  if (t != null) {
    var r, s, n, a, o = [], l = !0, c = !1;
    try {
      if (n = (t = t.call(i)).next, e !== 0) for (; !(l = (r = n.call(t)).done) && (o.push(r.value), o.length !== e); l = !0) ;
    } catch (h) {
      c = !0, s = h;
    } finally {
      try {
        if (!l && t.return != null && (a = t.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw s;
      }
    }
    return o;
  }
}
function Jr(i, e) {
  (e == null || e > i.length) && (e = i.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = i[t];
  return r;
}
function Co(i, e) {
  if (i) {
    if (typeof i == "string") return Jr(i, e);
    var t = {}.toString.call(i).slice(8, -1);
    return t === "Object" && i.constructor && (t = i.constructor.name), t === "Map" || t === "Set" ? Array.from(i) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? Jr(i, e) : void 0;
  }
}
function So() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Oo(i, e) {
  return wo(i) || xo(i, e) || Co(i, e) || So();
}
function Zr(i, e) {
  var t = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(i);
    e && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(i, s).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Ri(i) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Zr(Object(t), !0).forEach(function(r) {
      Ks(i, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t)) : Zr(Object(t)).forEach(function(r) {
      Object.defineProperty(i, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return i;
}
var Eo = function(e, t) {
  var r = be();
  return Ee(function() {
    r.current = e;
  }, [e, t]), r.current;
};
function No(i) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = e.i18n, r = aa(co) || {}, s = r.i18n, n = r.defaultNS, a = t || s || go();
  if (a && !a.reportNamespaces && (a.reportNamespaces = new fo()), !a) {
    zi("You will need to pass in an i18next instance by using initReactI18next");
    var o = function(x) {
      return Array.isArray(x) ? x[x.length - 1] : x;
    }, l = [o, {}, !1];
    return l.t = o, l.i18n = {}, l.ready = !1, l;
  }
  a.options.react && a.options.react.wait !== void 0 && zi("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var c = Ri(Ri(Ri({}, ho()), a.options.react), e), h = c.useSuspense, d = c.keyPrefix, u = i || n || a.options && a.options.defaultNS;
  u = typeof u == "string" ? [u] : u || ["translation"], a.reportNamespaces.addUsedNamespaces && a.reportNamespaces.addUsedNamespaces(u);
  var f = (a.isInitialized || a.initializedStoreOnce) && u.every(function(w) {
    return bo(w, a, c);
  });
  function g() {
    return a.getFixedT(null, c.nsMode === "fallback" ? u : u[0], d);
  }
  var b = W(g), v = Oo(b, 2), O = v[0], C = v[1], E = u.join(), N = Eo(E), R = be(!0);
  Ee(function() {
    var w = c.bindI18n, x = c.bindI18nStore;
    R.current = !0, !f && !h && Gr(a, u, function() {
      R.current && C(g);
    }), f && N && N !== E && R.current && C(g);
    function _() {
      R.current && C(g);
    }
    return w && a && a.on(w, _), x && a && a.store.on(x, _), function() {
      R.current = !1, w && a && w.split(" ").forEach(function(F) {
        return a.off(F, _);
      }), x && a && x.split(" ").forEach(function(F) {
        return a.store.off(F, _);
      });
    };
  }, [a, E]);
  var m = be(!0);
  Ee(function() {
    R.current && !m.current && C(g), m.current = !1;
  }, [a, d]);
  var S = [O, a, f];
  if (S.t = O, S.i18n = a, S.ready = f, f || !f && !h) return S;
  throw new Promise(function(w) {
    Gr(a, u, function() {
      w();
    });
  });
}
const qs = { title: "File Manager", file_upload: { file_not_supported: "File type not supported", drop_files_here: "Drag and drop your files here, or click to browse", upload_files: "Upload files", uploaded_successfully: "Successfully uploaded", crop_file: "Crop image ", crop_and_select_file: "Crop and select an image", upload_and_select_file: "Upload and select" }, cancelled: "Cancelled", error: "Error", something_went_wrong: "Something went wrong", confirm_action: "Confirm action", confirm: "Confirm", cancel: "Cancel", file_details: "File details", download: "Download", rename: "Rename", delete: "Delete", name: "Name", size: "Size", file_source: { editor: "Editor", community: "Community", block_preview: "Block preview", membership: "Membership", marketplace: "Marketplace", settings: "Settings", email: "Email", ckeditor: "CKEditor", blog_post: "Blog post", page_template: "Page template", page_template_preview: "Page template preview", blog_template_preview: "Blog template preview", email_template: "Email template", product: "Product", funnel_template_preview: "Funnel template preview", digital_store: "Digital store", digital_product_resource: "Digital product resource", file_manager: "File manager", calendar_host_avatar: "Calendar", text_editor: "Text editor", website_template: "Website template", white_label: "White Label" }, file_type: { image: "Image", image_other: "Other image", video: "Video", audio: "Audio", font: "Font", document: "Document" }, select: "Select", file_selector: { files_selected: "file selected", search_file: "Search file", rename_file: "Rename file", file_name: "File name", enter_new_file_name: "Enter a new file name", failed_rename_file: "Failed to rename file", failed_delete_file: "Failed to delete file", failed_download_file: "Failed to download file", file_deletion_confirmation_text: 'Are you sure you want to delete "{{file}}"?', choose_file: "Choose a file" }, search: "Search", upload: "Upload", file: "File", select_type: "Select file type", select_source: "Select source", type: "Type", created_at: "Created at", processing_size: "Processing", preview: "Preview", image_cropper: { aspect_ratio: { need_to_crop: "Crop image before selecting", need_to_crop_note: "The image has a different aspect ratio. Please crop it to match the required one" } }, errors: { payload_to_large_error_message: "The file size is too big", conflict_error_message: "Sorry, but someone else has already changed this entity. Please reload the page and try again!", fields_toast_message: "Some fields contain invalid data, scroll down to resolve the issue", internal_error_message: "Something went wrong. Please try again" }, file_renamed_successfully: "Renamed successfully", file_deleted_successfully: "Deleted successfully" }, Ys = {
  file_manager: qs
}, _o = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ys,
  file_manager: qs
}, Symbol.toStringTag, { value: "Module" })), Ci = ["common"], gr = Ci[0], Ro = Object.values(ki), Do = {
  en: { common: Ys }
}, Po = {
  supportedLngs: Ro,
  load: "languageOnly",
  debug: !1,
  defaultNS: gr,
  react: { useSuspense: !1 },
  ns: Ci,
  fallbackLng: ki.ENGLISH,
  lng: ki.ENGLISH,
  interpolation: {
    escapeValue: !1
  },
  resources: Do,
  returnEmptyString: !1
};
re.use(mo).init(Po);
const Fo = async (i) => {
  const e = await Pa(/* @__PURE__ */ Object.assign({ "./assets/translations/locales/ar/common.json": () => import("./common-DMCV0GGi.mjs"), "./assets/translations/locales/bn/common.json": () => import("./common-BM-3M8Dx.mjs"), "./assets/translations/locales/cs/common.json": () => import("./common-DZRWiEBT.mjs"), "./assets/translations/locales/da/common.json": () => import("./common-B5o4HVal.mjs"), "./assets/translations/locales/de/common.json": () => import("./common-CuzJRdg3.mjs"), "./assets/translations/locales/el/common.json": () => import("./common-BjwpuYro.mjs"), "./assets/translations/locales/en/common.json": () => Promise.resolve().then(() => _o), "./assets/translations/locales/es/common.json": () => import("./common-B_szy-FP.mjs"), "./assets/translations/locales/fi/common.json": () => import("./common-C4LoSUJq.mjs"), "./assets/translations/locales/fr/common.json": () => import("./common-CYTvzuJ6.mjs"), "./assets/translations/locales/he/common.json": () => import("./common-CmMEn3dp.mjs"), "./assets/translations/locales/hi/common.json": () => import("./common-BC9jBzrv.mjs"), "./assets/translations/locales/hu/common.json": () => import("./common-WLsuBVdv.mjs"), "./assets/translations/locales/id/common.json": () => import("./common-CsMC8nWS.mjs"), "./assets/translations/locales/it/common.json": () => import("./common-ga7QJLpV.mjs"), "./assets/translations/locales/ja/common.json": () => import("./common-OcEuF_Po.mjs"), "./assets/translations/locales/ms/common.json": () => import("./common-BWiHUpD2.mjs"), "./assets/translations/locales/nl/common.json": () => import("./common-DdC94BqO.mjs"), "./assets/translations/locales/no/common.json": () => import("./common-DAhW0tn5.mjs"), "./assets/translations/locales/pl/common.json": () => import("./common-DPWUnqdR.mjs"), "./assets/translations/locales/pt/common.json": () => import("./common-CNGRVbtk.mjs"), "./assets/translations/locales/ro/common.json": () => import("./common-DMnHVhgK.mjs"), "./assets/translations/locales/ru/common.json": () => import("./common-BDPRVMtQ.mjs"), "./assets/translations/locales/sk/common.json": () => import("./common-DXN70-fE.mjs"), "./assets/translations/locales/sl/common.json": () => import("./common-Bfz7QYTV.mjs"), "./assets/translations/locales/sq/common.json": () => import("./common-BYN6oIio.mjs"), "./assets/translations/locales/sr/common.json": () => import("./common-olVGXe6V.mjs"), "./assets/translations/locales/sv/common.json": () => import("./common-Cc7H2ooY.mjs"), "./assets/translations/locales/th/common.json": () => import("./common-DjabKxhc.mjs"), "./assets/translations/locales/tl/common.json": () => import("./common-Bu0NYLN8.mjs"), "./assets/translations/locales/tr/common.json": () => import("./common-Do1M5XIB.mjs"), "./assets/translations/locales/uk/common.json": () => import("./common-Bdag_9uX.mjs"), "./assets/translations/locales/zh/common.json": () => import("./common-Cl6I1s17.mjs") }), `./assets/translations/locales/${i}/common.json`, 6);
  return re.addResourceBundle(i, gr, {
    file_manager: e.default.file_manager
  }), e;
}, Xs = () => Ci, Gs = (i) => i.startsWith("core.error.") ? i.replace("core.error.", "file_manager.errors.") : i.replace(/^(global\.|core\.)/g, "file_manager."), Js = ma(eo, Xs, Gs), fe = va({
  useTranslation: No,
  defaultNamespaces: Ci,
  namespaceMapper: Xs,
  assetKeyMapper: Gs
}), mr = ya(), vt = ba({
  httpClient: mr,
  useLocoTranslation: fe,
  useRouter: () => ({
    push: async (i) => (window.location.assign(i), !0),
    replace: async (i) => (window.location.replace(i), !0)
  })
});
function Io(i, e = 2, t) {
  if (i < 0) return (t == null ? void 0 : t.whenNegative) ?? Js("file_manager.processing_size");
  if (i === 0) return "0 Bytes";
  const r = 1024, s = e < 0 ? 0 : e, n = ["Bytes", "KB", "MB", "GB"], a = Math.floor(Math.log(i) / Math.log(r));
  return parseFloat((i / Math.pow(r, a)).toFixed(s)) + " " + n[a];
}
const Mo = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg", "tiff", "ico", "avif"];
function Ui(i) {
  var t;
  const e = (t = i.name.split(".").pop()) == null ? void 0 : t.toLowerCase();
  return i.type.startsWith("image/") || Mo.includes(e ?? "-");
}
async function Zs(i) {
  return new Promise((e, t) => {
    const r = new Image();
    r.src = i, r.crossOrigin = "Anonymous", r.onload = () => {
      const s = r.width / r.height;
      e([r, s]);
    }, r.onerror = (s) => {
      t(new Error("Failed to load image"));
    };
  });
}
function en(i, e, t = 0.02) {
  return Math.abs(i - e) < t;
}
function tn(i, e = 0.02) {
  const r = [
    { label: "(1:1)", value: 1 },
    { label: "(16:9)", value: 1.7777777777777777 },
    { label: "(21:9)", value: 2.3333333333333335 },
    { label: "(4:3)", value: 1.3333333333333333 },
    { label: "(1.43:1)", value: 1.43 },
    { label: "(32:9)", value: 3.5555555555555554 },
    { label: "(1.41:1)", value: 1.41 },
    { label: "(9:16)", value: 0.5625 },
    { label: "(19.5:9)", value: 2.1666666666666665 },
    { label: "(12:7)", value: 1.7142857142857142 }
  ].find((s) => Math.abs(i - s.value) < e);
  return r == null ? void 0 : r.label;
}
function To(i, e = 0.02) {
  const t = tn(i, e);
  let r = Js("file_manager.image_cropper.aspect_ratio.need_to_crop");
  return t && (r += ` ${t}`), r;
}
function es(i, e) {
  if (!e || isNaN(e))
    return i;
  const t = tn(e);
  if (!t)
    return i;
  const r = t.replace(/[\s:]+/g, "_"), s = i.name.split(".").pop(), a = `${i.name.replace(/\.[^.]+$/, "")}_${r}.${s}`;
  return new File([i], a, {
    type: i.type,
    lastModified: i.lastModified
  });
}
function Lo(i, e) {
  return {
    id: i.id,
    name: i.filename,
    filename: i.filename,
    path: i.path,
    thumbnail: i.thumbnail || null,
    source: e,
    size: i.size,
    type: i.type,
    createdAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
async function ko(i, e, t = "image/png") {
  const r = new OffscreenCanvas(i.width, i.height), s = r.getContext("2d");
  if (!s) throw new Error("Canvas context is not available");
  s.drawImage(i, 0, 0);
  const n = await r.convertToBlob({ type: t });
  return new File([n], e, { type: t });
}
function ts(i, e) {
  const t = be(null);
  Ee(() => {
    t.current !== null && e(t.current, i), t.current = i;
  }, [i]);
}
function is(i, e) {
  return {
    added: e.filter((t) => !i.includes(t)),
    removed: i.filter((t) => !e.includes(t))
  };
}
async function Ao(i) {
  const e = await i.arrayBuffer(), t = await crypto.subtle.digest("SHA-256", e);
  return Array.from(new Uint8Array(t)).map((n) => n.toString(16).padStart(2, "0")).join("");
}
function rs(i, e) {
  const s = `${i.name.replace(/\.[^.]+$/, "")}.png`;
  return new File([e], s, {
    type: "image/png",
    lastModified: i.lastModified
  });
}
const uu = {
  image: ["image/*"],
  csv: ["text/csv", "application/vnd.ms-excel", "application/csv", ".csv"]
}, ss = (i, e) => e.some((t) => {
  if (t.includes("*")) {
    const r = t.replace("*", ".*");
    return new RegExp(`^${r}$`).test(i);
  } else
    return i.toLowerCase() === t.toLowerCase();
}), jo = (i) => i.join(", ");
function hu(i) {
  var l;
  const e = (l = i.split(".").pop()) == null ? void 0 : l.toLowerCase();
  if (!e) return Y.Document;
  const t = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"], r = ["tiff", "heic", "raw"], s = ["mp4", "mov", "avi", "mkv", "webm"], n = ["mp3", "wav", "ogg", "aac", "flac"], a = ["ttf", "otf", "woff", "woff2"], o = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "csv"];
  return t.includes(e) ? Y.Image : r.includes(e) ? Y.ImageOther : s.includes(e) ? Y.Video : n.includes(e) ? Y.Audio : a.includes(e) ? Y.Font : (o.includes(e), Y.Document);
}
function zo({
  fileType: i,
  src: e,
  alt: t,
  name: r,
  size: s,
  className: n,
  onClose: a,
  showCloseButton: o = !0,
  isFetching: l
}) {
  const { t: c } = fe();
  return l ? /* @__PURE__ */ A("div", { className: ie("flex w-full flex-col items-end", n), children: [
    o && /* @__PURE__ */ y("button", { type: "button", onClick: a, className: "mb-5", children: /* @__PURE__ */ y(Tr, { width: 17, height: 17, className: "fill-text-primary cursor-pointer" }) }),
    /* @__PURE__ */ A("div", { className: "flex w-full flex-col", children: [
      /* @__PURE__ */ y("div", { className: "bg-background-tertiary h-[300px] w-full animate-pulse rounded-md" }),
      /* @__PURE__ */ y("div", { className: "bg-background-tertiary mt-5 h-4 w-16 animate-pulse rounded-sm" }),
      /* @__PURE__ */ y("div", { className: "bg-background-tertiary mt-2 h-6 w-full animate-pulse rounded-sm" }),
      /* @__PURE__ */ y("div", { className: "bg-background-tertiary mt-2 h-4 w-16 animate-pulse rounded-sm" }),
      /* @__PURE__ */ y("div", { className: "bg-background-tertiary mt-2 h-6 w-full animate-pulse rounded-sm" })
    ] })
  ] }) : /* @__PURE__ */ A("div", { className: ie("flex w-full flex-col items-end", n), children: [
    o && /* @__PURE__ */ y("button", { type: "button", onClick: a, className: "mb-5", children: /* @__PURE__ */ y(Tr, { width: 17, height: 17, className: "fill-text-primary cursor-pointer" }) }),
    /* @__PURE__ */ A("div", { className: "flex w-full flex-col", children: [
      /* @__PURE__ */ y(ot, { src: e ?? "", fileType: i, alt: t }),
      r && /* @__PURE__ */ A(Li, { children: [
        /* @__PURE__ */ y(
          "div",
          {
            className: "text-text-secondary mt-5 overflow-clip truncate text-sm",
            style: { lineHeight: 1.1 },
            children: c("file_manager.name")
          }
        ),
        /* @__PURE__ */ y(
          "div",
          {
            className: "text-text-tertiary mt-2 truncate text-base font-semibold ",
            title: r,
            style: { lineHeight: 1.1 },
            children: r
          }
        )
      ] }),
      typeof s == "number" && /* @__PURE__ */ A(Li, { children: [
        /* @__PURE__ */ y(
          "div",
          {
            className: "text-text-secondary mt-[10px] overflow-clip truncate text-sm",
            style: { lineHeight: 1.1 },
            children: c("file_manager.size")
          }
        ),
        /* @__PURE__ */ y(
          "div",
          {
            className: "text-text-tertiary mt-2 text-base font-semibold",
            style: { lineHeight: 1.1 },
            children: Io(s)
          }
        )
      ] })
    ] })
  ] });
}
const rn = Oe.memo(({ file: i, className: e }) => i.type.startsWith("image/") ? /* @__PURE__ */ y(
  ot,
  {
    src: URL.createObjectURL(i),
    fileType: Y.Image,
    alt: i.name,
    className: e,
    isThumbnail: !0,
    title: i.name
  }
) : i.type === "application/pdf" ? /* @__PURE__ */ y(
  "div",
  {
    className: ie(
      "pointer-events-none flex select-none items-center justify-center overflow-hidden rounded-md",
      e
    ),
    title: i.name,
    children: /* @__PURE__ */ y(
      "embed",
      {
        src: URL.createObjectURL(i),
        type: i.type,
        className: "h-full w-full",
        style: { border: "none" }
      }
    )
  }
) : i.type.startsWith("video/") ? /* @__PURE__ */ y(
  ot,
  {
    src: URL.createObjectURL(i),
    fileType: Y.Video,
    alt: i.name,
    className: e,
    isThumbnail: !0,
    title: i.name
  }
) : /* @__PURE__ */ y(
  ot,
  {
    src: "",
    fileType: Y.Document,
    className: e,
    isThumbnail: !0,
    title: i.name
  }
));
rn.displayName = "FilePreviewFromOS";
function ns({
  opened: i,
  onClose: e,
  onConfirm: t,
  onDecline: r,
  title: s,
  confirmationText: n = "",
  className: a,
  cancelButtonCaption: o,
  confirmButtonCaption: l,
  buttonClassName: c,
  buttonTextClassName: h,
  confirmationContent: d,
  afterLeave: u
}) {
  const { t: f } = fe(), [g, b] = W(""), [v, O] = W(!1), [C, E] = W(!1), N = async () => {
    try {
      O(!0), await t(), O(!1), E(!0);
    } catch {
      O(!1), b(f("file_manager.something_went_wrong"));
    }
  }, R = () => {
    b(""), E(!1);
  };
  return /* @__PURE__ */ y(
    bi,
    {
      opened: i,
      onClose: () => {
        !C && r && r(), e();
      },
      title: s || f("file_manager.confirm_action"),
      afterLeave: () => {
        u && u(), R();
      },
      isFetching: v,
      isCentered: !0,
      className: a,
      children: /* @__PURE__ */ A("form", { className: "flex flex-col gap-6 lg:gap-10", children: [
        n && /* @__PURE__ */ y("div", { className: "flex justify-center", children: /* @__PURE__ */ y("p", { className: "text-text-primary text-base", children: n }) }),
        d,
        /* @__PURE__ */ A("div", { className: "flex justify-center gap-4", children: [
          /* @__PURE__ */ y(
            ti,
            {
              isFetching: v,
              className: ie("w-full", c),
              buttonTextClassName: h,
              width: "large",
              onClick: async (m) => {
                m.preventDefault(), await N();
              },
              type: "submit",
              children: l || f("file_manager.confirm")
            }
          ),
          /* @__PURE__ */ y(
            Us,
            {
              className: ie("w-full", c),
              width: "large",
              buttonTextClassName: h,
              onClick: (m) => {
                m.preventDefault(), r && r(), e();
              },
              disabled: v,
              children: o || f("file_manager.cancel")
            }
          )
        ] }),
        /* @__PURE__ */ y(ui, { error: g, errorClassName: "text-center" })
      ] })
    }
  );
}
function Uo({ label: i, ...e }) {
  const { t } = fe();
  return /* @__PURE__ */ y(
    wi,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: i ?? /* @__PURE__ */ A("div", { className: "text-text-primary group-hover:text-brand-primary main-transition-colors flex items-center gap-2", children: [
        /* @__PURE__ */ y(
          ua,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        t("file_manager.file_details")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
function $o({ label: i, ...e }) {
  const { t } = fe();
  return /* @__PURE__ */ y(
    wi,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: i ?? /* @__PURE__ */ A("div", { className: "text-text-primary group-hover:text-brand-primary main-transition-colors flex items-center gap-2", children: [
        /* @__PURE__ */ y(
          ha,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        t("file_manager.delete")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
function Bo({ label: i, ...e }) {
  const { t } = fe();
  return /* @__PURE__ */ y(
    wi,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: i ?? /* @__PURE__ */ A("div", { className: "text-text-primary group-hover:text-brand-primary main-transition-colors flex items-center gap-2", children: [
        /* @__PURE__ */ y(
          da,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        t("file_manager.rename")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
function Ho({ label: i, ...e }) {
  const { t } = fe();
  return /* @__PURE__ */ y(
    wi,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: i ?? /* @__PURE__ */ A("div", { className: "text-text-primary group-hover:text-brand-primary main-transition-colors flex items-center gap-2", children: [
        /* @__PURE__ */ y(
          fa,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        t("file_manager.download")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
var ii = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(i) {
    return this.listeners.add(i), this.onSubscribe(), () => {
      this.listeners.delete(i), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, lt = typeof window > "u" || "Deno" in globalThis;
function Se() {
}
function Wo(i, e) {
  return typeof i == "function" ? i(e) : i;
}
function $i(i) {
  return typeof i == "number" && i >= 0 && i !== 1 / 0;
}
function sn(i, e) {
  return Math.max(i + (e || 0) - Date.now(), 0);
}
function yt(i, e) {
  return typeof i == "function" ? i(e) : i;
}
function De(i, e) {
  return typeof i == "function" ? i(e) : i;
}
function as(i, e) {
  const {
    type: t = "all",
    exact: r,
    fetchStatus: s,
    predicate: n,
    queryKey: a,
    stale: o
  } = i;
  if (a) {
    if (r) {
      if (e.queryHash !== vr(a, e.options))
        return !1;
    } else if (!qt(e.queryKey, a))
      return !1;
  }
  if (t !== "all") {
    const l = e.isActive();
    if (t === "active" && !l || t === "inactive" && l)
      return !1;
  }
  return !(typeof o == "boolean" && e.isStale() !== o || s && s !== e.state.fetchStatus || n && !n(e));
}
function os(i, e) {
  const { exact: t, status: r, predicate: s, mutationKey: n } = i;
  if (n) {
    if (!e.options.mutationKey)
      return !1;
    if (t) {
      if (Qt(e.options.mutationKey) !== Qt(n))
        return !1;
    } else if (!qt(e.options.mutationKey, n))
      return !1;
  }
  return !(r && e.state.status !== r || s && !s(e));
}
function vr(i, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || Qt)(i);
}
function Qt(i) {
  return JSON.stringify(
    i,
    (e, t) => Wi(t) ? Object.keys(t).sort().reduce((r, s) => (r[s] = t[s], r), {}) : t
  );
}
function qt(i, e) {
  return i === e ? !0 : typeof i != typeof e ? !1 : i && e && typeof i == "object" && typeof e == "object" ? !Object.keys(e).some((t) => !qt(i[t], e[t])) : !1;
}
function Bi(i, e) {
  if (i === e)
    return i;
  const t = ls(i) && ls(e);
  if (t || Wi(i) && Wi(e)) {
    const r = t ? i : Object.keys(i), s = r.length, n = t ? e : Object.keys(e), a = n.length, o = t ? [] : {};
    let l = 0;
    for (let c = 0; c < a; c++) {
      const h = t ? c : n[c];
      (!t && r.includes(h) || t) && i[h] === void 0 && e[h] === void 0 ? (o[h] = void 0, l++) : (o[h] = Bi(i[h], e[h]), o[h] === i[h] && i[h] !== void 0 && l++);
    }
    return s === a && l === s ? i : o;
  }
  return e;
}
function Hi(i, e) {
  if (!e || Object.keys(i).length !== Object.keys(e).length)
    return !1;
  for (const t in i)
    if (i[t] !== e[t])
      return !1;
  return !0;
}
function ls(i) {
  return Array.isArray(i) && i.length === Object.keys(i).length;
}
function Wi(i) {
  if (!cs(i))
    return !1;
  const e = i.constructor;
  if (e === void 0)
    return !0;
  const t = e.prototype;
  return !(!cs(t) || !t.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(i) !== Object.prototype);
}
function cs(i) {
  return Object.prototype.toString.call(i) === "[object Object]";
}
function Vo(i) {
  return new Promise((e) => {
    setTimeout(e, i);
  });
}
function Vi(i, e, t) {
  if (typeof t.structuralSharing == "function")
    return t.structuralSharing(i, e);
  if (t.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return Bi(i, e);
      } catch (r) {
        console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${t.queryHash}]: ${r}`
        );
      }
    return Bi(i, e);
  }
  return e;
}
function Ko(i, e, t = 0) {
  const r = [...i, e];
  return t && r.length > t ? r.slice(1) : r;
}
function Qo(i, e, t = 0) {
  const r = [e, ...i];
  return t && r.length > t ? r.slice(0, -1) : r;
}
var gi = Symbol();
function nn(i, e) {
  return process.env.NODE_ENV !== "production" && i.queryFn === gi && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${i.queryHash}'`
  ), !i.queryFn && (e != null && e.initialPromise) ? () => e.initialPromise : !i.queryFn || i.queryFn === gi ? () => Promise.reject(new Error(`Missing queryFn: '${i.queryHash}'`)) : i.queryFn;
}
var et, $e, xt, Fs, qo = (Fs = class extends ii {
  constructor() {
    super();
    T(this, et);
    T(this, $e);
    T(this, xt);
    P(this, xt, (e) => {
      if (!lt && window.addEventListener) {
        const t = () => e();
        return window.addEventListener("visibilitychange", t, !1), () => {
          window.removeEventListener("visibilitychange", t);
        };
      }
    });
  }
  onSubscribe() {
    p(this, $e) || this.setEventListener(p(this, xt));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = p(this, $e)) == null || e.call(this), P(this, $e, void 0));
  }
  setEventListener(e) {
    var t;
    P(this, xt, e), (t = p(this, $e)) == null || t.call(this), P(this, $e, e((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    }));
  }
  setFocused(e) {
    p(this, et) !== e && (P(this, et, e), this.onFocus());
  }
  onFocus() {
    const e = this.isFocused();
    this.listeners.forEach((t) => {
      t(e);
    });
  }
  isFocused() {
    var e;
    return typeof p(this, et) == "boolean" ? p(this, et) : ((e = globalThis.document) == null ? void 0 : e.visibilityState) !== "hidden";
  }
}, et = new WeakMap(), $e = new WeakMap(), xt = new WeakMap(), Fs), yr = new qo(), Ct, Be, St, Is, Yo = (Is = class extends ii {
  constructor() {
    super();
    T(this, Ct, !0);
    T(this, Be);
    T(this, St);
    P(this, St, (e) => {
      if (!lt && window.addEventListener) {
        const t = () => e(!0), r = () => e(!1);
        return window.addEventListener("online", t, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", t), window.removeEventListener("offline", r);
        };
      }
    });
  }
  onSubscribe() {
    p(this, Be) || this.setEventListener(p(this, St));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = p(this, Be)) == null || e.call(this), P(this, Be, void 0));
  }
  setEventListener(e) {
    var t;
    P(this, St, e), (t = p(this, Be)) == null || t.call(this), P(this, Be, e(this.setOnline.bind(this)));
  }
  setOnline(e) {
    p(this, Ct) !== e && (P(this, Ct, e), this.listeners.forEach((r) => {
      r(e);
    }));
  }
  isOnline() {
    return p(this, Ct);
  }
}, Ct = new WeakMap(), Be = new WeakMap(), St = new WeakMap(), Is), mi = new Yo();
function Ki() {
  let i, e;
  const t = new Promise((s, n) => {
    i = s, e = n;
  });
  t.status = "pending", t.catch(() => {
  });
  function r(s) {
    Object.assign(t, s), delete t.resolve, delete t.reject;
  }
  return t.resolve = (s) => {
    r({
      status: "fulfilled",
      value: s
    }), i(s);
  }, t.reject = (s) => {
    r({
      status: "rejected",
      reason: s
    }), e(s);
  }, t;
}
function Xo(i) {
  return Math.min(1e3 * 2 ** i, 3e4);
}
function an(i) {
  return (i ?? "online") === "online" ? mi.isOnline() : !0;
}
var on = class extends Error {
  constructor(i) {
    super("CancelledError"), this.revert = i == null ? void 0 : i.revert, this.silent = i == null ? void 0 : i.silent;
  }
};
function Di(i) {
  return i instanceof on;
}
function ln(i) {
  let e = !1, t = 0, r = !1, s;
  const n = Ki(), a = (b) => {
    var v;
    r || (u(new on(b)), (v = i.abort) == null || v.call(i));
  }, o = () => {
    e = !0;
  }, l = () => {
    e = !1;
  }, c = () => yr.isFocused() && (i.networkMode === "always" || mi.isOnline()) && i.canRun(), h = () => an(i.networkMode) && i.canRun(), d = (b) => {
    var v;
    r || (r = !0, (v = i.onSuccess) == null || v.call(i, b), s == null || s(), n.resolve(b));
  }, u = (b) => {
    var v;
    r || (r = !0, (v = i.onError) == null || v.call(i, b), s == null || s(), n.reject(b));
  }, f = () => new Promise((b) => {
    var v;
    s = (O) => {
      (r || c()) && b(O);
    }, (v = i.onPause) == null || v.call(i);
  }).then(() => {
    var b;
    s = void 0, r || (b = i.onContinue) == null || b.call(i);
  }), g = () => {
    if (r)
      return;
    let b;
    const v = t === 0 ? i.initialPromise : void 0;
    try {
      b = v ?? i.fn();
    } catch (O) {
      b = Promise.reject(O);
    }
    Promise.resolve(b).then(d).catch((O) => {
      var m;
      if (r)
        return;
      const C = i.retry ?? (lt ? 0 : 3), E = i.retryDelay ?? Xo, N = typeof E == "function" ? E(t, O) : E, R = C === !0 || typeof C == "number" && t < C || typeof C == "function" && C(t, O);
      if (e || !R) {
        u(O);
        return;
      }
      t++, (m = i.onFail) == null || m.call(i, t, O), Vo(N).then(() => c() ? void 0 : f()).then(() => {
        e ? u(O) : g();
      });
    });
  };
  return {
    promise: n,
    cancel: a,
    continue: () => (s == null || s(), n),
    cancelRetry: o,
    continueRetry: l,
    canStart: h,
    start: () => (h() ? g() : f().then(g), n)
  };
}
function Go() {
  let i = [], e = 0, t = (o) => {
    o();
  }, r = (o) => {
    o();
  }, s = (o) => setTimeout(o, 0);
  const n = (o) => {
    e ? i.push(o) : s(() => {
      t(o);
    });
  }, a = () => {
    const o = i;
    i = [], o.length && s(() => {
      r(() => {
        o.forEach((l) => {
          t(l);
        });
      });
    });
  };
  return {
    batch: (o) => {
      let l;
      e++;
      try {
        l = o();
      } finally {
        e--, e || a();
      }
      return l;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (o) => (...l) => {
      n(() => {
        o(...l);
      });
    },
    schedule: n,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (o) => {
      t = o;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (o) => {
      r = o;
    },
    setScheduler: (o) => {
      s = o;
    }
  };
}
var le = Go(), tt, Ms, cn = (Ms = class {
  constructor() {
    T(this, tt);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), $i(this.gcTime) && P(this, tt, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(i) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      i ?? (lt ? 1 / 0 : 300 * 1e3)
    );
  }
  clearGcTimeout() {
    p(this, tt) && (clearTimeout(p(this, tt)), P(this, tt, void 0));
  }
}, tt = new WeakMap(), Ms), Ot, Et, Ce, ue, Gt, it, Re, Ae, Ts, Jo = (Ts = class extends cn {
  constructor(e) {
    super();
    T(this, Re);
    T(this, Ot);
    T(this, Et);
    T(this, Ce);
    T(this, ue);
    T(this, Gt);
    T(this, it);
    P(this, it, !1), P(this, Gt, e.defaultOptions), this.setOptions(e.options), this.observers = [], P(this, Ce, e.cache), this.queryKey = e.queryKey, this.queryHash = e.queryHash, P(this, Ot, Zo(this.options)), this.state = e.state ?? p(this, Ot), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var e;
    return (e = p(this, ue)) == null ? void 0 : e.promise;
  }
  setOptions(e) {
    this.options = { ...p(this, Gt), ...e }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && p(this, Ce).remove(this);
  }
  setData(e, t) {
    const r = Vi(this.state.data, e, this.options);
    return $(this, Re, Ae).call(this, {
      data: r,
      type: "success",
      dataUpdatedAt: t == null ? void 0 : t.updatedAt,
      manual: t == null ? void 0 : t.manual
    }), r;
  }
  setState(e, t) {
    $(this, Re, Ae).call(this, { type: "setState", state: e, setStateOptions: t });
  }
  cancel(e) {
    var r, s;
    const t = (r = p(this, ue)) == null ? void 0 : r.promise;
    return (s = p(this, ue)) == null || s.cancel(e), t ? t.then(Se).catch(Se) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(p(this, Ot));
  }
  isActive() {
    return this.observers.some(
      (e) => De(e.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === gi || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (e) => e.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !sn(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var t;
    const e = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    e == null || e.refetch({ cancelRefetch: !1 }), (t = p(this, ue)) == null || t.continue();
  }
  onOnline() {
    var t;
    const e = this.observers.find((r) => r.shouldFetchOnReconnect());
    e == null || e.refetch({ cancelRefetch: !1 }), (t = p(this, ue)) == null || t.continue();
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), p(this, Ce).notify({ type: "observerAdded", query: this, observer: e }));
  }
  removeObserver(e) {
    this.observers.includes(e) && (this.observers = this.observers.filter((t) => t !== e), this.observers.length || (p(this, ue) && (p(this, it) ? p(this, ue).cancel({ revert: !0 }) : p(this, ue).cancelRetry()), this.scheduleGc()), p(this, Ce).notify({ type: "observerRemoved", query: this, observer: e }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || $(this, Re, Ae).call(this, { type: "invalidate" });
  }
  fetch(e, t) {
    var l, c, h;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (t != null && t.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (p(this, ue))
        return p(this, ue).continueRetry(), p(this, ue).promise;
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const d = this.observers.find((u) => u.options.queryFn);
      d && this.setOptions(d.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const r = new AbortController(), s = (d) => {
      Object.defineProperty(d, "signal", {
        enumerable: !0,
        get: () => (P(this, it, !0), r.signal)
      });
    }, n = () => {
      const d = nn(this.options, t), u = {
        queryKey: this.queryKey,
        meta: this.meta
      };
      return s(u), P(this, it, !1), this.options.persister ? this.options.persister(
        d,
        u,
        this
      ) : d(u);
    }, a = {
      fetchOptions: t,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: n
    };
    s(a), (l = this.options.behavior) == null || l.onFetch(
      a,
      this
    ), P(this, Et, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((c = a.fetchOptions) == null ? void 0 : c.meta)) && $(this, Re, Ae).call(this, { type: "fetch", meta: (h = a.fetchOptions) == null ? void 0 : h.meta });
    const o = (d) => {
      var u, f, g, b;
      Di(d) && d.silent || $(this, Re, Ae).call(this, {
        type: "error",
        error: d
      }), Di(d) || ((f = (u = p(this, Ce).config).onError) == null || f.call(
        u,
        d,
        this
      ), (b = (g = p(this, Ce).config).onSettled) == null || b.call(
        g,
        this.state.data,
        d,
        this
      )), this.scheduleGc();
    };
    return P(this, ue, ln({
      initialPromise: t == null ? void 0 : t.initialPromise,
      fn: a.fetchFn,
      abort: r.abort.bind(r),
      onSuccess: (d) => {
        var u, f, g, b;
        if (d === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), o(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(d);
        } catch (v) {
          o(v);
          return;
        }
        (f = (u = p(this, Ce).config).onSuccess) == null || f.call(u, d, this), (b = (g = p(this, Ce).config).onSettled) == null || b.call(
          g,
          d,
          this.state.error,
          this
        ), this.scheduleGc();
      },
      onError: o,
      onFail: (d, u) => {
        $(this, Re, Ae).call(this, { type: "failed", failureCount: d, error: u });
      },
      onPause: () => {
        $(this, Re, Ae).call(this, { type: "pause" });
      },
      onContinue: () => {
        $(this, Re, Ae).call(this, { type: "continue" });
      },
      retry: a.options.retry,
      retryDelay: a.options.retryDelay,
      networkMode: a.options.networkMode,
      canRun: () => !0
    })), p(this, ue).start();
  }
}, Ot = new WeakMap(), Et = new WeakMap(), Ce = new WeakMap(), ue = new WeakMap(), Gt = new WeakMap(), it = new WeakMap(), Re = new WeakSet(), Ae = function(e) {
  const t = (r) => {
    switch (e.type) {
      case "failed":
        return {
          ...r,
          fetchFailureCount: e.failureCount,
          fetchFailureReason: e.error
        };
      case "pause":
        return {
          ...r,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...r,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...r,
          ...un(r.data, this.options),
          fetchMeta: e.meta ?? null
        };
      case "success":
        return {
          ...r,
          data: e.data,
          dataUpdateCount: r.dataUpdateCount + 1,
          dataUpdatedAt: e.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!e.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const s = e.error;
        return Di(s) && s.revert && p(this, Et) ? { ...p(this, Et), fetchStatus: "idle" } : {
          ...r,
          error: s,
          errorUpdateCount: r.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: r.fetchFailureCount + 1,
          fetchFailureReason: s,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...r,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...r,
          ...e.state
        };
    }
  };
  this.state = t(this.state), le.batch(() => {
    this.observers.forEach((r) => {
      r.onQueryUpdate();
    }), p(this, Ce).notify({ query: this, type: "updated", action: e });
  });
}, Ts);
function un(i, e) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: an(e.networkMode) ? "fetching" : "paused",
    ...i === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function Zo(i) {
  const e = typeof i.initialData == "function" ? i.initialData() : i.initialData, t = e !== void 0, r = t ? typeof i.initialDataUpdatedAt == "function" ? i.initialDataUpdatedAt() : i.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: t ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: t ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var Pe, Ls, el = (Ls = class extends ii {
  constructor(e = {}) {
    super();
    T(this, Pe);
    this.config = e, P(this, Pe, /* @__PURE__ */ new Map());
  }
  build(e, t, r) {
    const s = t.queryKey, n = t.queryHash ?? vr(s, t);
    let a = this.get(n);
    return a || (a = new Jo({
      cache: this,
      queryKey: s,
      queryHash: n,
      options: e.defaultQueryOptions(t),
      state: r,
      defaultOptions: e.getQueryDefaults(s)
    }), this.add(a)), a;
  }
  add(e) {
    p(this, Pe).has(e.queryHash) || (p(this, Pe).set(e.queryHash, e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const t = p(this, Pe).get(e.queryHash);
    t && (e.destroy(), t === e && p(this, Pe).delete(e.queryHash), this.notify({ type: "removed", query: e }));
  }
  clear() {
    le.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return p(this, Pe).get(e);
  }
  getAll() {
    return [...p(this, Pe).values()];
  }
  find(e) {
    const t = { exact: !0, ...e };
    return this.getAll().find(
      (r) => as(t, r)
    );
  }
  findAll(e = {}) {
    const t = this.getAll();
    return Object.keys(e).length > 0 ? t.filter((r) => as(e, r)) : t;
  }
  notify(e) {
    le.batch(() => {
      this.listeners.forEach((t) => {
        t(e);
      });
    });
  }
  onFocus() {
    le.batch(() => {
      this.getAll().forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    le.batch(() => {
      this.getAll().forEach((e) => {
        e.onOnline();
      });
    });
  }
}, Pe = new WeakMap(), Ls), Fe, he, rt, Ie, Ue, ks, tl = (ks = class extends cn {
  constructor(e) {
    super();
    T(this, Ie);
    T(this, Fe);
    T(this, he);
    T(this, rt);
    this.mutationId = e.mutationId, P(this, he, e.mutationCache), P(this, Fe, []), this.state = e.state || il(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = e, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(e) {
    p(this, Fe).includes(e) || (p(this, Fe).push(e), this.clearGcTimeout(), p(this, he).notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    P(this, Fe, p(this, Fe).filter((t) => t !== e)), this.scheduleGc(), p(this, he).notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    p(this, Fe).length || (this.state.status === "pending" ? this.scheduleGc() : p(this, he).remove(this));
  }
  continue() {
    var e;
    return ((e = p(this, rt)) == null ? void 0 : e.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(e) {
    var s, n, a, o, l, c, h, d, u, f, g, b, v, O, C, E, N, R, m, S;
    P(this, rt, ln({
      fn: () => this.options.mutationFn ? this.options.mutationFn(e) : Promise.reject(new Error("No mutationFn found")),
      onFail: (w, x) => {
        $(this, Ie, Ue).call(this, { type: "failed", failureCount: w, error: x });
      },
      onPause: () => {
        $(this, Ie, Ue).call(this, { type: "pause" });
      },
      onContinue: () => {
        $(this, Ie, Ue).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => p(this, he).canRun(this)
    }));
    const t = this.state.status === "pending", r = !p(this, rt).canStart();
    try {
      if (!t) {
        $(this, Ie, Ue).call(this, { type: "pending", variables: e, isPaused: r }), await ((n = (s = p(this, he).config).onMutate) == null ? void 0 : n.call(
          s,
          e,
          this
        ));
        const x = await ((o = (a = this.options).onMutate) == null ? void 0 : o.call(a, e));
        x !== this.state.context && $(this, Ie, Ue).call(this, {
          type: "pending",
          context: x,
          variables: e,
          isPaused: r
        });
      }
      const w = await p(this, rt).start();
      return await ((c = (l = p(this, he).config).onSuccess) == null ? void 0 : c.call(
        l,
        w,
        e,
        this.state.context,
        this
      )), await ((d = (h = this.options).onSuccess) == null ? void 0 : d.call(h, w, e, this.state.context)), await ((f = (u = p(this, he).config).onSettled) == null ? void 0 : f.call(
        u,
        w,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((b = (g = this.options).onSettled) == null ? void 0 : b.call(g, w, null, e, this.state.context)), $(this, Ie, Ue).call(this, { type: "success", data: w }), w;
    } catch (w) {
      try {
        throw await ((O = (v = p(this, he).config).onError) == null ? void 0 : O.call(
          v,
          w,
          e,
          this.state.context,
          this
        )), await ((E = (C = this.options).onError) == null ? void 0 : E.call(
          C,
          w,
          e,
          this.state.context
        )), await ((R = (N = p(this, he).config).onSettled) == null ? void 0 : R.call(
          N,
          void 0,
          w,
          this.state.variables,
          this.state.context,
          this
        )), await ((S = (m = this.options).onSettled) == null ? void 0 : S.call(
          m,
          void 0,
          w,
          e,
          this.state.context
        )), w;
      } finally {
        $(this, Ie, Ue).call(this, { type: "error", error: w });
      }
    } finally {
      p(this, he).runNext(this);
    }
  }
}, Fe = new WeakMap(), he = new WeakMap(), rt = new WeakMap(), Ie = new WeakSet(), Ue = function(e) {
  const t = (r) => {
    switch (e.type) {
      case "failed":
        return {
          ...r,
          failureCount: e.failureCount,
          failureReason: e.error
        };
      case "pause":
        return {
          ...r,
          isPaused: !0
        };
      case "continue":
        return {
          ...r,
          isPaused: !1
        };
      case "pending":
        return {
          ...r,
          context: e.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: e.isPaused,
          status: "pending",
          variables: e.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...r,
          data: e.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...r,
          data: void 0,
          error: e.error,
          failureCount: r.failureCount + 1,
          failureReason: e.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = t(this.state), le.batch(() => {
    p(this, Fe).forEach((r) => {
      r.onMutationUpdate(e);
    }), p(this, he).notify({
      mutation: this,
      type: "updated",
      action: e
    });
  });
}, ks);
function il() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var ve, Jt, As, rl = (As = class extends ii {
  constructor(e = {}) {
    super();
    T(this, ve);
    T(this, Jt);
    this.config = e, P(this, ve, /* @__PURE__ */ new Map()), P(this, Jt, Date.now());
  }
  build(e, t, r) {
    const s = new tl({
      mutationCache: this,
      mutationId: ++ni(this, Jt)._,
      options: e.defaultMutationOptions(t),
      state: r
    });
    return this.add(s), s;
  }
  add(e) {
    const t = oi(e), r = p(this, ve).get(t) ?? [];
    r.push(e), p(this, ve).set(t, r), this.notify({ type: "added", mutation: e });
  }
  remove(e) {
    var r;
    const t = oi(e);
    if (p(this, ve).has(t)) {
      const s = (r = p(this, ve).get(t)) == null ? void 0 : r.filter((n) => n !== e);
      s && (s.length === 0 ? p(this, ve).delete(t) : p(this, ve).set(t, s));
    }
    this.notify({ type: "removed", mutation: e });
  }
  canRun(e) {
    var r;
    const t = (r = p(this, ve).get(oi(e))) == null ? void 0 : r.find((s) => s.state.status === "pending");
    return !t || t === e;
  }
  runNext(e) {
    var r;
    const t = (r = p(this, ve).get(oi(e))) == null ? void 0 : r.find((s) => s !== e && s.state.isPaused);
    return (t == null ? void 0 : t.continue()) ?? Promise.resolve();
  }
  clear() {
    le.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return [...p(this, ve).values()].flat();
  }
  find(e) {
    const t = { exact: !0, ...e };
    return this.getAll().find(
      (r) => os(t, r)
    );
  }
  findAll(e = {}) {
    return this.getAll().filter((t) => os(e, t));
  }
  notify(e) {
    le.batch(() => {
      this.listeners.forEach((t) => {
        t(e);
      });
    });
  }
  resumePausedMutations() {
    const e = this.getAll().filter((t) => t.state.isPaused);
    return le.batch(
      () => Promise.all(
        e.map((t) => t.continue().catch(Se))
      )
    );
  }
}, ve = new WeakMap(), Jt = new WeakMap(), As);
function oi(i) {
  var e;
  return ((e = i.options.scope) == null ? void 0 : e.id) ?? String(i.mutationId);
}
function vi(i) {
  return {
    onFetch: (e, t) => {
      var h, d, u, f, g;
      const r = e.options, s = (u = (d = (h = e.fetchOptions) == null ? void 0 : h.meta) == null ? void 0 : d.fetchMore) == null ? void 0 : u.direction, n = ((f = e.state.data) == null ? void 0 : f.pages) || [], a = ((g = e.state.data) == null ? void 0 : g.pageParams) || [];
      let o = { pages: [], pageParams: [] }, l = 0;
      const c = async () => {
        let b = !1;
        const v = (E) => {
          Object.defineProperty(E, "signal", {
            enumerable: !0,
            get: () => (e.signal.aborted ? b = !0 : e.signal.addEventListener("abort", () => {
              b = !0;
            }), e.signal)
          });
        }, O = nn(e.options, e.fetchOptions), C = async (E, N, R) => {
          if (b)
            return Promise.reject();
          if (N == null && E.pages.length)
            return Promise.resolve(E);
          const m = {
            queryKey: e.queryKey,
            pageParam: N,
            direction: R ? "backward" : "forward",
            meta: e.options.meta
          };
          v(m);
          const S = await O(
            m
          ), { maxPages: w } = e.options, x = R ? Qo : Ko;
          return {
            pages: x(E.pages, S, w),
            pageParams: x(E.pageParams, N, w)
          };
        };
        if (s && n.length) {
          const E = s === "backward", N = E ? hn : Qi, R = {
            pages: n,
            pageParams: a
          }, m = N(r, R);
          o = await C(R, m, E);
        } else {
          const E = i ?? n.length;
          do {
            const N = l === 0 ? a[0] ?? r.initialPageParam : Qi(r, o);
            if (l > 0 && N == null)
              break;
            o = await C(o, N), l++;
          } while (l < E);
        }
        return o;
      };
      e.options.persister ? e.fetchFn = () => {
        var b, v;
        return (v = (b = e.options).persister) == null ? void 0 : v.call(
          b,
          c,
          {
            queryKey: e.queryKey,
            meta: e.options.meta,
            signal: e.signal
          },
          t
        );
      } : e.fetchFn = c;
    }
  };
}
function Qi(i, { pages: e, pageParams: t }) {
  const r = e.length - 1;
  return e.length > 0 ? i.getNextPageParam(
    e[r],
    e,
    t[r],
    t
  ) : void 0;
}
function hn(i, { pages: e, pageParams: t }) {
  var r;
  return e.length > 0 ? (r = i.getPreviousPageParam) == null ? void 0 : r.call(i, e[0], e, t[0], t) : void 0;
}
function sl(i, e) {
  return e ? Qi(i, e) != null : !1;
}
function nl(i, e) {
  return !e || !i.getPreviousPageParam ? !1 : hn(i, e) != null;
}
var te, He, We, Nt, _t, Ve, Rt, Dt, js, al = (js = class {
  constructor(i = {}) {
    T(this, te);
    T(this, He);
    T(this, We);
    T(this, Nt);
    T(this, _t);
    T(this, Ve);
    T(this, Rt);
    T(this, Dt);
    P(this, te, i.queryCache || new el()), P(this, He, i.mutationCache || new rl()), P(this, We, i.defaultOptions || {}), P(this, Nt, /* @__PURE__ */ new Map()), P(this, _t, /* @__PURE__ */ new Map()), P(this, Ve, 0);
  }
  mount() {
    ni(this, Ve)._++, p(this, Ve) === 1 && (P(this, Rt, yr.subscribe(async (i) => {
      i && (await this.resumePausedMutations(), p(this, te).onFocus());
    })), P(this, Dt, mi.subscribe(async (i) => {
      i && (await this.resumePausedMutations(), p(this, te).onOnline());
    })));
  }
  unmount() {
    var i, e;
    ni(this, Ve)._--, p(this, Ve) === 0 && ((i = p(this, Rt)) == null || i.call(this), P(this, Rt, void 0), (e = p(this, Dt)) == null || e.call(this), P(this, Dt, void 0));
  }
  isFetching(i) {
    return p(this, te).findAll({ ...i, fetchStatus: "fetching" }).length;
  }
  isMutating(i) {
    return p(this, He).findAll({ ...i, status: "pending" }).length;
  }
  getQueryData(i) {
    var t;
    const e = this.defaultQueryOptions({ queryKey: i });
    return (t = p(this, te).get(e.queryHash)) == null ? void 0 : t.state.data;
  }
  ensureQueryData(i) {
    const e = this.getQueryData(i.queryKey);
    if (e === void 0)
      return this.fetchQuery(i);
    {
      const t = this.defaultQueryOptions(i), r = p(this, te).build(this, t);
      return i.revalidateIfStale && r.isStaleByTime(yt(t.staleTime, r)) && this.prefetchQuery(t), Promise.resolve(e);
    }
  }
  getQueriesData(i) {
    return p(this, te).findAll(i).map(({ queryKey: e, state: t }) => {
      const r = t.data;
      return [e, r];
    });
  }
  setQueryData(i, e, t) {
    const r = this.defaultQueryOptions({ queryKey: i }), s = p(this, te).get(
      r.queryHash
    ), n = s == null ? void 0 : s.state.data, a = Wo(e, n);
    if (a !== void 0)
      return p(this, te).build(this, r).setData(a, { ...t, manual: !0 });
  }
  setQueriesData(i, e, t) {
    return le.batch(
      () => p(this, te).findAll(i).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, e, t)
      ])
    );
  }
  getQueryState(i) {
    var t;
    const e = this.defaultQueryOptions({ queryKey: i });
    return (t = p(this, te).get(e.queryHash)) == null ? void 0 : t.state;
  }
  removeQueries(i) {
    const e = p(this, te);
    le.batch(() => {
      e.findAll(i).forEach((t) => {
        e.remove(t);
      });
    });
  }
  resetQueries(i, e) {
    const t = p(this, te), r = {
      type: "active",
      ...i
    };
    return le.batch(() => (t.findAll(i).forEach((s) => {
      s.reset();
    }), this.refetchQueries(r, e)));
  }
  cancelQueries(i = {}, e = {}) {
    const t = { revert: !0, ...e }, r = le.batch(
      () => p(this, te).findAll(i).map((s) => s.cancel(t))
    );
    return Promise.all(r).then(Se).catch(Se);
  }
  invalidateQueries(i = {}, e = {}) {
    return le.batch(() => {
      if (p(this, te).findAll(i).forEach((r) => {
        r.invalidate();
      }), i.refetchType === "none")
        return Promise.resolve();
      const t = {
        ...i,
        type: i.refetchType ?? i.type ?? "active"
      };
      return this.refetchQueries(t, e);
    });
  }
  refetchQueries(i = {}, e) {
    const t = {
      ...e,
      cancelRefetch: (e == null ? void 0 : e.cancelRefetch) ?? !0
    }, r = le.batch(
      () => p(this, te).findAll(i).filter((s) => !s.isDisabled()).map((s) => {
        let n = s.fetch(void 0, t);
        return t.throwOnError || (n = n.catch(Se)), s.state.fetchStatus === "paused" ? Promise.resolve() : n;
      })
    );
    return Promise.all(r).then(Se);
  }
  fetchQuery(i) {
    const e = this.defaultQueryOptions(i);
    e.retry === void 0 && (e.retry = !1);
    const t = p(this, te).build(this, e);
    return t.isStaleByTime(
      yt(e.staleTime, t)
    ) ? t.fetch(e) : Promise.resolve(t.state.data);
  }
  prefetchQuery(i) {
    return this.fetchQuery(i).then(Se).catch(Se);
  }
  fetchInfiniteQuery(i) {
    return i.behavior = vi(i.pages), this.fetchQuery(i);
  }
  prefetchInfiniteQuery(i) {
    return this.fetchInfiniteQuery(i).then(Se).catch(Se);
  }
  ensureInfiniteQueryData(i) {
    return i.behavior = vi(i.pages), this.ensureQueryData(i);
  }
  resumePausedMutations() {
    return mi.isOnline() ? p(this, He).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return p(this, te);
  }
  getMutationCache() {
    return p(this, He);
  }
  getDefaultOptions() {
    return p(this, We);
  }
  setDefaultOptions(i) {
    P(this, We, i);
  }
  setQueryDefaults(i, e) {
    p(this, Nt).set(Qt(i), {
      queryKey: i,
      defaultOptions: e
    });
  }
  getQueryDefaults(i) {
    const e = [...p(this, Nt).values()];
    let t = {};
    return e.forEach((r) => {
      qt(i, r.queryKey) && (t = { ...t, ...r.defaultOptions });
    }), t;
  }
  setMutationDefaults(i, e) {
    p(this, _t).set(Qt(i), {
      mutationKey: i,
      defaultOptions: e
    });
  }
  getMutationDefaults(i) {
    const e = [...p(this, _t).values()];
    let t = {};
    return e.forEach((r) => {
      qt(i, r.mutationKey) && (t = { ...t, ...r.defaultOptions });
    }), t;
  }
  defaultQueryOptions(i) {
    if (i._defaulted)
      return i;
    const e = {
      ...p(this, We).queries,
      ...this.getQueryDefaults(i.queryKey),
      ...i,
      _defaulted: !0
    };
    return e.queryHash || (e.queryHash = vr(
      e.queryKey,
      e
    )), e.refetchOnReconnect === void 0 && (e.refetchOnReconnect = e.networkMode !== "always"), e.throwOnError === void 0 && (e.throwOnError = !!e.suspense), !e.networkMode && e.persister && (e.networkMode = "offlineFirst"), e.enabled !== !0 && e.queryFn === gi && (e.enabled = !1), e;
  }
  defaultMutationOptions(i) {
    return i != null && i._defaulted ? i : {
      ...p(this, We).mutations,
      ...(i == null ? void 0 : i.mutationKey) && this.getMutationDefaults(i.mutationKey),
      ...i,
      _defaulted: !0
    };
  }
  clear() {
    p(this, te).clear(), p(this, He).clear();
  }
}, te = new WeakMap(), He = new WeakMap(), We = new WeakMap(), Nt = new WeakMap(), _t = new WeakMap(), Ve = new WeakMap(), Rt = new WeakMap(), Dt = new WeakMap(), js), pe, B, Zt, de, st, Pt, Ke, Me, ei, Ft, It, nt, at, Qe, Mt, Q, Bt, qi, Yi, Xi, Gi, Ji, Zi, er, fn, zs, dn = (zs = class extends ii {
  constructor(e, t) {
    super();
    T(this, Q);
    T(this, pe);
    T(this, B);
    T(this, Zt);
    T(this, de);
    T(this, st);
    T(this, Pt);
    T(this, Ke);
    T(this, Me);
    T(this, ei);
    T(this, Ft);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    T(this, It);
    T(this, nt);
    T(this, at);
    T(this, Qe);
    T(this, Mt, /* @__PURE__ */ new Set());
    this.options = t, P(this, pe, e), P(this, Me, null), P(this, Ke, Ki()), this.options.experimental_prefetchInRender || p(this, Ke).reject(
      new Error("experimental_prefetchInRender feature flag is not enabled")
    ), this.bindMethods(), this.setOptions(t);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (p(this, B).addObserver(this), us(p(this, B), this.options) ? $(this, Q, Bt).call(this) : this.updateResult(), $(this, Q, Gi).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return tr(
      p(this, B),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return tr(
      p(this, B),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), $(this, Q, Ji).call(this), $(this, Q, Zi).call(this), p(this, B).removeObserver(this);
  }
  setOptions(e, t) {
    const r = this.options, s = p(this, B);
    if (this.options = p(this, pe).defaultQueryOptions(e), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof De(this.options.enabled, p(this, B)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    $(this, Q, er).call(this), p(this, B).setOptions(this.options), r._defaulted && !Hi(this.options, r) && p(this, pe).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: p(this, B),
      observer: this
    });
    const n = this.hasListeners();
    n && hs(
      p(this, B),
      s,
      this.options,
      r
    ) && $(this, Q, Bt).call(this), this.updateResult(t), n && (p(this, B) !== s || De(this.options.enabled, p(this, B)) !== De(r.enabled, p(this, B)) || yt(this.options.staleTime, p(this, B)) !== yt(r.staleTime, p(this, B))) && $(this, Q, qi).call(this);
    const a = $(this, Q, Yi).call(this);
    n && (p(this, B) !== s || De(this.options.enabled, p(this, B)) !== De(r.enabled, p(this, B)) || a !== p(this, Qe)) && $(this, Q, Xi).call(this, a);
  }
  getOptimisticResult(e) {
    const t = p(this, pe).getQueryCache().build(p(this, pe), e), r = this.createResult(t, e);
    return ll(this, r) && (P(this, de, r), P(this, Pt, this.options), P(this, st, p(this, B).state)), r;
  }
  getCurrentResult() {
    return p(this, de);
  }
  trackResult(e, t) {
    const r = {};
    return Object.keys(e).forEach((s) => {
      Object.defineProperty(r, s, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackProp(s), t == null || t(s), e[s])
      });
    }), r;
  }
  trackProp(e) {
    p(this, Mt).add(e);
  }
  getCurrentQuery() {
    return p(this, B);
  }
  refetch({ ...e } = {}) {
    return this.fetch({
      ...e
    });
  }
  fetchOptimistic(e) {
    const t = p(this, pe).defaultQueryOptions(e), r = p(this, pe).getQueryCache().build(p(this, pe), t);
    return r.fetch().then(() => this.createResult(r, t));
  }
  fetch(e) {
    return $(this, Q, Bt).call(this, {
      ...e,
      cancelRefetch: e.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), p(this, de)));
  }
  createResult(e, t) {
    var w;
    const r = p(this, B), s = this.options, n = p(this, de), a = p(this, st), o = p(this, Pt), c = e !== r ? e.state : p(this, Zt), { state: h } = e;
    let d = { ...h }, u = !1, f;
    if (t._optimisticResults) {
      const x = this.hasListeners(), _ = !x && us(e, t), F = x && hs(e, r, t, s);
      (_ || F) && (d = {
        ...d,
        ...un(h.data, e.options)
      }), t._optimisticResults === "isRestoring" && (d.fetchStatus = "idle");
    }
    let { error: g, errorUpdatedAt: b, status: v } = d;
    if (t.select && d.data !== void 0)
      if (n && d.data === (a == null ? void 0 : a.data) && t.select === p(this, ei))
        f = p(this, Ft);
      else
        try {
          P(this, ei, t.select), f = t.select(d.data), f = Vi(n == null ? void 0 : n.data, f, t), P(this, Ft, f), P(this, Me, null);
        } catch (x) {
          P(this, Me, x);
        }
    else
      f = d.data;
    if (t.placeholderData !== void 0 && f === void 0 && v === "pending") {
      let x;
      if (n != null && n.isPlaceholderData && t.placeholderData === (o == null ? void 0 : o.placeholderData))
        x = n.data;
      else if (x = typeof t.placeholderData == "function" ? t.placeholderData(
        (w = p(this, It)) == null ? void 0 : w.state.data,
        p(this, It)
      ) : t.placeholderData, t.select && x !== void 0)
        try {
          x = t.select(x), P(this, Me, null);
        } catch (_) {
          P(this, Me, _);
        }
      x !== void 0 && (v = "success", f = Vi(
        n == null ? void 0 : n.data,
        x,
        t
      ), u = !0);
    }
    p(this, Me) && (g = p(this, Me), f = p(this, Ft), b = Date.now(), v = "error");
    const O = d.fetchStatus === "fetching", C = v === "pending", E = v === "error", N = C && O, R = f !== void 0, S = {
      status: v,
      fetchStatus: d.fetchStatus,
      isPending: C,
      isSuccess: v === "success",
      isError: E,
      isInitialLoading: N,
      isLoading: N,
      data: f,
      dataUpdatedAt: d.dataUpdatedAt,
      error: g,
      errorUpdatedAt: b,
      failureCount: d.fetchFailureCount,
      failureReason: d.fetchFailureReason,
      errorUpdateCount: d.errorUpdateCount,
      isFetched: d.dataUpdateCount > 0 || d.errorUpdateCount > 0,
      isFetchedAfterMount: d.dataUpdateCount > c.dataUpdateCount || d.errorUpdateCount > c.errorUpdateCount,
      isFetching: O,
      isRefetching: O && !C,
      isLoadingError: E && !R,
      isPaused: d.fetchStatus === "paused",
      isPlaceholderData: u,
      isRefetchError: E && R,
      isStale: br(e, t),
      refetch: this.refetch,
      promise: p(this, Ke)
    };
    if (this.options.experimental_prefetchInRender) {
      const x = (I) => {
        S.status === "error" ? I.reject(S.error) : S.data !== void 0 && I.resolve(S.data);
      }, _ = () => {
        const I = P(this, Ke, S.promise = Ki());
        x(I);
      }, F = p(this, Ke);
      switch (F.status) {
        case "pending":
          e.queryHash === r.queryHash && x(F);
          break;
        case "fulfilled":
          (S.status === "error" || S.data !== F.value) && _();
          break;
        case "rejected":
          (S.status !== "error" || S.error !== F.reason) && _();
          break;
      }
    }
    return S;
  }
  updateResult(e) {
    const t = p(this, de), r = this.createResult(p(this, B), this.options);
    if (P(this, st, p(this, B).state), P(this, Pt, this.options), p(this, st).data !== void 0 && P(this, It, p(this, B)), Hi(r, t))
      return;
    P(this, de, r);
    const s = {}, n = () => {
      if (!t)
        return !0;
      const { notifyOnChangeProps: a } = this.options, o = typeof a == "function" ? a() : a;
      if (o === "all" || !o && !p(this, Mt).size)
        return !0;
      const l = new Set(
        o ?? p(this, Mt)
      );
      return this.options.throwOnError && l.add("error"), Object.keys(p(this, de)).some((c) => {
        const h = c;
        return p(this, de)[h] !== t[h] && l.has(h);
      });
    };
    (e == null ? void 0 : e.listeners) !== !1 && n() && (s.listeners = !0), $(this, Q, fn).call(this, { ...s, ...e });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && $(this, Q, Gi).call(this);
  }
}, pe = new WeakMap(), B = new WeakMap(), Zt = new WeakMap(), de = new WeakMap(), st = new WeakMap(), Pt = new WeakMap(), Ke = new WeakMap(), Me = new WeakMap(), ei = new WeakMap(), Ft = new WeakMap(), It = new WeakMap(), nt = new WeakMap(), at = new WeakMap(), Qe = new WeakMap(), Mt = new WeakMap(), Q = new WeakSet(), Bt = function(e) {
  $(this, Q, er).call(this);
  let t = p(this, B).fetch(
    this.options,
    e
  );
  return e != null && e.throwOnError || (t = t.catch(Se)), t;
}, qi = function() {
  $(this, Q, Ji).call(this);
  const e = yt(
    this.options.staleTime,
    p(this, B)
  );
  if (lt || p(this, de).isStale || !$i(e))
    return;
  const r = sn(p(this, de).dataUpdatedAt, e) + 1;
  P(this, nt, setTimeout(() => {
    p(this, de).isStale || this.updateResult();
  }, r));
}, Yi = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(p(this, B)) : this.options.refetchInterval) ?? !1;
}, Xi = function(e) {
  $(this, Q, Zi).call(this), P(this, Qe, e), !(lt || De(this.options.enabled, p(this, B)) === !1 || !$i(p(this, Qe)) || p(this, Qe) === 0) && P(this, at, setInterval(() => {
    (this.options.refetchIntervalInBackground || yr.isFocused()) && $(this, Q, Bt).call(this);
  }, p(this, Qe)));
}, Gi = function() {
  $(this, Q, qi).call(this), $(this, Q, Xi).call(this, $(this, Q, Yi).call(this));
}, Ji = function() {
  p(this, nt) && (clearTimeout(p(this, nt)), P(this, nt, void 0));
}, Zi = function() {
  p(this, at) && (clearInterval(p(this, at)), P(this, at, void 0));
}, er = function() {
  const e = p(this, pe).getQueryCache().build(p(this, pe), this.options);
  if (e === p(this, B))
    return;
  const t = p(this, B);
  P(this, B, e), P(this, Zt, e.state), this.hasListeners() && (t == null || t.removeObserver(this), e.addObserver(this));
}, fn = function(e) {
  le.batch(() => {
    e.listeners && this.listeners.forEach((t) => {
      t(p(this, de));
    }), p(this, pe).getQueryCache().notify({
      query: p(this, B),
      type: "observerResultsUpdated"
    });
  });
}, zs);
function ol(i, e) {
  return De(e.enabled, i) !== !1 && i.state.data === void 0 && !(i.state.status === "error" && e.retryOnMount === !1);
}
function us(i, e) {
  return ol(i, e) || i.state.data !== void 0 && tr(i, e, e.refetchOnMount);
}
function tr(i, e, t) {
  if (De(e.enabled, i) !== !1) {
    const r = typeof t == "function" ? t(i) : t;
    return r === "always" || r !== !1 && br(i, e);
  }
  return !1;
}
function hs(i, e, t, r) {
  return (i !== e || De(r.enabled, i) === !1) && (!t.suspense || i.state.status !== "error") && br(i, t);
}
function br(i, e) {
  return De(e.enabled, i) !== !1 && i.isStaleByTime(yt(e.staleTime, i));
}
function ll(i, e) {
  return !Hi(i.getCurrentResult(), e);
}
var cl = class extends dn {
  constructor(i, e) {
    super(i, e);
  }
  bindMethods() {
    super.bindMethods(), this.fetchNextPage = this.fetchNextPage.bind(this), this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }
  setOptions(i, e) {
    super.setOptions(
      {
        ...i,
        behavior: vi()
      },
      e
    );
  }
  getOptimisticResult(i) {
    return i.behavior = vi(), super.getOptimisticResult(i);
  }
  fetchNextPage(i) {
    return this.fetch({
      ...i,
      meta: {
        fetchMore: { direction: "forward" }
      }
    });
  }
  fetchPreviousPage(i) {
    return this.fetch({
      ...i,
      meta: {
        fetchMore: { direction: "backward" }
      }
    });
  }
  createResult(i, e) {
    var g, b;
    const { state: t } = i, r = super.createResult(i, e), { isFetching: s, isRefetching: n, isError: a, isRefetchError: o } = r, l = (b = (g = t.fetchMeta) == null ? void 0 : g.fetchMore) == null ? void 0 : b.direction, c = a && l === "forward", h = s && l === "forward", d = a && l === "backward", u = s && l === "backward";
    return {
      ...r,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: sl(e, t.data),
      hasPreviousPage: nl(e, t.data),
      isFetchNextPageError: c,
      isFetchingNextPage: h,
      isFetchPreviousPageError: d,
      isFetchingPreviousPage: u,
      isRefetchError: o && !c && !d,
      isRefetching: n && !h && !u
    };
  }
}, pn = ce.createContext(
  void 0
), Si = (i) => {
  const e = ce.useContext(pn);
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
}, ul = ({
  client: i,
  children: e
}) => (ce.useEffect(() => (i.mount(), () => {
  i.unmount();
}), [i]), /* @__PURE__ */ y(pn.Provider, { value: i, children: e })), gn = ce.createContext(!1), hl = () => ce.useContext(gn);
gn.Provider;
function dl() {
  let i = !1;
  return {
    clearReset: () => {
      i = !1;
    },
    reset: () => {
      i = !0;
    },
    isReset: () => i
  };
}
var fl = ce.createContext(dl()), pl = () => ce.useContext(fl);
function gl(i, e) {
  return typeof i == "function" ? i(...e) : !!i;
}
function ml() {
}
var vl = (i, e) => {
  (i.suspense || i.throwOnError || i.experimental_prefetchInRender) && (e.isReset() || (i.retryOnMount = !1));
}, yl = (i) => {
  ce.useEffect(() => {
    i.clearReset();
  }, [i]);
}, bl = ({
  result: i,
  errorResetBoundary: e,
  throwOnError: t,
  query: r
}) => i.isError && !e.isReset() && !i.isFetching && r && gl(t, [i.error, r]), wl = (i) => {
  i.suspense && (i.staleTime === void 0 && (i.staleTime = 1e3), typeof i.gcTime == "number" && (i.gcTime = Math.max(i.gcTime, 1e3)));
}, xl = (i, e) => i.isLoading && i.isFetching && !e, Cl = (i, e) => (i == null ? void 0 : i.suspense) && e.isPending, ds = (i, e, t) => e.fetchOptimistic(i).catch(() => {
  t.clearReset();
});
function mn(i, e, t) {
  var h, d, u, f, g;
  if (process.env.NODE_ENV !== "production" && (typeof i != "object" || Array.isArray(i)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const r = Si(), s = hl(), n = pl(), a = r.defaultQueryOptions(i);
  (d = (h = r.getDefaultOptions().queries) == null ? void 0 : h._experimental_beforeQuery) == null || d.call(
    h,
    a
  ), a._optimisticResults = s ? "isRestoring" : "optimistic", wl(a), vl(a, n), yl(n);
  const o = !r.getQueryCache().get(a.queryHash), [l] = ce.useState(
    () => new e(
      r,
      a
    )
  ), c = l.getOptimisticResult(a);
  if (ce.useSyncExternalStore(
    ce.useCallback(
      (b) => {
        const v = s ? () => {
        } : l.subscribe(le.batchCalls(b));
        return l.updateResult(), v;
      },
      [l, s]
    ),
    () => l.getCurrentResult(),
    () => l.getCurrentResult()
  ), ce.useEffect(() => {
    l.setOptions(a, { listeners: !1 });
  }, [a, l]), Cl(a, c))
    throw ds(a, l, n);
  if (bl({
    result: c,
    errorResetBoundary: n,
    throwOnError: a.throwOnError,
    query: r.getQueryCache().get(a.queryHash)
  }))
    throw c.error;
  if ((f = (u = r.getDefaultOptions().queries) == null ? void 0 : u._experimental_afterQuery) == null || f.call(
    u,
    a,
    c
  ), a.experimental_prefetchInRender && !lt && xl(c, s)) {
    const b = o ? (
      // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
      ds(a, l, n)
    ) : (
      // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
      (g = r.getQueryCache().get(a.queryHash)) == null ? void 0 : g.promise
    );
    b == null || b.catch(ml).finally(() => {
      l.updateResult();
    });
  }
  return a.notifyOnChangeProps ? c : l.trackResult(c);
}
function vn(i, e) {
  return mn(i, dn);
}
function Sl(i, e) {
  return mn(
    i,
    cl
  );
}
const Ol = new al({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchInterval: !1,
      refetchOnWindowFocus: !1,
      refetchOnMount: !1,
      refetchIntervalInBackground: !1
    }
  }
});
function du({ children: i }) {
  return /* @__PURE__ */ y(ul, { client: Ol, children: i });
}
const El = $s(null), fu = ({
  children: i,
  languageCode: e
}) => {
  const [t, r] = W(e), s = oa((n) => {
    re.hasResourceBundle(n, gr) ? (re.changeLanguage(n), r(n)) : Fo(n).then(() => {
      re.changeLanguage(n), r(n);
    });
  }, []);
  return Ee(() => {
    re.isInitialized && s(e);
  }, [e, s]), /* @__PURE__ */ y(El.Provider, { value: { currentLanguageCode: t, changeLocale: s }, children: i });
}, yn = async ({
  startFrom: i,
  limit: e,
  order: t,
  sortColumn: r,
  sortDirection: s,
  filter: n
}) => {
  var o, l;
  return (await mr.get(
    "/api/dashboard/customer/data-files?" + (n != null && n.name ? `&filter[names][]=${n == null ? void 0 : n.name}` : "") + ((o = n == null ? void 0 : n.source) != null && o.length ? n.source.map((c) => `&filter[sources][]=${encodeURIComponent(c)}`).join("") : "") + ((l = n == null ? void 0 : n.type) != null && l.length ? n.type.map((c) => `&filter[types][]=${encodeURIComponent(c)}`).join("") : "") + (i ? `&pagination[startFrom]=${i}` : "") + (r ? `&pagination[sortColumn]=${r}` : "") + (s ? `&pagination[sortDirection]=${s}` : "") + (e ? `&pagination[limit]=${e}` : "") + (t ? `&pagination[order]=${t}` : "")
  )).data;
}, pu = ({
  startFrom: i,
  limit: e = 10,
  order: t = pr.Next,
  sortColumn: r,
  sortDirection: s,
  filter: n
}, a) => {
  const o = Si(), l = ["data-files"], c = [
    "data-files",
    { startFrom: i, limit: e, order: t, sortColumn: r, sortDirection: s, filter: n }
  ];
  return {
    ...vn({
      queryKey: c,
      queryFn: () => yn({ startFrom: i, limit: e, order: t, sortColumn: r, sortDirection: s, filter: n }),
      ...a
    }),
    resetAndRefetch: () => {
      o.invalidateQueries({ queryKey: l });
    },
    triggerFetch: () => {
      o.fetchQuery({ queryKey: c });
    },
    deleteItemFromData: (b) => {
      o.getQueryCache().findAll({ queryKey: l }).forEach((O) => {
        o.setQueryData(
          O.queryKey,
          (C) => {
            if (C)
              return {
                ...C,
                items: C.items.filter((E) => E.id !== b)
              };
          }
        );
      });
    },
    renameItemFromData: ({ id: b, name: v }) => {
      o.getQueryCache().findAll({ queryKey: l }).forEach((C) => {
        o.setQueryData(
          C.queryKey,
          (E) => {
            if (E)
              return {
                ...E,
                items: E.items.map((N) => N.id === b ? { ...N, name: v } : N)
              };
          }
        );
      });
    }
  };
}, Nl = ({
  limit: i = 10,
  order: e = pr.Next,
  sortColumn: t,
  sortDirection: r,
  filter: s
}, n) => {
  const a = Si(), o = [
    "infinite-data-files",
    { limit: i, order: e, sortColumn: t, sortDirection: r, filter: s }
  ];
  return { ...Sl({
    initialPageParam: void 0,
    queryKey: o,
    queryFn: ({ pageParam: u }) => yn({
      startFrom: typeof u == "string" ? u : void 0,
      limit: i,
      order: e,
      sortColumn: t,
      sortDirection: r,
      filter: s
    }),
    getPreviousPageParam: (u) => {
      if (!u.hasMore) return;
      const f = u.items[0];
      if (f)
        return encodeURIComponent(
          JSON.stringify({
            id: f.id,
            field: f[t ?? "name"]
          })
        );
    },
    getNextPageParam: (u) => {
      if (!u.hasMore) return;
      const f = u.items[u.items.length - 1];
      if (f)
        return encodeURIComponent(
          JSON.stringify({
            id: f.id,
            field: f[t ?? "name"]
          })
        );
    },
    ...n
  }), resetAndRefetch: () => {
    a.invalidateQueries({ queryKey: o });
  }, deleteItemFromData: (u) => {
    a.setQueryData(o, (f) => f && {
      ...f,
      pages: f.pages.map((g) => ({
        ...g,
        items: g.items.filter((b) => b.id !== u)
      }))
    });
  }, renameItemFromData: ({ id: u, name: f }) => {
    a.setQueryData(o, (g) => g && {
      ...g,
      pages: g.pages.map((b) => ({
        ...b,
        items: b.items.map((v) => v.id === u ? { ...v, name: f } : v)
      }))
    });
  } };
}, _l = ({ id: i }, e) => {
  const t = Si(), r = ["file-details", { id: i }];
  return { ...vn({
    queryKey: r,
    retry: !1,
    refetchInterval: !1,
    refetchOnWindowFocus: !1,
    enabled: typeof i < "u",
    queryFn: async ({ queryKey: a }) => {
      const [, { id: o }] = a;
      return (await mr.get("/api/dashboard/customer/data-files/" + o)).data;
    },
    ...e
  }), resetAndRefetch: () => {
    t.invalidateQueries({ queryKey: r });
  } };
}, bn = () => {
  const { fetcher: i } = vt({
    method: mt.delete
  }), { fetcher: e } = vt({
    method: mt.get
  }), { fetcher: t } = vt({
    method: mt.post
  });
  return { deleteFile: async ({ id: a }) => {
    await i("/api/dashboard/customer/data-files/" + a);
  }, downloadFile: async ({ id: a }) => {
    const { link: o } = await e(`/api/dashboard/customer/data-files/${a}/download-link`), l = document.createElement("a");
    l.setAttribute("href", o), l.setAttribute("download", ""), l.click();
  }, renameFile: async ({ id: a, name: o }) => await t(`/api/dashboard/customer/data-files/${a}/rename`, {
    name: o
  }) };
};
function Rl({
  isFetching: i,
  values: e,
  disabled: t,
  disabledFileSourceSelect: r,
  disabledFileTypeSelect: s,
  onChange: n,
  onSubmit: a
}) {
  const { t: o } = fe();
  return /* @__PURE__ */ A(
    "form",
    {
      onSubmit: (l) => {
        l.preventDefault(), l.stopPropagation(), a();
      },
      className: "flex flex-col gap-2 sm:grid sm:grid-cols-2 lg:flex lg:flex-row lg:items-end lg:flex-wrap",
      children: [
        /* @__PURE__ */ y(
          ea,
          {
            disabled: i || t,
            label: o("file_manager.file_selector.search_file"),
            placeholder: o("file_manager.search"),
            value: e.name,
            onClear: () => n == null ? void 0 : n({ ...e, name: "" }),
            onChange: (l) => n == null ? void 0 : n({ ...e, name: l.target.value }),
            showSearchIcon: !0,
            className: "lg:flex-2",
            labelClassName: "text-text-primary text-lg font-bold",
            searchIconClassName: "left-3 top-[31px]",
            closeIconClassName: "top-[31px]",
            inputClassName: "!pl-[40px] pr-4"
          }
        ),
        /* @__PURE__ */ y(
          Mr,
          {
            disabled: i || t || r,
            placeholder: o("file_manager.select_source"),
            value: e.source,
            data: Object.values(X).filter((l) => l !== X.BlockPreview && l !== X.Community).map((l) => ({
              id: l,
              caption: o(Sa[l])
            })),
            onChange: (l) => n == null ? void 0 : n({ ...e, source: l }),
            containerClassName: "self-auto sm:self-end"
          }
        ),
        /* @__PURE__ */ y(
          Mr,
          {
            disabled: i || t || s,
            placeholder: o("file_manager.select_type"),
            value: e.type,
            data: Object.values(Y).map((l) => ({
              id: l,
              caption: o(Oa[l])
            })),
            onChange: (l) => n == null ? void 0 : n({ ...e, type: l }),
            containerClassName: "self-auto sm:self-end"
          }
        ),
        /* @__PURE__ */ y(
          ti,
          {
            type: "submit",
            isFetching: i,
            disabled: t,
            className: "min-w-14",
            children: o("file_manager.search")
          }
        )
      ]
    }
  );
}
function dt(i, e, t) {
  let r = t.initialDeps ?? [], s;
  return () => {
    var n, a, o, l;
    let c;
    t.key && ((n = t.debug) != null && n.call(t)) && (c = Date.now());
    const h = i();
    if (!(h.length !== r.length || h.some((f, g) => r[g] !== f)))
      return s;
    r = h;
    let u;
    if (t.key && ((a = t.debug) != null && a.call(t)) && (u = Date.now()), s = e(...h), t.key && ((o = t.debug) != null && o.call(t))) {
      const f = Math.round((Date.now() - c) * 100) / 100, g = Math.round((Date.now() - u) * 100) / 100, b = g / 16, v = (O, C) => {
        for (O = String(O); O.length < C; )
          O = " " + O;
        return O;
      };
      console.info(
        `%c⏱ ${v(g, 5)} /${v(f, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * b, 120)
        )}deg 100% 31%);`,
        t == null ? void 0 : t.key
      );
    }
    return (l = t == null ? void 0 : t.onChange) == null || l.call(t, s), s;
  };
}
function Pi(i, e) {
  if (i === void 0)
    throw new Error("Unexpected undefined");
  return i;
}
const Dl = (i, e) => Math.abs(i - e) < 1, Pl = (i, e, t) => {
  let r;
  return function(...s) {
    i.clearTimeout(r), r = i.setTimeout(() => e.apply(this, s), t);
  };
}, Fl = (i) => i, Il = (i) => {
  const e = Math.max(i.startIndex - i.overscan, 0), t = Math.min(i.endIndex + i.overscan, i.count - 1), r = [];
  for (let s = e; s <= t; s++)
    r.push(s);
  return r;
}, Ml = (i, e) => {
  const t = i.scrollElement;
  if (!t)
    return;
  const r = i.targetWindow;
  if (!r)
    return;
  const s = (a) => {
    const { width: o, height: l } = a;
    e({ width: Math.round(o), height: Math.round(l) });
  };
  if (s(t.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const n = new r.ResizeObserver((a) => {
    const o = a[0];
    if (o != null && o.borderBoxSize) {
      const l = o.borderBoxSize[0];
      if (l) {
        s({ width: l.inlineSize, height: l.blockSize });
        return;
      }
    }
    s(t.getBoundingClientRect());
  });
  return n.observe(t, { box: "border-box" }), () => {
    n.unobserve(t);
  };
}, fs = {
  passive: !0
}, Tl = typeof window > "u" ? !0 : "onscrollend" in window, Ll = (i, e) => {
  const t = i.scrollElement;
  if (!t)
    return;
  const r = i.targetWindow;
  if (!r)
    return;
  let s = 0;
  const n = Tl ? () => {
  } : Pl(
    r,
    () => {
      e(s, !1);
    },
    i.options.isScrollingResetDelay
  ), a = (c) => () => {
    const { horizontal: h, isRtl: d } = i.options;
    s = h ? t.scrollLeft * (d && -1 || 1) : t.scrollTop, n(), e(s, c);
  }, o = a(!0), l = a(!1);
  return l(), t.addEventListener("scroll", o, fs), t.addEventListener("scrollend", l, fs), () => {
    t.removeEventListener("scroll", o), t.removeEventListener("scrollend", l);
  };
}, kl = (i, e, t) => {
  if (e != null && e.borderBoxSize) {
    const r = e.borderBoxSize[0];
    if (r)
      return Math.round(
        r[t.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    i.getBoundingClientRect()[t.options.horizontal ? "width" : "height"]
  );
}, Al = (i, {
  adjustments: e = 0,
  behavior: t
}, r) => {
  var s, n;
  const a = i + e;
  (n = (s = r.scrollElement) == null ? void 0 : s.scrollTo) == null || n.call(s, {
    [r.options.horizontal ? "left" : "top"]: a,
    behavior: t
  });
};
class jl {
  constructor(e) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let t = null;
      const r = () => t || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : t = new this.targetWindow.ResizeObserver((s) => {
        s.forEach((n) => {
          this._measureElement(n.target, n);
        });
      }));
      return {
        disconnect: () => {
          var s;
          (s = r()) == null || s.disconnect(), t = null;
        },
        observe: (s) => {
          var n;
          return (n = r()) == null ? void 0 : n.observe(s, { box: "border-box" });
        },
        unobserve: (s) => {
          var n;
          return (n = r()) == null ? void 0 : n.unobserve(s);
        }
      };
    })(), this.range = null, this.setOptions = (t) => {
      Object.entries(t).forEach(([r, s]) => {
        typeof s > "u" && delete t[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: Fl,
        rangeExtractor: Il,
        onChange: () => {
        },
        measureElement: kl,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        ...t
      };
    }, this.notify = (t) => {
      var r, s;
      (s = (r = this.options).onChange) == null || s.call(r, this, t);
    }, this.maybeNotify = dt(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (t) => {
        this.notify(t);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((t) => t()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var t;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((t = this.scrollElement) == null ? void 0 : t.window) ?? null, this.elementsCache.forEach((s) => {
          this.observer.observe(s);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (s) => {
            this.scrollRect = s, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (s, n) => {
            this.scrollAdjustments = 0, this.scrollDirection = n ? this.getScrollOffset() < s ? "forward" : "backward" : null, this.scrollOffset = s, this.isScrolling = n, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (t, r) => {
      const s = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
      for (let a = r - 1; a >= 0; a--) {
        const o = t[a];
        if (s.has(o.lane))
          continue;
        const l = n.get(
          o.lane
        );
        if (l == null || o.end > l.end ? n.set(o.lane, o) : o.end < l.end && s.set(o.lane, !0), s.size === this.options.lanes)
          break;
      }
      return n.size === this.options.lanes ? Array.from(n.values()).sort((a, o) => a.end === o.end ? a.index - o.index : a.end - o.end)[0] : void 0;
    }, this.getMeasurementOptions = dt(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (t, r, s, n, a) => (this.pendingMeasuredCacheIndexes = [], {
        count: t,
        paddingStart: r,
        scrollMargin: s,
        getItemKey: n,
        enabled: a
      }),
      {
        key: !1
      }
    ), this.getMeasurements = dt(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: t, paddingStart: r, scrollMargin: s, getItemKey: n, enabled: a }, o) => {
        if (!a)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((h) => {
          this.itemSizeCache.set(h.key, h.size);
        }));
        const l = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const c = this.measurementsCache.slice(0, l);
        for (let h = l; h < t; h++) {
          const d = n(h), u = this.options.lanes === 1 ? c[h - 1] : this.getFurthestMeasurement(c, h), f = u ? u.end + this.options.gap : r + s, g = o.get(d), b = typeof g == "number" ? g : this.options.estimateSize(h), v = f + b, O = u ? u.lane : h % this.options.lanes;
          c[h] = {
            index: h,
            start: f,
            size: b,
            end: v,
            key: d,
            lane: O
          };
        }
        return this.measurementsCache = c, c;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = dt(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (t, r, s) => this.range = t.length > 0 && r > 0 ? zl({
        measurements: t,
        outerSize: r,
        scrollOffset: s
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = dt(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (t, r, s, n) => r === null ? [] : t({
        startIndex: r.startIndex,
        endIndex: r.endIndex,
        overscan: s,
        count: n
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (t) => {
      const r = this.options.indexAttribute, s = t.getAttribute(r);
      return s ? parseInt(s, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (t, r) => {
      const s = this.indexFromElement(t), n = this.measurementsCache[s];
      if (!n)
        return;
      const a = n.key, o = this.elementsCache.get(a);
      o !== t && (o && this.observer.unobserve(o), this.observer.observe(t), this.elementsCache.set(a, t)), t.isConnected && this.resizeItem(s, this.options.measureElement(t, r, this));
    }, this.resizeItem = (t, r) => {
      const s = this.measurementsCache[t];
      if (!s)
        return;
      const n = this.itemSizeCache.get(s.key) ?? s.size, a = r - n;
      a !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(s, a, this) : s.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", a), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += a,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(s.index), this.itemSizeCache = new Map(this.itemSizeCache.set(s.key, r)), this.notify(!1));
    }, this.measureElement = (t) => {
      if (!t) {
        this.elementsCache.forEach((r, s) => {
          r.isConnected || (this.observer.unobserve(r), this.elementsCache.delete(s));
        });
        return;
      }
      this._measureElement(t, void 0);
    }, this.getVirtualItems = dt(
      () => [this.getIndexes(), this.getMeasurements()],
      (t, r) => {
        const s = [];
        for (let n = 0, a = t.length; n < a; n++) {
          const o = t[n], l = r[o];
          s.push(l);
        }
        return s;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (t) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return Pi(
          r[wn(
            0,
            r.length - 1,
            (s) => Pi(r[s]).start,
            t
          )]
        );
    }, this.getOffsetForAlignment = (t, r) => {
      const s = this.getSize(), n = this.getScrollOffset();
      r === "auto" && (t <= n ? r = "start" : t >= n + s ? r = "end" : r = "start"), r === "start" ? t = t : r === "end" ? t = t - s : r === "center" && (t = t - s / 2);
      const a = this.options.horizontal ? "scrollWidth" : "scrollHeight", l = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[a] : this.scrollElement[a] : 0) - s;
      return Math.max(Math.min(l, t), 0);
    }, this.getOffsetForIndex = (t, r = "auto") => {
      t = Math.max(0, Math.min(t, this.options.count - 1));
      const s = this.measurementsCache[t];
      if (!s)
        return;
      const n = this.getSize(), a = this.getScrollOffset();
      if (r === "auto")
        if (s.end >= a + n - this.options.scrollPaddingEnd)
          r = "end";
        else if (s.start <= a + this.options.scrollPaddingStart)
          r = "start";
        else
          return [a, r];
      const o = r === "end" ? s.end + this.options.scrollPaddingEnd : s.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(o, r), r];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (t, { align: r = "start", behavior: s } = {}) => {
      this.cancelScrollToIndex(), s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(t, r), {
        adjustments: void 0,
        behavior: s
      });
    }, this.scrollToIndex = (t, { align: r = "auto", behavior: s } = {}) => {
      t = Math.max(0, Math.min(t, this.options.count - 1)), this.cancelScrollToIndex(), s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const n = this.getOffsetForIndex(t, r);
      if (!n) return;
      const [a, o] = n;
      this._scrollToOffset(a, { adjustments: void 0, behavior: s }), s !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(t)
        )) {
          const [c] = Pi(
            this.getOffsetForIndex(t, o)
          );
          Dl(c, this.getScrollOffset()) || this.scrollToIndex(t, { align: o, behavior: s });
        } else
          this.scrollToIndex(t, { align: o, behavior: s });
      }));
    }, this.scrollBy = (t, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + t, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var t;
      const r = this.getMeasurements();
      let s;
      return r.length === 0 ? s = this.options.paddingStart : s = this.options.lanes === 1 ? ((t = r[r.length - 1]) == null ? void 0 : t.end) ?? 0 : Math.max(
        ...r.slice(-this.options.lanes).map((n) => n.end)
      ), Math.max(
        s - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (t, {
      adjustments: r,
      behavior: s
    }) => {
      this.options.scrollToFn(t, { behavior: s, adjustments: r }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(e);
  }
}
const wn = (i, e, t, r) => {
  for (; i <= e; ) {
    const s = (i + e) / 2 | 0, n = t(s);
    if (n < r)
      i = s + 1;
    else if (n > r)
      e = s - 1;
    else
      return s;
  }
  return i > 0 ? i - 1 : 0;
};
function zl({
  measurements: i,
  outerSize: e,
  scrollOffset: t
}) {
  const r = i.length - 1, n = wn(0, r, (o) => i[o].start, t);
  let a = n;
  for (; a < r && i[a].end < t + e; )
    a++;
  return { startIndex: n, endIndex: a };
}
const Ul = typeof document < "u" ? ce.useLayoutEffect : ce.useEffect;
function $l(i) {
  const e = ce.useReducer(() => ({}), {})[1], t = {
    ...i,
    onChange: (s, n) => {
      var a;
      n ? xa(e) : e(), (a = i.onChange) == null || a.call(i, s, n);
    }
  }, [r] = ce.useState(
    () => new jl(t)
  );
  return r.setOptions(t), ce.useEffect(() => r._didMount(), []), Ul(() => r._willUpdate()), r;
}
function ps(i) {
  return $l({
    observeElementRect: Ml,
    observeElementOffset: Ll,
    scrollToFn: Al,
    ...i
  });
}
const ir = 2, Bl = 6, Hl = ir * 2 + Bl;
function Wl({
  initialItemWidth: i = 150,
  initialItemHeight: e = 180,
  rowGap: t = 18,
  columnGap: r = 16,
  columnCount: s = 6,
  dataFilesApi: n,
  specialElementInGrid: a,
  onSelect: o,
  onDetails: l,
  onDelete: c,
  onRename: h,
  onDownload: d
}) {
  var ae;
  const u = Oe.useRef(null), f = Oe.useRef(null), [g, b] = W(s), [v, O] = W(i), [C, E] = W(e), [N, R] = W(), { data: m, fetchNextPage: S, hasNextPage: w, isFetchingNextPage: x, isFetching: _ } = n, F = "specialElementInGridId", I = a ? g >= 2 ? [F, F] : [F] : [], H = [...I, ...((ae = m == null ? void 0 : m.pages) == null ? void 0 : ae.flatMap((k) => k.items)) ?? []], z = H.length;
  Ee(() => {
    const k = () => {
      if (u.current) {
        const G = u.current.offsetWidth - Hl, K = Math.floor(G / (i + r));
        b(K || 1);
        const D = (G - r * (K - 1)) / K;
        O(D), E(D / i * e);
      }
    };
    k();
    const q = new ResizeObserver(k);
    return u.current && q.observe(u.current), () => q.disconnect();
  }, [i, e, r]);
  const M = ps({
    count: Math.ceil(z / g),
    gap: t,
    getScrollElement: () => u.current,
    estimateSize: () => C
  }), ee = ps({
    count: g,
    gap: r,
    getScrollElement: () => u.current,
    estimateSize: () => v,
    horizontal: !0
  });
  return Ee(() => {
    if (!f.current || !w || x) return;
    const k = new IntersectionObserver(
      (q) => {
        q[0].isIntersecting && S();
      },
      { root: u.current, threshold: 0.1 }
    );
    return k.observe(f.current), () => {
      f.current && k.unobserve(f.current);
    };
  }, [S, w, x]), Ee(() => {
    const k = H.filter(Ca).find((q) => q.id === N);
    o == null || o(k);
  }, [N]), /* @__PURE__ */ A(
    "div",
    {
      ref: u,
      className: "relative overflow-auto w-full h-[400px] customScroll",
      style: { paddingTop: ir, paddingLeft: ir },
      children: [
        /* @__PURE__ */ A(
          "div",
          {
            style: {
              height: M.getTotalSize(),
              width: ee.getTotalSize()
            },
            className: "relative",
            children: [
              _ && !x ? Array.from({ length: 10 }).map((k, q) => /* @__PURE__ */ y(
                "div",
                {
                  className: "absolute bg-background-tertiary animate-pulse rounded-md",
                  style: {
                    top: Math.floor(q / g) * (C + t),
                    left: q % g * (v + r),
                    height: C,
                    width: v
                  }
                },
                q
              )) : M.getVirtualItems().map(
                (k) => ee.getVirtualItems().map((q) => {
                  const G = k.index * g + q.index, K = H[G];
                  if (!K) return null;
                  let D = Math.floor(G / g) * (C + t);
                  const U = G % g * (v + r);
                  let V = 0;
                  switch (g) {
                    case 1:
                      V = 180;
                      break;
                    case 2:
                      V = 80;
                      break;
                  }
                  return a && (D = D - V), F === K ? G === 0 ? /* @__PURE__ */ y(
                    "div",
                    {
                      style: {
                        top: 0,
                        left: 0,
                        height: C - V,
                        width: v * I.length + r * (I.length - 1)
                      },
                      children: a
                    },
                    K + G
                  ) : null : /* @__PURE__ */ y(
                    Da,
                    {
                      src: K.thumbnail ?? K.path ?? void 0,
                      alt: K.name,
                      name: K.name,
                      imageWidth: v,
                      imageHeight: v * 0.869,
                      secondaryText: K.type,
                      fileType: K.type,
                      style: {
                        top: D,
                        left: U,
                        height: C,
                        width: v
                      },
                      selected: N === K.id,
                      onSelect: (we) => {
                        R(we ? K.id : void 0);
                      },
                      className: "absolute",
                      actionMenu: {
                        menuItems: [
                          l ? /* @__PURE__ */ y(
                            Uo,
                            {
                              onClick: () => l(K)
                            },
                            "details"
                          ) : void 0,
                          c ? /* @__PURE__ */ y(
                            $o,
                            {
                              onClick: () => c(K)
                            },
                            "delete"
                          ) : void 0,
                          h ? /* @__PURE__ */ y(
                            Bo,
                            {
                              onClick: () => h(K)
                            },
                            "rename"
                          ) : void 0,
                          d ? /* @__PURE__ */ y(
                            Ho,
                            {
                              onClick: () => d(K)
                            },
                            "download"
                          ) : void 0
                        ].filter(Boolean)
                      }
                    },
                    K.id
                  );
                })
              ),
              w && /* @__PURE__ */ y("div", { ref: f, className: "absolute bottom-0" })
            ]
          }
        ),
        /* @__PURE__ */ y("div", { className: "flex items-center justify-center w-full pt-4 h-11", children: x && /* @__PURE__ */ y(ta, {}) })
      ]
    }
  );
}
const Vl = "/api/dashboard/customer", xn = "/api/dashboard/customer/data-files", Kl = `${xn}/validate-and-get-upload-options`, Ql = (i) => `${xn}/${i}/activate-file`, ql = (i) => `${Vl}/draft-file/${i}`, Cn = "/api/data-files", Yl = `${Cn}/validate-and-get-upload-options`, Xl = (i) => `${Cn}/${i}/activate-file`, Gl = (i = !1) => {
  const { fetcher: e } = vt({
    method: mt.post
  }), { fetcher: t } = vt({
    method: mt.post
  }), { fetcher: r } = vt({
    method: mt.delete
  });
  return {
    validateAndGetUploadOptions: async ({
      file: l,
      isCommon: c,
      source: h,
      mimeType: d,
      cancelToken: u
    }) => await e(
      i ? Yl : Kl,
      {
        source: h,
        fileName: l.name,
        fileSize: l.size,
        mimeType: d,
        isCommon: c
      },
      {
        cancelToken: u
      }
    ),
    uploadToFileStore: async ({
      file: l,
      uploadOptions: c,
      progressHandler: h,
      cancelToken: d
    }) => {
      const u = new FormData();
      return u.append("key", c.key), u.append("acl", c.acl), u.append("X-Amz-Credential", c.credential), u.append("X-Amz-Algorithm", c.algorithm), u.append("X-Amz-Date", c.date), u.append("Policy", c.policy), u.append("X-Amz-Signature", c.signature), u.append("Content-Type", c.contentType), u.append("Cache-Control", c.cacheControl), u.append("file", l), await fr.post(c.url, u, {
        onUploadProgress: h,
        cancelToken: d
      });
    },
    activate: async ({
      fileId: l,
      cancelToken: c
    }) => await t(
      i ? Xl(l) : Ql(l),
      {},
      {
        cancelToken: c,
        headers: {
          "Content-Type": "application/json"
        }
      }
    ),
    removeDraftFile: async (l) => await r(ql(l))
  };
}, Jl = () => {
  let i;
  return {
    createToken: () => (i = fr.CancelToken.source(), i.token),
    cancel: () => {
      i && (i.cancel(), i = void 0);
    },
    getToken: () => i == null ? void 0 : i.token
  };
}, Zl = ({
  onChange: i
}) => {
  let e = {
    isUploading: !1,
    progress: 0,
    total: 0,
    isUploaded: !1
  };
  const t = () => {
    i(e);
  }, r = () => {
    e = {
      ...e,
      progress: 0,
      total: 0,
      isUploading: !0,
      isUploaded: !1
    }, t();
  }, s = () => {
    e = {
      ...e,
      isUploading: !1,
      isUploaded: !0
    }, t();
  }, n = (l, c) => {
    c && (e = {
      ...e,
      progress: Math.round(l * 100 / c),
      total: c
    }, t());
  };
  return {
    getState: () => e,
    startProgress: r,
    finishProgress: s,
    updateProgress: n,
    resetProgress: () => {
      e = {
        progress: 0,
        total: 0,
        isUploading: !1,
        isUploaded: !1
      }, t();
    },
    progressHandler: (l) => {
      const c = l.loaded, h = l.total;
      n(c, h);
    }
  };
}, ec = (i) => {
  const e = i.name.match(/\.[a-zA-Z0-9_-]+$/i);
  switch (e && e[0]) {
    case ze.Docx:
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case ze.Doc:
      return "application/msword";
    case ze.Ttf:
      return "font/ttf";
    case ze.AD_PRT:
      return "application/vnd.alibre.part";
    case ze.AD_SMP:
      return "application/vnd.alibre.sheet_metal_part";
    case ze.AD_ASM:
      return "application/vnd.alibre.assembly";
    case ze.AD_DRW:
      return "application/vnd.alibre.drawing";
    default:
      return i.type;
  }
}, Sn = (i) => {
  const { t: e } = fe(), { validateAndGetUploadOptions: t, uploadToFileStore: r, activate: s, removeDraftFile: n } = Gl(i);
  return {
    createFileUploader: (o) => {
      const l = Zl({ onChange: o }), c = Jl();
      return {
        progress: l,
        upload: async ({
          file: u,
          source: f,
          isCommon: g = !1
        }) => {
          l.startProgress();
          const b = c.createToken();
          let v;
          try {
            const { uploadOptions: O, id: C } = await t({
              file: u,
              isCommon: g,
              source: f,
              mimeType: ec(u),
              cancelToken: b
            });
            v = C, await r({
              file: u,
              uploadOptions: O,
              progressHandler: l.progressHandler,
              cancelToken: b
            });
            const E = await s({
              fileId: C,
              cancelToken: b
            });
            return l.finishProgress(), E[C];
          } catch (O) {
            if (fr.isCancel(O)) {
              ye(e("file_manager.cancelled"));
              return;
            }
            throw typeof v == "number" ? await n(v) : ye.error(e("file_manager.error")), O;
          }
        },
        cancelUpload: () => {
          c.cancel(), l.resetProgress();
        }
      };
    }
  };
}, tc = ({
  preLoadedFiles: i,
  source: e,
  usePublicApi: t,
  onChange: r
}) => {
  const { t: s } = fe(), { createFileUploader: n } = Sn(t), { deleteFile: a } = bn(), [o, l] = W([]), [c, h] = W([]), [d, u] = W({}), [f, g] = W([]), b = (w) => {
    const x = i == null ? void 0 : i.map((_) => _.id);
    return x == null ? void 0 : x.includes(w.id);
  }, v = () => c.map((x) => {
    const _ = !b(x);
    return {
      file: { ...x, name: x.filename },
      disabled: f.includes(x.id),
      uploaded: _
    };
  }), O = () => Object.entries(d).map(([x, _]) => ({
    file: { ..._, id: x, name: _.file.name },
    progress: _.progress.isUploading ? _.progress.progress : void 0,
    uploaded: _.progress.isUploaded
  })), C = v(), E = O(), N = async (w) => {
    try {
      g((x) => [...x, w]), await a({ id: w }), h((x) => {
        const _ = x.filter((F) => F.id !== w);
        return r == null || r(_), _;
      });
    } catch (x) {
      throw x;
    } finally {
      g((x) => x.filter((_) => _ !== w));
    }
  }, R = (w) => {
    d[w].cancelUpload(), u((x) => {
      const { [w]: _, ...F } = x;
      return F;
    });
  };
  return {
    waitingUploadFiles: o,
    setWaitingUploadFiles: l,
    removingFiles: f,
    uploadedFiles: c,
    setUploadedFiles: h,
    mappedUploadedFiles: C,
    mappedUploadingFiles: E,
    startUploading: async (w) => {
      const x = await Ao(w) + "_" + crypto.randomUUID(), F = n((I) => {
        u((H) => ({
          ...H,
          [x]: {
            ...H[x],
            progress: I
          }
        }));
      });
      l((I) => I.filter((H) => H.file !== w)), u((I) => ({
        ...I,
        [x]: {
          file: w,
          progress: F.progress.getState(),
          cancelUpload: F.cancelUpload
        }
      }));
      try {
        const I = await F.upload({ file: w, source: e });
        if (I)
          return h((H) => {
            const z = [{ ...I, file: w }, ...H];
            return r == null || r(z), z;
          }), I;
      } catch (I) {
        const H = I instanceof Error ? I : new Error(s("file_manager.error"));
        throw l((z) => [{ file: w, error: H }, ...z]), I;
      } finally {
        u((I) => {
          const { [x]: H, ...z } = I;
          return z;
        });
      }
    },
    deleteUploadedOrUploadingFile: async (w) => {
      d[w] && await R(String(w)), c.find((F) => F.id === +w) && await N(Number(w));
    },
    deleteUploadedFile: N,
    deleteUploadingFile: R
  };
}, ic = (i) => i instanceof File, rc = (i) => "id" in i && "file" in i, sc = (i) => "id" in i && "path" in i && "size" in i && "type" in i && "filename" in i && "thumbnail" in i, nc = ({ progress: i }) => {
  const t = 2 * Math.PI * 14, r = t * (1 - i / 100);
  return /* @__PURE__ */ A("div", { className: "relative w-8 h-8", children: [
    /* @__PURE__ */ y("svg", { className: "w-full h-full", children: /* @__PURE__ */ y(
      "circle",
      {
        cx: "50%",
        cy: "50%",
        r: 14,
        className: "stroke-text-secondary fill-none",
        strokeWidth: "3"
      }
    ) }),
    /* @__PURE__ */ y("svg", { className: "absolute top-0 left-0 w-full h-full", children: /* @__PURE__ */ y(
      "circle",
      {
        cx: "50%",
        cy: "50%",
        r: 14,
        className: "stroke-background-secondary fill-none transition-all duration-300",
        strokeWidth: "3",
        strokeDasharray: t,
        strokeDashoffset: r,
        transform: "rotate(-90 16 16)"
      }
    ) })
  ] });
};
function Fi({
  file: i,
  progress: e = 0,
  isError: t,
  isLoading: r,
  isLoaded: s,
  isDeleting: n,
  className: a,
  disabled: o,
  disabledDeleteButton: l,
  showDeleteButton: c,
  showEditButton: h,
  onDeleteFile: d,
  onEdit: u
}) {
  return /* @__PURE__ */ A(
    "div",
    {
      className: ie("relative w-24 h-24", a),
      onClick: (f) => f.stopPropagation(),
      children: [
        c && /* @__PURE__ */ y(
          "button",
          {
            type: "button",
            className: ie(
              "absolute group -top-2 -right-2 z-1 rounded-full bg-background-primary",
              n && "animate-pulse"
            ),
            onClick: (f) => {
              f.preventDefault(), f.stopPropagation(), d();
            },
            disabled: l || o,
            children: /* @__PURE__ */ y(
              Lr,
              {
                className: ie(
                  "fill-text-secondary transition-colors",
                  !l && !o && "group-hover:fill-brand-primary"
                )
              }
            )
          }
        ),
        /* @__PURE__ */ A("div", { className: "relative w-full h-full group/edit", children: [
          i instanceof File ? /* @__PURE__ */ y(rn, { file: i, className: "w-full h-full rounded-md" }) : /* @__PURE__ */ y(
            ot,
            {
              src: i.thumbnail || i.path,
              fileType: i.type,
              isThumbnail: !0,
              className: "w-full h-full rounded-md",
              title: i.filename
            }
          ),
          /* @__PURE__ */ y(
            "div",
            {
              className: ie(
                "absolute top-0 left-0 w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md cursor-auto hidden",
                h && !o && "flex lg:hidden group-hover/edit:lg:flex"
              ),
              children: /* @__PURE__ */ y("div", { onClick: u, className: "cursor-pointer group p-2", children: /* @__PURE__ */ y(pa, { className: "fill-background-secondary group-hover:fill-brand-primary transition-colors" }) })
            }
          )
        ] }),
        t && /* @__PURE__ */ y("div", { className: "absolute top-0 left-0 flex w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md", children: /* @__PURE__ */ y(Lr, { className: "fill-danger rounded-full" }) }),
        r && /* @__PURE__ */ y("div", { className: "absolute top-0 left-0 flex w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md", children: /* @__PURE__ */ y(nc, { progress: e }) })
      ]
    }
  );
}
var On = /* @__PURE__ */ ((i) => (i[i.Small = 0] = "Small", i[i.Medium = 1] = "Medium", i[i.Big = 2] = "Big", i))(On || {});
const ac = {
  0: "p-2",
  1: "p-3",
  2: "p-10"
};
function En({
  acceptTypes: i,
  children: e,
  dropZoneClassName: t,
  className: r,
  disabled: s,
  error: n,
  variant: a = On.Medium,
  label: o,
  icon: l = /* @__PURE__ */ y(ga, {}),
  isPreFetching: c,
  toastText: h,
  labelClassName: d,
  openNativeWindow: u = !0,
  onSelectFile: f,
  onClick: g
}) {
  const { t: b } = fe(), v = be(null), [O, C] = W(!1), [E, N] = W(""), R = (_) => {
    var F;
    _.preventDefault(), !s && (g == null || g(), u && ((F = v.current) == null || F.click()));
  }, m = (_) => {
    if (_.target.files && _.target.files[0]) {
      const F = _.target.files[0];
      i && !ss(F.type, i) ? N(b("file_manager.file_upload.file_not_supported")) : (f(F), h && ye.success(h));
    }
    _.target.value = "";
  }, S = (_) => {
    _.preventDefault(), C(!0);
  }, w = (_) => {
    _.preventDefault(), C(!1);
  }, x = (_) => {
    _.preventDefault(), _.stopPropagation();
    const { files: F } = _.dataTransfer;
    if (F && F.length) {
      const I = F[0];
      i && !ss(I.type, i) ? N(b("file_manager.file_upload.file_not_supported")) : (f(I), h && ye.success(h));
    }
    C(!1);
  };
  return /* @__PURE__ */ A("div", { className: ie("font-medium", r), children: [
    /* @__PURE__ */ y(
      "input",
      {
        ref: v,
        type: "file",
        className: "invisible absolute h-1 w-0",
        onChange: m,
        disabled: c || s,
        accept: i && jo(i)
      }
    ),
    /* @__PURE__ */ A(
      "button",
      {
        type: "button",
        className: ie(
          "bg-background-primary ring-brand-primary flex min-h-[60px] w-full flex-row flex-wrap gap-3 rounded-lg border border-dashed outline-hidden ring-offset-1 focus-visible:ring-2",
          O ? "border-brand-primary" : "border-text-secondary",
          ac[a],
          c && "animate-pulse",
          s || c ? "pointer-events-none" : "hover:border-brand-primary cursor-pointer",
          t
        ),
        onDragStart: S,
        onDragLeave: w,
        onDrop: x,
        onDragOver: S,
        onClick: R,
        children: [
          !!la.count(e) && /* @__PURE__ */ y("div", { className: "flex w-full flex-wrap gap-3", children: e }),
          /* @__PURE__ */ A(
            "div",
            {
              className: ie(
                "flex w-full flex-col items-center justify-center gap-1",
                d
              ),
              children: [
                l,
                o ?? b("file_manager.file_upload.drop_files_here")
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ y(ui, { error: E, errorClassName: "text-center mt-2" }),
    /* @__PURE__ */ y(ui, { error: n, errorClassName: "text-center mt-2" })
  ] });
}
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */
function gs(i, e) {
  var t = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(i);
    e && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(i, s).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Nn(i) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? gs(Object(t), !0).forEach(function(r) {
      uc(i, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t)) : gs(Object(t)).forEach(function(r) {
      Object.defineProperty(i, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return i;
}
function oc(i, e) {
  if (typeof i != "object" || !i) return i;
  var t = i[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(i, e);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(i);
}
function _n(i) {
  var e = oc(i, "string");
  return typeof e == "symbol" ? e : e + "";
}
function rr(i) {
  "@babel/helpers - typeof";
  return rr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, rr(i);
}
function lc(i, e) {
  if (!(i instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ms(i, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(i, _n(r.key), r);
  }
}
function cc(i, e, t) {
  return e && ms(i.prototype, e), t && ms(i, t), Object.defineProperty(i, "prototype", {
    writable: !1
  }), i;
}
function uc(i, e, t) {
  return e = _n(e), e in i ? Object.defineProperty(i, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[e] = t, i;
}
function Rn(i) {
  return hc(i) || dc(i) || fc(i) || pc();
}
function hc(i) {
  if (Array.isArray(i)) return sr(i);
}
function dc(i) {
  if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null) return Array.from(i);
}
function fc(i, e) {
  if (i) {
    if (typeof i == "string") return sr(i, e);
    var t = Object.prototype.toString.call(i).slice(8, -1);
    if (t === "Object" && i.constructor && (t = i.constructor.name), t === "Map" || t === "Set") return Array.from(i);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return sr(i, e);
  }
}
function sr(i, e) {
  (e == null || e > i.length) && (e = i.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = i[t];
  return r;
}
function pc() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Oi = typeof window < "u" && typeof window.document < "u", ke = Oi ? window : {}, wr = Oi && ke.document.documentElement ? "ontouchstart" in ke.document.documentElement : !1, xr = Oi ? "PointerEvent" in ke : !1, J = "cropper", Cr = "all", Dn = "crop", Pn = "move", Fn = "zoom", Ge = "e", Je = "w", ft = "s", je = "n", jt = "ne", zt = "nw", Ut = "se", $t = "sw", nr = "".concat(J, "-crop"), vs = "".concat(J, "-disabled"), me = "".concat(J, "-hidden"), ys = "".concat(J, "-hide"), gc = "".concat(J, "-invisible"), yi = "".concat(J, "-modal"), ar = "".concat(J, "-move"), Yt = "".concat(J, "Action"), li = "".concat(J, "Preview"), Sr = "crop", In = "move", Mn = "none", or = "crop", lr = "cropend", cr = "cropmove", ur = "cropstart", bs = "dblclick", mc = wr ? "touchstart" : "mousedown", vc = wr ? "touchmove" : "mousemove", yc = wr ? "touchend touchcancel" : "mouseup", ws = xr ? "pointerdown" : mc, xs = xr ? "pointermove" : vc, Cs = xr ? "pointerup pointercancel" : yc, Ss = "ready", Os = "resize", Es = "wheel", hr = "zoom", Ns = "image/jpeg", bc = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, wc = /^data:/, xc = /^data:image\/jpeg;base64,/, Cc = /^img|canvas$/i, Tn = 200, Ln = 100, _s = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: Sr,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: Tn,
  minContainerHeight: Ln,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, Sc = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', Oc = Number.isNaN || ke.isNaN;
function j(i) {
  return typeof i == "number" && !Oc(i);
}
var Rs = function(e) {
  return e > 0 && e < 1 / 0;
};
function Ii(i) {
  return typeof i > "u";
}
function ct(i) {
  return rr(i) === "object" && i !== null;
}
var Ec = Object.prototype.hasOwnProperty;
function pt(i) {
  if (!ct(i))
    return !1;
  try {
    var e = i.constructor, t = e.prototype;
    return e && t && Ec.call(t, "isPrototypeOf");
  } catch {
    return !1;
  }
}
function ge(i) {
  return typeof i == "function";
}
var Nc = Array.prototype.slice;
function kn(i) {
  return Array.from ? Array.from(i) : Nc.call(i);
}
function ne(i, e) {
  return i && ge(e) && (Array.isArray(i) || j(i.length) ? kn(i).forEach(function(t, r) {
    e.call(i, t, r, i);
  }) : ct(i) && Object.keys(i).forEach(function(t) {
    e.call(i, i[t], t, i);
  })), i;
}
var Z = Object.assign || function(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
    r[s - 1] = arguments[s];
  return ct(e) && r.length > 0 && r.forEach(function(n) {
    ct(n) && Object.keys(n).forEach(function(a) {
      e[a] = n[a];
    });
  }), e;
}, _c = /\.\d*(?:0|9){12}\d*$/;
function bt(i) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return _c.test(i) ? Math.round(i * e) / e : i;
}
var Rc = /^width|height|left|top|marginLeft|marginTop$/;
function qe(i, e) {
  var t = i.style;
  ne(e, function(r, s) {
    Rc.test(s) && j(r) && (r = "".concat(r, "px")), t[s] = r;
  });
}
function Dc(i, e) {
  return i.classList ? i.classList.contains(e) : i.className.indexOf(e) > -1;
}
function oe(i, e) {
  if (e) {
    if (j(i.length)) {
      ne(i, function(r) {
        oe(r, e);
      });
      return;
    }
    if (i.classList) {
      i.classList.add(e);
      return;
    }
    var t = i.className.trim();
    t ? t.indexOf(e) < 0 && (i.className = "".concat(t, " ").concat(e)) : i.className = e;
  }
}
function Le(i, e) {
  if (e) {
    if (j(i.length)) {
      ne(i, function(t) {
        Le(t, e);
      });
      return;
    }
    if (i.classList) {
      i.classList.remove(e);
      return;
    }
    i.className.indexOf(e) >= 0 && (i.className = i.className.replace(e, ""));
  }
}
function gt(i, e, t) {
  if (e) {
    if (j(i.length)) {
      ne(i, function(r) {
        gt(r, e, t);
      });
      return;
    }
    t ? oe(i, e) : Le(i, e);
  }
}
var Pc = /([a-z\d])([A-Z])/g;
function Or(i) {
  return i.replace(Pc, "$1-$2").toLowerCase();
}
function dr(i, e) {
  return ct(i[e]) ? i[e] : i.dataset ? i.dataset[e] : i.getAttribute("data-".concat(Or(e)));
}
function Xt(i, e, t) {
  ct(t) ? i[e] = t : i.dataset ? i.dataset[e] = t : i.setAttribute("data-".concat(Or(e)), t);
}
function Fc(i, e) {
  if (ct(i[e]))
    try {
      delete i[e];
    } catch {
      i[e] = void 0;
    }
  else if (i.dataset)
    try {
      delete i.dataset[e];
    } catch {
      i.dataset[e] = void 0;
    }
  else
    i.removeAttribute("data-".concat(Or(e)));
}
var An = /\s\s*/, jn = (function() {
  var i = !1;
  if (Oi) {
    var e = !1, t = function() {
    }, r = Object.defineProperty({}, "once", {
      get: function() {
        return i = !0, e;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function(n) {
        e = n;
      }
    });
    ke.addEventListener("test", t, r), ke.removeEventListener("test", t, r);
  }
  return i;
})();
function _e(i, e, t) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, s = t;
  e.trim().split(An).forEach(function(n) {
    if (!jn) {
      var a = i.listeners;
      a && a[n] && a[n][t] && (s = a[n][t], delete a[n][t], Object.keys(a[n]).length === 0 && delete a[n], Object.keys(a).length === 0 && delete i.listeners);
    }
    i.removeEventListener(n, s, r);
  });
}
function xe(i, e, t) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, s = t;
  e.trim().split(An).forEach(function(n) {
    if (r.once && !jn) {
      var a = i.listeners, o = a === void 0 ? {} : a;
      s = function() {
        delete o[n][t], i.removeEventListener(n, s, r);
        for (var c = arguments.length, h = new Array(c), d = 0; d < c; d++)
          h[d] = arguments[d];
        t.apply(i, h);
      }, o[n] || (o[n] = {}), o[n][t] && i.removeEventListener(n, o[n][t], r), o[n][t] = s, i.listeners = o;
    }
    i.addEventListener(n, s, r);
  });
}
function wt(i, e, t) {
  var r;
  return ge(Event) && ge(CustomEvent) ? r = new CustomEvent(e, {
    detail: t,
    bubbles: !0,
    cancelable: !0
  }) : (r = document.createEvent("CustomEvent"), r.initCustomEvent(e, !0, !0, t)), i.dispatchEvent(r);
}
function zn(i) {
  var e = i.getBoundingClientRect();
  return {
    left: e.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: e.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var Mi = ke.location, Ic = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function Ds(i) {
  var e = i.match(Ic);
  return e !== null && (e[1] !== Mi.protocol || e[2] !== Mi.hostname || e[3] !== Mi.port);
}
function Ps(i) {
  var e = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return i + (i.indexOf("?") === -1 ? "?" : "&") + e;
}
function Wt(i) {
  var e = i.rotate, t = i.scaleX, r = i.scaleY, s = i.translateX, n = i.translateY, a = [];
  j(s) && s !== 0 && a.push("translateX(".concat(s, "px)")), j(n) && n !== 0 && a.push("translateY(".concat(n, "px)")), j(e) && e !== 0 && a.push("rotate(".concat(e, "deg)")), j(t) && t !== 1 && a.push("scaleX(".concat(t, ")")), j(r) && r !== 1 && a.push("scaleY(".concat(r, ")"));
  var o = a.length ? a.join(" ") : "none";
  return {
    WebkitTransform: o,
    msTransform: o,
    transform: o
  };
}
function Mc(i) {
  var e = Nn({}, i), t = 0;
  return ne(i, function(r, s) {
    delete e[s], ne(e, function(n) {
      var a = Math.abs(r.startX - n.startX), o = Math.abs(r.startY - n.startY), l = Math.abs(r.endX - n.endX), c = Math.abs(r.endY - n.endY), h = Math.sqrt(a * a + o * o), d = Math.sqrt(l * l + c * c), u = (d - h) / h;
      Math.abs(u) > Math.abs(t) && (t = u);
    });
  }), t;
}
function ci(i, e) {
  var t = i.pageX, r = i.pageY, s = {
    endX: t,
    endY: r
  };
  return e ? s : Nn({
    startX: t,
    startY: r
  }, s);
}
function Tc(i) {
  var e = 0, t = 0, r = 0;
  return ne(i, function(s) {
    var n = s.startX, a = s.startY;
    e += n, t += a, r += 1;
  }), e /= r, t /= r, {
    pageX: e,
    pageY: t
  };
}
function Ye(i) {
  var e = i.aspectRatio, t = i.height, r = i.width, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", n = Rs(r), a = Rs(t);
  if (n && a) {
    var o = t * e;
    s === "contain" && o > r || s === "cover" && o < r ? t = r / e : r = t * e;
  } else n ? t = r / e : a && (r = t * e);
  return {
    width: r,
    height: t
  };
}
function Lc(i) {
  var e = i.width, t = i.height, r = i.degree;
  if (r = Math.abs(r) % 180, r === 90)
    return {
      width: t,
      height: e
    };
  var s = r % 90 * Math.PI / 180, n = Math.sin(s), a = Math.cos(s), o = e * a + t * n, l = e * n + t * a;
  return r > 90 ? {
    width: l,
    height: o
  } : {
    width: o,
    height: l
  };
}
function kc(i, e, t, r) {
  var s = e.aspectRatio, n = e.naturalWidth, a = e.naturalHeight, o = e.rotate, l = o === void 0 ? 0 : o, c = e.scaleX, h = c === void 0 ? 1 : c, d = e.scaleY, u = d === void 0 ? 1 : d, f = t.aspectRatio, g = t.naturalWidth, b = t.naturalHeight, v = r.fillColor, O = v === void 0 ? "transparent" : v, C = r.imageSmoothingEnabled, E = C === void 0 ? !0 : C, N = r.imageSmoothingQuality, R = N === void 0 ? "low" : N, m = r.maxWidth, S = m === void 0 ? 1 / 0 : m, w = r.maxHeight, x = w === void 0 ? 1 / 0 : w, _ = r.minWidth, F = _ === void 0 ? 0 : _, I = r.minHeight, H = I === void 0 ? 0 : I, z = document.createElement("canvas"), M = z.getContext("2d"), ee = Ye({
    aspectRatio: f,
    width: S,
    height: x
  }), ae = Ye({
    aspectRatio: f,
    width: F,
    height: H
  }, "cover"), k = Math.min(ee.width, Math.max(ae.width, g)), q = Math.min(ee.height, Math.max(ae.height, b)), G = Ye({
    aspectRatio: s,
    width: S,
    height: x
  }), K = Ye({
    aspectRatio: s,
    width: F,
    height: H
  }, "cover"), D = Math.min(G.width, Math.max(K.width, n)), U = Math.min(G.height, Math.max(K.height, a)), V = [-D / 2, -U / 2, D, U];
  return z.width = bt(k), z.height = bt(q), M.fillStyle = O, M.fillRect(0, 0, k, q), M.save(), M.translate(k / 2, q / 2), M.rotate(l * Math.PI / 180), M.scale(h, u), M.imageSmoothingEnabled = E, M.imageSmoothingQuality = R, M.drawImage.apply(M, [i].concat(Rn(V.map(function(we) {
    return Math.floor(bt(we));
  })))), M.restore(), z;
}
var Un = String.fromCharCode;
function Ac(i, e, t) {
  var r = "";
  t += e;
  for (var s = e; s < t; s += 1)
    r += Un(i.getUint8(s));
  return r;
}
var jc = /^data:.*,/;
function zc(i) {
  var e = i.replace(jc, ""), t = atob(e), r = new ArrayBuffer(t.length), s = new Uint8Array(r);
  return ne(s, function(n, a) {
    s[a] = t.charCodeAt(a);
  }), r;
}
function Uc(i, e) {
  for (var t = [], r = 8192, s = new Uint8Array(i); s.length > 0; )
    t.push(Un.apply(null, kn(s.subarray(0, r)))), s = s.subarray(r);
  return "data:".concat(e, ";base64,").concat(btoa(t.join("")));
}
function $c(i) {
  var e = new DataView(i), t;
  try {
    var r, s, n;
    if (e.getUint8(0) === 255 && e.getUint8(1) === 216)
      for (var a = e.byteLength, o = 2; o + 1 < a; ) {
        if (e.getUint8(o) === 255 && e.getUint8(o + 1) === 225) {
          s = o;
          break;
        }
        o += 1;
      }
    if (s) {
      var l = s + 4, c = s + 10;
      if (Ac(e, l, 4) === "Exif") {
        var h = e.getUint16(c);
        if (r = h === 18761, (r || h === 19789) && e.getUint16(c + 2, r) === 42) {
          var d = e.getUint32(c + 4, r);
          d >= 8 && (n = c + d);
        }
      }
    }
    if (n) {
      var u = e.getUint16(n, r), f, g;
      for (g = 0; g < u; g += 1)
        if (f = n + g * 12 + 2, e.getUint16(f, r) === 274) {
          f += 8, t = e.getUint16(f, r), e.setUint16(f, 1, r);
          break;
        }
    }
  } catch {
    t = 1;
  }
  return t;
}
function Bc(i) {
  var e = 0, t = 1, r = 1;
  switch (i) {
    // Flip horizontal
    case 2:
      t = -1;
      break;
    // Rotate left 180°
    case 3:
      e = -180;
      break;
    // Flip vertical
    case 4:
      r = -1;
      break;
    // Flip vertical and rotate right 90°
    case 5:
      e = 90, r = -1;
      break;
    // Rotate right 90°
    case 6:
      e = 90;
      break;
    // Flip horizontal and rotate right 90°
    case 7:
      e = 90, t = -1;
      break;
    // Rotate left 90°
    case 8:
      e = -90;
      break;
  }
  return {
    rotate: e,
    scaleX: t,
    scaleY: r
  };
}
var Hc = {
  render: function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  },
  initContainer: function() {
    var e = this.element, t = this.options, r = this.container, s = this.cropper, n = Number(t.minContainerWidth), a = Number(t.minContainerHeight);
    oe(s, me), Le(e, me);
    var o = {
      width: Math.max(r.offsetWidth, n >= 0 ? n : Tn),
      height: Math.max(r.offsetHeight, a >= 0 ? a : Ln)
    };
    this.containerData = o, qe(s, {
      width: o.width,
      height: o.height
    }), oe(e, me), Le(s, me);
  },
  // Canvas (image wrapper)
  initCanvas: function() {
    var e = this.containerData, t = this.imageData, r = this.options.viewMode, s = Math.abs(t.rotate) % 180 === 90, n = s ? t.naturalHeight : t.naturalWidth, a = s ? t.naturalWidth : t.naturalHeight, o = n / a, l = e.width, c = e.height;
    e.height * o > e.width ? r === 3 ? l = e.height * o : c = e.width / o : r === 3 ? c = e.width / o : l = e.height * o;
    var h = {
      aspectRatio: o,
      naturalWidth: n,
      naturalHeight: a,
      width: l,
      height: c
    };
    this.canvasData = h, this.limited = r === 1 || r === 2, this.limitCanvas(!0, !0), h.width = Math.min(Math.max(h.width, h.minWidth), h.maxWidth), h.height = Math.min(Math.max(h.height, h.minHeight), h.maxHeight), h.left = (e.width - h.width) / 2, h.top = (e.height - h.height) / 2, h.oldLeft = h.left, h.oldTop = h.top, this.initialCanvasData = Z({}, h);
  },
  limitCanvas: function(e, t) {
    var r = this.options, s = this.containerData, n = this.canvasData, a = this.cropBoxData, o = r.viewMode, l = n.aspectRatio, c = this.cropped && a;
    if (e) {
      var h = Number(r.minCanvasWidth) || 0, d = Number(r.minCanvasHeight) || 0;
      o > 1 ? (h = Math.max(h, s.width), d = Math.max(d, s.height), o === 3 && (d * l > h ? h = d * l : d = h / l)) : o > 0 && (h ? h = Math.max(h, c ? a.width : 0) : d ? d = Math.max(d, c ? a.height : 0) : c && (h = a.width, d = a.height, d * l > h ? h = d * l : d = h / l));
      var u = Ye({
        aspectRatio: l,
        width: h,
        height: d
      });
      h = u.width, d = u.height, n.minWidth = h, n.minHeight = d, n.maxWidth = 1 / 0, n.maxHeight = 1 / 0;
    }
    if (t)
      if (o > (c ? 0 : 1)) {
        var f = s.width - n.width, g = s.height - n.height;
        n.minLeft = Math.min(0, f), n.minTop = Math.min(0, g), n.maxLeft = Math.max(0, f), n.maxTop = Math.max(0, g), c && this.limited && (n.minLeft = Math.min(a.left, a.left + (a.width - n.width)), n.minTop = Math.min(a.top, a.top + (a.height - n.height)), n.maxLeft = a.left, n.maxTop = a.top, o === 2 && (n.width >= s.width && (n.minLeft = Math.min(0, f), n.maxLeft = Math.max(0, f)), n.height >= s.height && (n.minTop = Math.min(0, g), n.maxTop = Math.max(0, g))));
      } else
        n.minLeft = -n.width, n.minTop = -n.height, n.maxLeft = s.width, n.maxTop = s.height;
  },
  renderCanvas: function(e, t) {
    var r = this.canvasData, s = this.imageData;
    if (t) {
      var n = Lc({
        width: s.naturalWidth * Math.abs(s.scaleX || 1),
        height: s.naturalHeight * Math.abs(s.scaleY || 1),
        degree: s.rotate || 0
      }), a = n.width, o = n.height, l = r.width * (a / r.naturalWidth), c = r.height * (o / r.naturalHeight);
      r.left -= (l - r.width) / 2, r.top -= (c - r.height) / 2, r.width = l, r.height = c, r.aspectRatio = a / o, r.naturalWidth = a, r.naturalHeight = o, this.limitCanvas(!0, !1);
    }
    (r.width > r.maxWidth || r.width < r.minWidth) && (r.left = r.oldLeft), (r.height > r.maxHeight || r.height < r.minHeight) && (r.top = r.oldTop), r.width = Math.min(Math.max(r.width, r.minWidth), r.maxWidth), r.height = Math.min(Math.max(r.height, r.minHeight), r.maxHeight), this.limitCanvas(!1, !0), r.left = Math.min(Math.max(r.left, r.minLeft), r.maxLeft), r.top = Math.min(Math.max(r.top, r.minTop), r.maxTop), r.oldLeft = r.left, r.oldTop = r.top, qe(this.canvas, Z({
      width: r.width,
      height: r.height
    }, Wt({
      translateX: r.left,
      translateY: r.top
    }))), this.renderImage(e), this.cropped && this.limited && this.limitCropBox(!0, !0);
  },
  renderImage: function(e) {
    var t = this.canvasData, r = this.imageData, s = r.naturalWidth * (t.width / t.naturalWidth), n = r.naturalHeight * (t.height / t.naturalHeight);
    Z(r, {
      width: s,
      height: n,
      left: (t.width - s) / 2,
      top: (t.height - n) / 2
    }), qe(this.image, Z({
      width: r.width,
      height: r.height
    }, Wt(Z({
      translateX: r.left,
      translateY: r.top
    }, r)))), e && this.output();
  },
  initCropBox: function() {
    var e = this.options, t = this.canvasData, r = e.aspectRatio || e.initialAspectRatio, s = Number(e.autoCropArea) || 0.8, n = {
      width: t.width,
      height: t.height
    };
    r && (t.height * r > t.width ? n.height = n.width / r : n.width = n.height * r), this.cropBoxData = n, this.limitCropBox(!0, !0), n.width = Math.min(Math.max(n.width, n.minWidth), n.maxWidth), n.height = Math.min(Math.max(n.height, n.minHeight), n.maxHeight), n.width = Math.max(n.minWidth, n.width * s), n.height = Math.max(n.minHeight, n.height * s), n.left = t.left + (t.width - n.width) / 2, n.top = t.top + (t.height - n.height) / 2, n.oldLeft = n.left, n.oldTop = n.top, this.initialCropBoxData = Z({}, n);
  },
  limitCropBox: function(e, t) {
    var r = this.options, s = this.containerData, n = this.canvasData, a = this.cropBoxData, o = this.limited, l = r.aspectRatio;
    if (e) {
      var c = Number(r.minCropBoxWidth) || 0, h = Number(r.minCropBoxHeight) || 0, d = o ? Math.min(s.width, n.width, n.width + n.left, s.width - n.left) : s.width, u = o ? Math.min(s.height, n.height, n.height + n.top, s.height - n.top) : s.height;
      c = Math.min(c, s.width), h = Math.min(h, s.height), l && (c && h ? h * l > c ? h = c / l : c = h * l : c ? h = c / l : h && (c = h * l), u * l > d ? u = d / l : d = u * l), a.minWidth = Math.min(c, d), a.minHeight = Math.min(h, u), a.maxWidth = d, a.maxHeight = u;
    }
    t && (o ? (a.minLeft = Math.max(0, n.left), a.minTop = Math.max(0, n.top), a.maxLeft = Math.min(s.width, n.left + n.width) - a.width, a.maxTop = Math.min(s.height, n.top + n.height) - a.height) : (a.minLeft = 0, a.minTop = 0, a.maxLeft = s.width - a.width, a.maxTop = s.height - a.height));
  },
  renderCropBox: function() {
    var e = this.options, t = this.containerData, r = this.cropBoxData;
    (r.width > r.maxWidth || r.width < r.minWidth) && (r.left = r.oldLeft), (r.height > r.maxHeight || r.height < r.minHeight) && (r.top = r.oldTop), r.width = Math.min(Math.max(r.width, r.minWidth), r.maxWidth), r.height = Math.min(Math.max(r.height, r.minHeight), r.maxHeight), this.limitCropBox(!1, !0), r.left = Math.min(Math.max(r.left, r.minLeft), r.maxLeft), r.top = Math.min(Math.max(r.top, r.minTop), r.maxTop), r.oldLeft = r.left, r.oldTop = r.top, e.movable && e.cropBoxMovable && Xt(this.face, Yt, r.width >= t.width && r.height >= t.height ? Pn : Cr), qe(this.cropBox, Z({
      width: r.width,
      height: r.height
    }, Wt({
      translateX: r.left,
      translateY: r.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  },
  output: function() {
    this.preview(), wt(this.element, or, this.getData());
  }
}, Wc = {
  initPreview: function() {
    var e = this.element, t = this.crossOrigin, r = this.options.preview, s = t ? this.crossOriginUrl : this.url, n = e.alt || "The image to preview", a = document.createElement("img");
    if (t && (a.crossOrigin = t), a.src = s, a.alt = n, this.viewBox.appendChild(a), this.viewBoxImage = a, !!r) {
      var o = r;
      typeof r == "string" ? o = e.ownerDocument.querySelectorAll(r) : r.querySelector && (o = [r]), this.previews = o, ne(o, function(l) {
        var c = document.createElement("img");
        Xt(l, li, {
          width: l.offsetWidth,
          height: l.offsetHeight,
          html: l.innerHTML
        }), t && (c.crossOrigin = t), c.src = s, c.alt = n, c.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', l.innerHTML = "", l.appendChild(c);
      });
    }
  },
  resetPreview: function() {
    ne(this.previews, function(e) {
      var t = dr(e, li);
      qe(e, {
        width: t.width,
        height: t.height
      }), e.innerHTML = t.html, Fc(e, li);
    });
  },
  preview: function() {
    var e = this.imageData, t = this.canvasData, r = this.cropBoxData, s = r.width, n = r.height, a = e.width, o = e.height, l = r.left - t.left - e.left, c = r.top - t.top - e.top;
    !this.cropped || this.disabled || (qe(this.viewBoxImage, Z({
      width: a,
      height: o
    }, Wt(Z({
      translateX: -l,
      translateY: -c
    }, e)))), ne(this.previews, function(h) {
      var d = dr(h, li), u = d.width, f = d.height, g = u, b = f, v = 1;
      s && (v = u / s, b = n * v), n && b > f && (v = f / n, g = s * v, b = f), qe(h, {
        width: g,
        height: b
      }), qe(h.getElementsByTagName("img")[0], Z({
        width: a * v,
        height: o * v
      }, Wt(Z({
        translateX: -l * v,
        translateY: -c * v
      }, e))));
    }));
  }
}, Vc = {
  bind: function() {
    var e = this.element, t = this.options, r = this.cropper;
    ge(t.cropstart) && xe(e, ur, t.cropstart), ge(t.cropmove) && xe(e, cr, t.cropmove), ge(t.cropend) && xe(e, lr, t.cropend), ge(t.crop) && xe(e, or, t.crop), ge(t.zoom) && xe(e, hr, t.zoom), xe(r, ws, this.onCropStart = this.cropStart.bind(this)), t.zoomable && t.zoomOnWheel && xe(r, Es, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), t.toggleDragModeOnDblclick && xe(r, bs, this.onDblclick = this.dblclick.bind(this)), xe(e.ownerDocument, xs, this.onCropMove = this.cropMove.bind(this)), xe(e.ownerDocument, Cs, this.onCropEnd = this.cropEnd.bind(this)), t.responsive && xe(window, Os, this.onResize = this.resize.bind(this));
  },
  unbind: function() {
    var e = this.element, t = this.options, r = this.cropper;
    ge(t.cropstart) && _e(e, ur, t.cropstart), ge(t.cropmove) && _e(e, cr, t.cropmove), ge(t.cropend) && _e(e, lr, t.cropend), ge(t.crop) && _e(e, or, t.crop), ge(t.zoom) && _e(e, hr, t.zoom), _e(r, ws, this.onCropStart), t.zoomable && t.zoomOnWheel && _e(r, Es, this.onWheel, {
      passive: !1,
      capture: !0
    }), t.toggleDragModeOnDblclick && _e(r, bs, this.onDblclick), _e(e.ownerDocument, xs, this.onCropMove), _e(e.ownerDocument, Cs, this.onCropEnd), t.responsive && _e(window, Os, this.onResize);
  }
}, Kc = {
  resize: function() {
    if (!this.disabled) {
      var e = this.options, t = this.container, r = this.containerData, s = t.offsetWidth / r.width, n = t.offsetHeight / r.height, a = Math.abs(s - 1) > Math.abs(n - 1) ? s : n;
      if (a !== 1) {
        var o, l;
        e.restore && (o = this.getCanvasData(), l = this.getCropBoxData()), this.render(), e.restore && (this.setCanvasData(ne(o, function(c, h) {
          o[h] = c * a;
        })), this.setCropBoxData(ne(l, function(c, h) {
          l[h] = c * a;
        })));
      }
    }
  },
  dblclick: function() {
    this.disabled || this.options.dragMode === Mn || this.setDragMode(Dc(this.dragBox, nr) ? In : Sr);
  },
  wheel: function(e) {
    var t = this, r = Number(this.options.wheelZoomRatio) || 0.1, s = 1;
    this.disabled || (e.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      t.wheeling = !1;
    }, 50), e.deltaY ? s = e.deltaY > 0 ? 1 : -1 : e.wheelDelta ? s = -e.wheelDelta / 120 : e.detail && (s = e.detail > 0 ? 1 : -1), this.zoom(-s * r, e)));
  },
  cropStart: function(e) {
    var t = e.buttons, r = e.button;
    if (!(this.disabled || (e.type === "mousedown" || e.type === "pointerdown" && e.pointerType === "mouse") && // No primary button (Usually the left button)
    (j(t) && t !== 1 || j(r) && r !== 0 || e.ctrlKey))) {
      var s = this.options, n = this.pointers, a;
      e.changedTouches ? ne(e.changedTouches, function(o) {
        n[o.identifier] = ci(o);
      }) : n[e.pointerId || 0] = ci(e), Object.keys(n).length > 1 && s.zoomable && s.zoomOnTouch ? a = Fn : a = dr(e.target, Yt), bc.test(a) && wt(this.element, ur, {
        originalEvent: e,
        action: a
      }) !== !1 && (e.preventDefault(), this.action = a, this.cropping = !1, a === Dn && (this.cropping = !0, oe(this.dragBox, yi)));
    }
  },
  cropMove: function(e) {
    var t = this.action;
    if (!(this.disabled || !t)) {
      var r = this.pointers;
      e.preventDefault(), wt(this.element, cr, {
        originalEvent: e,
        action: t
      }) !== !1 && (e.changedTouches ? ne(e.changedTouches, function(s) {
        Z(r[s.identifier] || {}, ci(s, !0));
      }) : Z(r[e.pointerId || 0] || {}, ci(e, !0)), this.change(e));
    }
  },
  cropEnd: function(e) {
    if (!this.disabled) {
      var t = this.action, r = this.pointers;
      e.changedTouches ? ne(e.changedTouches, function(s) {
        delete r[s.identifier];
      }) : delete r[e.pointerId || 0], t && (e.preventDefault(), Object.keys(r).length || (this.action = ""), this.cropping && (this.cropping = !1, gt(this.dragBox, yi, this.cropped && this.options.modal)), wt(this.element, lr, {
        originalEvent: e,
        action: t
      }));
    }
  }
}, Qc = {
  change: function(e) {
    var t = this.options, r = this.canvasData, s = this.containerData, n = this.cropBoxData, a = this.pointers, o = this.action, l = t.aspectRatio, c = n.left, h = n.top, d = n.width, u = n.height, f = c + d, g = h + u, b = 0, v = 0, O = s.width, C = s.height, E = !0, N;
    !l && e.shiftKey && (l = d && u ? d / u : 1), this.limited && (b = n.minLeft, v = n.minTop, O = b + Math.min(s.width, r.width, r.left + r.width), C = v + Math.min(s.height, r.height, r.top + r.height));
    var R = a[Object.keys(a)[0]], m = {
      x: R.endX - R.startX,
      y: R.endY - R.startY
    }, S = function(x) {
      switch (x) {
        case Ge:
          f + m.x > O && (m.x = O - f);
          break;
        case Je:
          c + m.x < b && (m.x = b - c);
          break;
        case je:
          h + m.y < v && (m.y = v - h);
          break;
        case ft:
          g + m.y > C && (m.y = C - g);
          break;
      }
    };
    switch (o) {
      // Move crop box
      case Cr:
        c += m.x, h += m.y;
        break;
      // Resize crop box
      case Ge:
        if (m.x >= 0 && (f >= O || l && (h <= v || g >= C))) {
          E = !1;
          break;
        }
        S(Ge), d += m.x, d < 0 && (o = Je, d = -d, c -= d), l && (u = d / l, h += (n.height - u) / 2);
        break;
      case je:
        if (m.y <= 0 && (h <= v || l && (c <= b || f >= O))) {
          E = !1;
          break;
        }
        S(je), u -= m.y, h += m.y, u < 0 && (o = ft, u = -u, h -= u), l && (d = u * l, c += (n.width - d) / 2);
        break;
      case Je:
        if (m.x <= 0 && (c <= b || l && (h <= v || g >= C))) {
          E = !1;
          break;
        }
        S(Je), d -= m.x, c += m.x, d < 0 && (o = Ge, d = -d, c -= d), l && (u = d / l, h += (n.height - u) / 2);
        break;
      case ft:
        if (m.y >= 0 && (g >= C || l && (c <= b || f >= O))) {
          E = !1;
          break;
        }
        S(ft), u += m.y, u < 0 && (o = je, u = -u, h -= u), l && (d = u * l, c += (n.width - d) / 2);
        break;
      case jt:
        if (l) {
          if (m.y <= 0 && (h <= v || f >= O)) {
            E = !1;
            break;
          }
          S(je), u -= m.y, h += m.y, d = u * l;
        } else
          S(je), S(Ge), m.x >= 0 ? f < O ? d += m.x : m.y <= 0 && h <= v && (E = !1) : d += m.x, m.y <= 0 ? h > v && (u -= m.y, h += m.y) : (u -= m.y, h += m.y);
        d < 0 && u < 0 ? (o = $t, u = -u, d = -d, h -= u, c -= d) : d < 0 ? (o = zt, d = -d, c -= d) : u < 0 && (o = Ut, u = -u, h -= u);
        break;
      case zt:
        if (l) {
          if (m.y <= 0 && (h <= v || c <= b)) {
            E = !1;
            break;
          }
          S(je), u -= m.y, h += m.y, d = u * l, c += n.width - d;
        } else
          S(je), S(Je), m.x <= 0 ? c > b ? (d -= m.x, c += m.x) : m.y <= 0 && h <= v && (E = !1) : (d -= m.x, c += m.x), m.y <= 0 ? h > v && (u -= m.y, h += m.y) : (u -= m.y, h += m.y);
        d < 0 && u < 0 ? (o = Ut, u = -u, d = -d, h -= u, c -= d) : d < 0 ? (o = jt, d = -d, c -= d) : u < 0 && (o = $t, u = -u, h -= u);
        break;
      case $t:
        if (l) {
          if (m.x <= 0 && (c <= b || g >= C)) {
            E = !1;
            break;
          }
          S(Je), d -= m.x, c += m.x, u = d / l;
        } else
          S(ft), S(Je), m.x <= 0 ? c > b ? (d -= m.x, c += m.x) : m.y >= 0 && g >= C && (E = !1) : (d -= m.x, c += m.x), m.y >= 0 ? g < C && (u += m.y) : u += m.y;
        d < 0 && u < 0 ? (o = jt, u = -u, d = -d, h -= u, c -= d) : d < 0 ? (o = Ut, d = -d, c -= d) : u < 0 && (o = zt, u = -u, h -= u);
        break;
      case Ut:
        if (l) {
          if (m.x >= 0 && (f >= O || g >= C)) {
            E = !1;
            break;
          }
          S(Ge), d += m.x, u = d / l;
        } else
          S(ft), S(Ge), m.x >= 0 ? f < O ? d += m.x : m.y >= 0 && g >= C && (E = !1) : d += m.x, m.y >= 0 ? g < C && (u += m.y) : u += m.y;
        d < 0 && u < 0 ? (o = zt, u = -u, d = -d, h -= u, c -= d) : d < 0 ? (o = $t, d = -d, c -= d) : u < 0 && (o = jt, u = -u, h -= u);
        break;
      // Move canvas
      case Pn:
        this.move(m.x, m.y), E = !1;
        break;
      // Zoom canvas
      case Fn:
        this.zoom(Mc(a), e), E = !1;
        break;
      // Create crop box
      case Dn:
        if (!m.x || !m.y) {
          E = !1;
          break;
        }
        N = zn(this.cropper), c = R.startX - N.left, h = R.startY - N.top, d = n.minWidth, u = n.minHeight, m.x > 0 ? o = m.y > 0 ? Ut : jt : m.x < 0 && (c -= d, o = m.y > 0 ? $t : zt), m.y < 0 && (h -= u), this.cropped || (Le(this.cropBox, me), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    E && (n.width = d, n.height = u, n.left = c, n.top = h, this.action = o, this.renderCropBox()), ne(a, function(w) {
      w.startX = w.endX, w.startY = w.endY;
    });
  }
}, qc = {
  // Show the crop box manually
  crop: function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && oe(this.dragBox, yi), Le(this.cropBox, me), this.setCropBoxData(this.initialCropBoxData)), this;
  },
  // Reset the image and crop box to their initial states
  reset: function() {
    return this.ready && !this.disabled && (this.imageData = Z({}, this.initialImageData), this.canvasData = Z({}, this.initialCanvasData), this.cropBoxData = Z({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  },
  // Clear the crop box
  clear: function() {
    return this.cropped && !this.disabled && (Z(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), Le(this.dragBox, yi), oe(this.cropBox, me)), this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && e && (this.isImg && (this.element.src = e), t ? (this.url = e, this.image.src = e, this.ready && (this.viewBoxImage.src = e, ne(this.previews, function(r) {
      r.getElementsByTagName("img")[0].src = e;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(e))), this;
  },
  // Enable (unfreeze) the cropper
  enable: function() {
    return this.ready && this.disabled && (this.disabled = !1, Le(this.cropper, vs)), this;
  },
  // Disable (freeze) the cropper
  disable: function() {
    return this.ready && !this.disabled && (this.disabled = !0, oe(this.cropper, vs)), this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function() {
    var e = this.element;
    return e[J] ? (e[J] = void 0, this.isImg && this.replaced && (e.src = this.originalUrl), this.uncreate(), this) : this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = this.canvasData, s = r.left, n = r.top;
    return this.moveTo(Ii(e) ? e : s + Number(e), Ii(t) ? t : n + Number(t));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = this.canvasData, s = !1;
    return e = Number(e), t = Number(t), this.ready && !this.disabled && this.options.movable && (j(e) && (r.left = e, s = !0), j(t) && (r.top = t, s = !0), s && this.renderCanvas(!0)), this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function(e, t) {
    var r = this.canvasData;
    return e = Number(e), e < 0 ? e = 1 / (1 - e) : e = 1 + e, this.zoomTo(r.width * e / r.naturalWidth, null, t);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function(e, t, r) {
    var s = this.options, n = this.canvasData, a = n.width, o = n.height, l = n.naturalWidth, c = n.naturalHeight;
    if (e = Number(e), e >= 0 && this.ready && !this.disabled && s.zoomable) {
      var h = l * e, d = c * e;
      if (wt(this.element, hr, {
        ratio: e,
        oldRatio: a / l,
        originalEvent: r
      }) === !1)
        return this;
      if (r) {
        var u = this.pointers, f = zn(this.cropper), g = u && Object.keys(u).length ? Tc(u) : {
          pageX: r.pageX,
          pageY: r.pageY
        };
        n.left -= (h - a) * ((g.pageX - f.left - n.left) / a), n.top -= (d - o) * ((g.pageY - f.top - n.top) / o);
      } else pt(t) && j(t.x) && j(t.y) ? (n.left -= (h - a) * ((t.x - n.left) / a), n.top -= (d - o) * ((t.y - n.top) / o)) : (n.left -= (h - a) / 2, n.top -= (d - o) / 2);
      n.width = h, n.height = d, this.renderCanvas(!0);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function(e) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(e));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function(e) {
    return e = Number(e), j(e) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = e % 360, this.renderCanvas(!0, !0)), this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function(e) {
    var t = this.imageData.scaleY;
    return this.scale(e, j(t) ? t : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function(e) {
    var t = this.imageData.scaleX;
    return this.scale(j(t) ? t : 1, e);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = this.imageData, s = !1;
    return e = Number(e), t = Number(t), this.ready && !this.disabled && this.options.scalable && (j(e) && (r.scaleX = e, s = !0), j(t) && (r.scaleY = t, s = !0), s && this.renderCanvas(!0, !0)), this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = this.options, r = this.imageData, s = this.canvasData, n = this.cropBoxData, a;
    if (this.ready && this.cropped) {
      a = {
        x: n.left - s.left,
        y: n.top - s.top,
        width: n.width,
        height: n.height
      };
      var o = r.width / r.naturalWidth;
      if (ne(a, function(h, d) {
        a[d] = h / o;
      }), e) {
        var l = Math.round(a.y + a.height), c = Math.round(a.x + a.width);
        a.x = Math.round(a.x), a.y = Math.round(a.y), a.width = c - a.x, a.height = l - a.y;
      }
    } else
      a = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return t.rotatable && (a.rotate = r.rotate || 0), t.scalable && (a.scaleX = r.scaleX || 1, a.scaleY = r.scaleY || 1), a;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function(e) {
    var t = this.options, r = this.imageData, s = this.canvasData, n = {};
    if (this.ready && !this.disabled && pt(e)) {
      var a = !1;
      t.rotatable && j(e.rotate) && e.rotate !== r.rotate && (r.rotate = e.rotate, a = !0), t.scalable && (j(e.scaleX) && e.scaleX !== r.scaleX && (r.scaleX = e.scaleX, a = !0), j(e.scaleY) && e.scaleY !== r.scaleY && (r.scaleY = e.scaleY, a = !0)), a && this.renderCanvas(!0, !0);
      var o = r.width / r.naturalWidth;
      j(e.x) && (n.left = e.x * o + s.left), j(e.y) && (n.top = e.y * o + s.top), j(e.width) && (n.width = e.width * o), j(e.height) && (n.height = e.height * o), this.setCropBoxData(n);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function() {
    return this.ready ? Z({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function() {
    return this.sized ? Z({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function() {
    var e = this.canvasData, t = {};
    return this.ready && ne(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(r) {
      t[r] = e[r];
    }), t;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function(e) {
    var t = this.canvasData, r = t.aspectRatio;
    return this.ready && !this.disabled && pt(e) && (j(e.left) && (t.left = e.left), j(e.top) && (t.top = e.top), j(e.width) ? (t.width = e.width, t.height = e.width / r) : j(e.height) && (t.height = e.height, t.width = e.height * r), this.renderCanvas(!0)), this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function() {
    var e = this.cropBoxData, t;
    return this.ready && this.cropped && (t = {
      left: e.left,
      top: e.top,
      width: e.width,
      height: e.height
    }), t || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function(e) {
    var t = this.cropBoxData, r = this.options.aspectRatio, s, n;
    return this.ready && this.cropped && !this.disabled && pt(e) && (j(e.left) && (t.left = e.left), j(e.top) && (t.top = e.top), j(e.width) && e.width !== t.width && (s = !0, t.width = e.width), j(e.height) && e.height !== t.height && (n = !0, t.height = e.height), r && (s ? t.height = t.width / r : n && (t.width = t.height * r)), this.renderCropBox()), this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var t = this.canvasData, r = kc(this.image, this.imageData, t, e);
    if (!this.cropped)
      return r;
    var s = this.getData(e.rounded), n = s.x, a = s.y, o = s.width, l = s.height, c = r.width / Math.floor(t.naturalWidth);
    c !== 1 && (n *= c, a *= c, o *= c, l *= c);
    var h = o / l, d = Ye({
      aspectRatio: h,
      width: e.maxWidth || 1 / 0,
      height: e.maxHeight || 1 / 0
    }), u = Ye({
      aspectRatio: h,
      width: e.minWidth || 0,
      height: e.minHeight || 0
    }, "cover"), f = Ye({
      aspectRatio: h,
      width: e.width || (c !== 1 ? r.width : o),
      height: e.height || (c !== 1 ? r.height : l)
    }), g = f.width, b = f.height;
    g = Math.min(d.width, Math.max(u.width, g)), b = Math.min(d.height, Math.max(u.height, b));
    var v = document.createElement("canvas"), O = v.getContext("2d");
    v.width = bt(g), v.height = bt(b), O.fillStyle = e.fillColor || "transparent", O.fillRect(0, 0, g, b);
    var C = e.imageSmoothingEnabled, E = C === void 0 ? !0 : C, N = e.imageSmoothingQuality;
    O.imageSmoothingEnabled = E, N && (O.imageSmoothingQuality = N);
    var R = r.width, m = r.height, S = n, w = a, x, _, F, I, H, z;
    S <= -o || S > R ? (S = 0, x = 0, F = 0, H = 0) : S <= 0 ? (F = -S, S = 0, x = Math.min(R, o + S), H = x) : S <= R && (F = 0, x = Math.min(o, R - S), H = x), x <= 0 || w <= -l || w > m ? (w = 0, _ = 0, I = 0, z = 0) : w <= 0 ? (I = -w, w = 0, _ = Math.min(m, l + w), z = _) : w <= m && (I = 0, _ = Math.min(l, m - w), z = _);
    var M = [S, w, x, _];
    if (H > 0 && z > 0) {
      var ee = g / o;
      M.push(F * ee, I * ee, H * ee, z * ee);
    }
    return O.drawImage.apply(O, [r].concat(Rn(M.map(function(ae) {
      return Math.floor(bt(ae));
    })))), v;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function(e) {
    var t = this.options;
    return !this.disabled && !Ii(e) && (t.aspectRatio = Math.max(0, e) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function(e) {
    var t = this.options, r = this.dragBox, s = this.face;
    if (this.ready && !this.disabled) {
      var n = e === Sr, a = t.movable && e === In;
      e = n || a ? e : Mn, t.dragMode = e, Xt(r, Yt, e), gt(r, nr, n), gt(r, ar, a), t.cropBoxMovable || (Xt(s, Yt, e), gt(s, nr, n), gt(s, ar, a));
    }
    return this;
  }
}, Yc = ke.Cropper, $n = /* @__PURE__ */ (function() {
  function i(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (lc(this, i), !e || !Cc.test(e.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = e, this.options = Z({}, _s, pt(t) && t), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return cc(i, [{
    key: "init",
    value: function() {
      var t = this.element, r = t.tagName.toLowerCase(), s;
      if (!t[J]) {
        if (t[J] = this, r === "img") {
          if (this.isImg = !0, s = t.getAttribute("src") || "", this.originalUrl = s, !s)
            return;
          s = t.src;
        } else r === "canvas" && window.HTMLCanvasElement && (s = t.toDataURL());
        this.load(s);
      }
    }
  }, {
    key: "load",
    value: function(t) {
      var r = this;
      if (t) {
        this.url = t, this.imageData = {};
        var s = this.element, n = this.options;
        if (!n.rotatable && !n.scalable && (n.checkOrientation = !1), !n.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (wc.test(t)) {
          xc.test(t) ? this.read(zc(t)) : this.clone();
          return;
        }
        var a = new XMLHttpRequest(), o = this.clone.bind(this);
        this.reloading = !0, this.xhr = a, a.onabort = o, a.onerror = o, a.ontimeout = o, a.onprogress = function() {
          a.getResponseHeader("content-type") !== Ns && a.abort();
        }, a.onload = function() {
          r.read(a.response);
        }, a.onloadend = function() {
          r.reloading = !1, r.xhr = null;
        }, n.checkCrossOrigin && Ds(t) && s.crossOrigin && (t = Ps(t)), a.open("GET", t, !0), a.responseType = "arraybuffer", a.withCredentials = s.crossOrigin === "use-credentials", a.send();
      }
    }
  }, {
    key: "read",
    value: function(t) {
      var r = this.options, s = this.imageData, n = $c(t), a = 0, o = 1, l = 1;
      if (n > 1) {
        this.url = Uc(t, Ns);
        var c = Bc(n);
        a = c.rotate, o = c.scaleX, l = c.scaleY;
      }
      r.rotatable && (s.rotate = a), r.scalable && (s.scaleX = o, s.scaleY = l), this.clone();
    }
  }, {
    key: "clone",
    value: function() {
      var t = this.element, r = this.url, s = t.crossOrigin, n = r;
      this.options.checkCrossOrigin && Ds(r) && (s || (s = "anonymous"), n = Ps(r)), this.crossOrigin = s, this.crossOriginUrl = n;
      var a = document.createElement("img");
      s && (a.crossOrigin = s), a.src = n || r, a.alt = t.alt || "The image to crop", this.image = a, a.onload = this.start.bind(this), a.onerror = this.stop.bind(this), oe(a, ys), t.parentNode.insertBefore(a, t.nextSibling);
    }
  }, {
    key: "start",
    value: function() {
      var t = this, r = this.image;
      r.onload = null, r.onerror = null, this.sizing = !0;
      var s = ke.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(ke.navigator.userAgent), n = function(c, h) {
        Z(t.imageData, {
          naturalWidth: c,
          naturalHeight: h,
          aspectRatio: c / h
        }), t.initialImageData = Z({}, t.imageData), t.sizing = !1, t.sized = !0, t.build();
      };
      if (r.naturalWidth && !s) {
        n(r.naturalWidth, r.naturalHeight);
        return;
      }
      var a = document.createElement("img"), o = document.body || document.documentElement;
      this.sizingImage = a, a.onload = function() {
        n(a.width, a.height), s || o.removeChild(a);
      }, a.src = r.src, s || (a.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", o.appendChild(a));
    }
  }, {
    key: "stop",
    value: function() {
      var t = this.image;
      t.onload = null, t.onerror = null, t.parentNode.removeChild(t), this.image = null;
    }
  }, {
    key: "build",
    value: function() {
      if (!(!this.sized || this.ready)) {
        var t = this.element, r = this.options, s = this.image, n = t.parentNode, a = document.createElement("div");
        a.innerHTML = Sc;
        var o = a.querySelector(".".concat(J, "-container")), l = o.querySelector(".".concat(J, "-canvas")), c = o.querySelector(".".concat(J, "-drag-box")), h = o.querySelector(".".concat(J, "-crop-box")), d = h.querySelector(".".concat(J, "-face"));
        this.container = n, this.cropper = o, this.canvas = l, this.dragBox = c, this.cropBox = h, this.viewBox = o.querySelector(".".concat(J, "-view-box")), this.face = d, l.appendChild(s), oe(t, me), n.insertBefore(o, t.nextSibling), Le(s, ys), this.initPreview(), this.bind(), r.initialAspectRatio = Math.max(0, r.initialAspectRatio) || NaN, r.aspectRatio = Math.max(0, r.aspectRatio) || NaN, r.viewMode = Math.max(0, Math.min(3, Math.round(r.viewMode))) || 0, oe(h, me), r.guides || oe(h.getElementsByClassName("".concat(J, "-dashed")), me), r.center || oe(h.getElementsByClassName("".concat(J, "-center")), me), r.background && oe(o, "".concat(J, "-bg")), r.highlight || oe(d, gc), r.cropBoxMovable && (oe(d, ar), Xt(d, Yt, Cr)), r.cropBoxResizable || (oe(h.getElementsByClassName("".concat(J, "-line")), me), oe(h.getElementsByClassName("".concat(J, "-point")), me)), this.render(), this.ready = !0, this.setDragMode(r.dragMode), r.autoCrop && this.crop(), this.setData(r.data), ge(r.ready) && xe(t, Ss, r.ready, {
          once: !0
        }), wt(t, Ss);
      }
    }
  }, {
    key: "unbuild",
    value: function() {
      if (this.ready) {
        this.ready = !1, this.unbind(), this.resetPreview();
        var t = this.cropper.parentNode;
        t && t.removeChild(this.cropper), Le(this.element, me);
      }
    }
  }, {
    key: "uncreate",
    value: function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Cropper = Yc, i;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(t) {
      Z(_s, pt(t) && t);
    }
  }]);
})();
Z($n.prototype, Hc, Wc, Vc, Kc, Qc, qc);
var Ze = function() {
  return Ze = Object.assign || function(i) {
    for (var e, t = 1, r = arguments.length; t < r; t++) for (var s in e = arguments[t]) Object.prototype.hasOwnProperty.call(e, s) && (i[s] = e[s]);
    return i;
  }, Ze.apply(this, arguments);
};
function Ti(i, e) {
  var t = {};
  for (var r in i) Object.prototype.hasOwnProperty.call(i, r) && e.indexOf(r) < 0 && (t[r] = i[r]);
  if (i != null && typeof Object.getOwnPropertySymbols == "function") {
    var s = 0;
    for (r = Object.getOwnPropertySymbols(i); s < r.length; s++) e.indexOf(r[s]) < 0 && Object.prototype.propertyIsEnumerable.call(i, r[s]) && (t[r[s]] = i[r[s]]);
  }
  return t;
}
var Xc = ["aspectRatio", "autoCrop", "autoCropArea", "background", "center", "checkCrossOrigin", "checkOrientation", "cropBoxMovable", "cropBoxResizable", "data", "dragMode", "guides", "highlight", "initialAspectRatio", "minCanvasHeight", "minCanvasWidth", "minContainerHeight", "minContainerWidth", "minCropBoxHeight", "minCropBoxWidth", "modal", "movable", "preview", "responsive", "restore", "rotatable", "scalable", "toggleDragModeOnDblclick", "viewMode", "wheelZoomRatio", "zoomOnTouch", "zoomOnWheel", "zoomable", "cropstart", "cropmove", "cropend", "crop", "zoom", "ready"], Gc = { opacity: 0, maxWidth: "100%" }, Jc = Oe.forwardRef((function(i, e) {
  var t = Ti(i, []), r = t.dragMode, s = r === void 0 ? "crop" : r, n = t.src, a = t.style, o = t.className, l = t.crossOrigin, c = t.scaleX, h = t.scaleY, d = t.enable, u = t.zoomTo, f = t.rotateTo, g = t.alt, b = g === void 0 ? "picture" : g, v = t.ready, O = t.onInitialized, C = Ti(t, ["dragMode", "src", "style", "className", "crossOrigin", "scaleX", "scaleY", "enable", "zoomTo", "rotateTo", "alt", "ready", "onInitialized"]), E = { scaleY: h, scaleX: c, enable: d, zoomTo: u, rotateTo: f }, N = (function() {
    for (var m = [], S = 0; S < arguments.length; S++) m[S] = arguments[S];
    var w = be(null);
    return Oe.useEffect((function() {
      m.forEach((function(x) {
        x && (typeof x == "function" ? x(w.current) : x.current = w.current);
      }));
    }), [m]), w;
  })(e, be(null));
  Ee((function() {
    var m;
    !((m = N.current) === null || m === void 0) && m.cropper && typeof u == "number" && N.current.cropper.zoomTo(u);
  }), [t.zoomTo]), Ee((function() {
    var m;
    !((m = N.current) === null || m === void 0) && m.cropper && n !== void 0 && N.current.cropper.reset().clear().replace(n);
  }), [n]), Ee((function() {
    if (N.current !== null) {
      var m = new $n(N.current, Ze(Ze({ dragMode: s }, C), { ready: function(S) {
        S.currentTarget !== null && (function(w, x) {
          x === void 0 && (x = {});
          var _ = x.enable, F = _ === void 0 || _, I = x.scaleX, H = I === void 0 ? 1 : I, z = x.scaleY, M = z === void 0 ? 1 : z, ee = x.zoomTo, ae = ee === void 0 ? 0 : ee, k = x.rotateTo;
          F ? w.enable() : w.disable(), w.scaleX(H), w.scaleY(M), k !== void 0 && w.rotateTo(k), ae > 0 && w.zoomTo(ae);
        })(S.currentTarget.cropper, E), v && v(S);
      } }));
      O && O(m);
    }
    return function() {
      var S, w;
      (w = (S = N.current) === null || S === void 0 ? void 0 : S.cropper) === null || w === void 0 || w.destroy();
    };
  }), [N]);
  var R = (function(m) {
    return Xc.reduce((function(S, w) {
      var x = S, _ = w;
      return x[_], Ti(x, [typeof _ == "symbol" ? _ : _ + ""]);
    }), m);
  })(Ze(Ze({}, C), { crossOrigin: l, src: n, alt: b }));
  return Oe.createElement("div", { style: a, className: o }, Oe.createElement("img", Ze({}, R, { style: Gc, ref: N })));
}));
const Bn = ca(
  ({ imageCropperRef: i, isRounded: e, imageFile: t, imageCropperProps: r }) => {
    const {
      viewMode: s = 1,
      autoCropArea: n = 1,
      aspectRatio: a = 1,
      checkOrientation: o = !1,
      // NOTE: it fixes this issue https://github.com/fengyuanchen/cropperjs/issues/671
      background: l = !0,
      dragMode: c = "move",
      toggleDragModeOnDblclick: h = !1,
      style: d = { height: 400, width: "100%" },
      ...u
    } = r || {}, f = be(null), g = be(null), b = be(null), v = be(null), O = () => {
      g.current && (g.current.style.opacity = ""), b.current && (b.current.style.display = "block"), v.current && (v.current.style.zIndex = "", v.current.innerText = "");
    }, C = () => {
      b.current && v.current && (v.current.appendChild(b.current.cloneNode(!0)), v.current.style.zIndex = "1000", b.current.style.display = "none"), g.current && (g.current.style.opacity = "0");
    }, E = (N) => new Promise((R, m) => {
      var S;
      try {
        const w = (S = f.current) == null ? void 0 : S.cropper;
        if (!w) throw new Error();
        if (e) {
          const x = w == null ? void 0 : w.getCroppedCanvas();
          if (!x) throw new Error();
          const _ = Math.min(x.width, x.height), F = document.createElement("canvas");
          F.width = _, F.height = _;
          const I = F.getContext("2d");
          if (!I) throw new Error();
          I.beginPath(), I.arc(_ / 2, _ / 2, _ / 2, 0, Math.PI * 2), I.closePath(), I.clip(), I.drawImage(x, 0, 0, _, _), F.toBlob((H) => {
            if (!t || !H)
              return m(new Error());
            const z = es(
              rs(t, H),
              a
            );
            R(z);
          });
        } else
          w.getCroppedCanvas(N).toBlob((x) => {
            if (!t || !x)
              return m(new Error());
            const _ = es(
              rs(t, x),
              a
            );
            R(_);
          });
      } catch (w) {
        m(w);
      }
    });
    return i && (i.current = {
      hidePreview: O,
      showPreview: C,
      getCroppedFile: E
    }), /* @__PURE__ */ y("div", { children: /* @__PURE__ */ A("div", { className: "relative w-full overflow-hidden", children: [
      /* @__PURE__ */ y(
        "div",
        {
          ref: v,
          className: "absolute inset-0 flex items-center justify-center"
        }
      ),
      /* @__PURE__ */ y(
        "div",
        {
          ref: b,
          style: {
            position: "absolute",
            overflow: "hidden",
            width: d.width,
            height: d.height,
            borderRadius: e ? "50%" : 0
          }
        }
      ),
      /* @__PURE__ */ y("div", { ref: g, children: /* @__PURE__ */ y(
        Jc,
        {
          className: e ? "sio-cropper-rounded" : "",
          ref: f,
          src: t && URL.createObjectURL(t),
          preview: b || void 0,
          style: d,
          viewMode: s,
          background: l,
          autoCropArea: n,
          aspectRatio: a,
          checkOrientation: o,
          dragMode: c,
          toggleDragModeOnDblclick: h,
          ...u
        }
      ) })
    ] }) });
  }
);
Bn.displayName = "ImageCropper";
function Hn({
  imageFile: i,
  opened: e,
  actionButtonLabel: t,
  isFetching: r,
  onClose: s,
  onCrop: n,
  ...a
}) {
  const { t: o } = fe(), l = be(), [c, h] = W(!1), d = (f) => {
    var g, b;
    h(f), f ? (g = l.current) == null || g.showPreview() : (b = l.current) == null || b.hidePreview();
  }, u = async () => {
    var f;
    try {
      const g = await ((f = l.current) == null ? void 0 : f.getCroppedFile());
      if (!g) throw new Error();
      n(g);
    } catch {
      ye.error(o("file_manager.error"));
    }
  };
  return /* @__PURE__ */ A(
    bi,
    {
      title: o("file_manager.file_upload.crop_file"),
      opened: e,
      onClose: s,
      afterLeave: () => h(!1),
      isFetching: r,
      isCentered: !0,
      children: [
        /* @__PURE__ */ y(Bn, { imageCropperRef: l, imageFile: i, ...a }),
        /* @__PURE__ */ A("div", { className: "mt-10 flex items-center justify-between", children: [
          /* @__PURE__ */ y(
            ia,
            {
              label: o("file_manager.preview"),
              selected: c,
              onChange: d
            }
          ),
          /* @__PURE__ */ y(ti, { onClick: u, isFetching: r, children: t ?? o("file_manager.file_upload.crop_file") })
        ] })
      ]
    }
  );
}
const Zc = ({
  uploaderRef: i,
  opened: e,
  source: t,
  imageCropperModalProps: r,
  showCroppingNote: s,
  acceptTypes: n,
  usePublicApi: a,
  actionLabel: o,
  singleFileMode: l,
  openCroppingModalOnAdding: c,
  requireCropping: h,
  onClose: d,
  onUploadFinish: u
}) => {
  const { t: f } = fe(), [g, b] = W(!1), [v, O] = W(), {
    waitingUploadFiles: C,
    setWaitingUploadFiles: E,
    removingFiles: N,
    mappedUploadedFiles: R,
    mappedUploadingFiles: m,
    startUploading: S,
    setUploadedFiles: w,
    deleteUploadedOrUploadingFile: x
  } = tc({
    usePublicApi: a,
    source: t
  }), _ = async (D) => {
    var ri;
    const U = (ri = r == null ? void 0 : r.imageCropperProps) == null ? void 0 : ri.aspectRatio;
    if (!Ui(D) || !U || isNaN(U))
      return !0;
    const V = URL.createObjectURL(D), [we, Tt] = await Zs(V);
    return !!en(Tt, U);
  };
  ts(C, async (D, U) => {
    if (!c) return;
    const { added: V } = D ? is(D, U) : { added: U };
    for (const { file: we } of V)
      if (!await _(we)) {
        q(we);
        break;
      }
  }), ts(C, async (D, U) => {
    if (!s) return;
    const { added: V } = D ? is(D, U) : { added: U };
    for (const { file: we } of V)
      if (!await _(we)) {
        ye(f("file_manager.image_cropper.aspect_ratio.need_to_crop_note"));
        break;
      }
  });
  const F = async (D) => {
    E(l ? [{ file: D }] : (U) => [{ file: D }, ...U]);
  }, I = async (D) => {
    try {
      ic(D) && E((U) => U == null ? void 0 : U.filter((V) => V.file !== D)), rc(D) && (await x(D.id), E((U) => U == null ? void 0 : U.filter((V) => V.file !== D.file))), sc(D) && await x(D.id);
    } catch {
      ye.error(f("file_manager.error"));
    }
  }, H = async () => {
    try {
      if (O(void 0), b(!0), h) {
        for await (const { file: V } of C)
          if (!await _(V))
            throw new Error(f("file_manager.image_cropper.aspect_ratio.need_to_crop_note"));
      }
      const D = [], U = await Promise.allSettled(
        C.map(
          ({ file: V }) => S(V).catch(() => {
            D.push(f("file_manager.error") + ": " + V.name);
          })
        )
      );
      if (D.length)
        throw new Error(D.join(", "));
      await u(
        U.map((V) => {
          if (V.status === "fulfilled")
            return V.value;
        })
      ), ye.success(f("file_manager.file_upload.uploaded_successfully"));
    } catch (D) {
      const U = D instanceof Error ? D : new Error(f("file_manager.error"));
      O(U);
    } finally {
      b(!1);
    }
  }, z = !![...C, ...m, ...R].length, [M, ee] = W(!1), [ae, k] = W(), q = (D) => {
    ee(!0), k(D);
  }, G = () => {
    ee(!1), k(void 0);
  }, K = (D) => {
    E(
      (U) => U.map((V) => V.file === ae ? { file: D } : V)
    ), G();
  };
  return i && (i.current = {
    setWaitingUploadFiles: E
  }), /* @__PURE__ */ A(Li, { children: [
    /* @__PURE__ */ y(
      bi,
      {
        title: f("file_manager.file_upload.upload_files"),
        isCentered: !0,
        isFetching: g,
        opened: e,
        onClose: d,
        afterLeave: () => {
          w([]), E([]);
        },
        children: /* @__PURE__ */ A("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ A(
            En,
            {
              acceptTypes: n,
              onSelectFile: F,
              dropZoneClassName: ie("min-h-[400px]", !z && "items-center"),
              label: f("file_manager.file_upload.drop_files_here"),
              disabled: g,
              children: [
                C.map((D, U) => /* @__PURE__ */ y("div", { title: D.file.name, children: /* @__PURE__ */ y(
                  Fi,
                  {
                    file: D.file,
                    isError: !!D.error,
                    onDeleteFile: () => I(D.file),
                    showDeleteButton: !0,
                    showEditButton: Ui(D.file),
                    onEdit: () => q(D.file)
                  }
                ) }, U + D.file.name)),
                m.map((D) => /* @__PURE__ */ y("div", { title: D.file.name, children: /* @__PURE__ */ y(
                  Fi,
                  {
                    file: D.file.file,
                    progress: D.progress,
                    isLoading: !0,
                    onDeleteFile: () => I(D.file)
                  }
                ) }, D.file.id)),
                R.map((D) => /* @__PURE__ */ y("div", { title: D.file.name, children: /* @__PURE__ */ y(
                  Fi,
                  {
                    file: D.file,
                    progress: D.progress,
                    isLoaded: !0,
                    isDeleting: N.includes(D.file.id),
                    onDeleteFile: () => I(D.file)
                  }
                ) }, D.file.id))
              ]
            }
          ),
          /* @__PURE__ */ y("div", { children: /* @__PURE__ */ y(
            ui,
            {
              error: v == null ? void 0 : v.message,
              className: "text-center"
            }
          ) }),
          /* @__PURE__ */ A("div", { className: "flex justify-end gap-3", children: [
            /* @__PURE__ */ y(Us, { disabled: g, onClick: () => d(), children: f("file_manager.cancel") }),
            /* @__PURE__ */ y(
              ti,
              {
                isFetching: g,
                onClick: H,
                disabled: !z,
                children: o ?? f("file_manager.upload")
              }
            )
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ y(
      Hn,
      {
        imageFile: ae,
        opened: M,
        onClose: G,
        onCrop: K,
        ...r
      }
    )
  ] });
};
function eu({
  uploadingFromSource: i,
  requiredCropping: e = !0,
  fileUploaderModalProps: t,
  initialSearchFilters: r,
  disabledFileTypeSelect: s,
  disabledFileSourceSelect: n,
  fileSelectorRef: a,
  onSelect: o
}) {
  var Pr, Fr;
  e = !!(e && ((Fr = (Pr = t == null ? void 0 : t.imageCropperModalProps) == null ? void 0 : Pr.imageCropperProps) != null && Fr.aspectRatio));
  const { t: l } = fe(), { width: c } = ra(), [h, d] = W(
    r ?? {
      name: "",
      source: [],
      type: []
    }
  ), [u, f] = W(h), [g, b] = W(), [v, O] = W(), [C, E] = W(), [N, R] = W(""), [m, S] = W(), w = Nl({
    filter: u,
    sortColumn: "createdAt",
    sortDirection: Bs.Desc
  }), { resetAndRefetch: x, deleteItemFromData: _, renameItemFromData: F } = w, { deleteFile: I, downloadFile: H, renameFile: z } = bn(), { data: M, isFetching: ee } = _l({
    id: g == null ? void 0 : g.id
  }), ae = async () => {
    v && (await I(v), _(v.id), ye.success(l("file_manager.file_deleted_successfully")), O(void 0));
  }, k = async (se) => {
    try {
      await H(se);
    } catch {
    }
  }, [q, G] = W(), K = async () => {
    var se;
    if (C)
      try {
        G(void 0), await z({ id: C.id, name: N }), F({ id: C.id, name: N }), ye.success(l("file_manager.file_renamed_successfully")), E(void 0);
      } catch (Ne) {
        if (Ne instanceof wa)
          G((se = Ne.errors.fields.name) == null ? void 0 : se.join(" "));
        else
          throw Ne;
      }
  }, D = be(), [U, V] = W(!1), we = (se) => {
    var Ne;
    (Ne = D.current) == null || Ne.setWaitingUploadFiles((Xe) => [...Xe, { file: se }]), V(!0);
  };
  Ee(() => {
    t != null && t.uploaderRef && (t.uploaderRef.current = D.current);
  }, [D.current]), a && (a.current = {
    setFileUploadModalOpen: V
  });
  const { createFileUploader: Tt } = Sn(), [ri, Er] = W(!1), [Wn, Nr] = W(!1), [Vn, _r] = W(!1), [Kn, Rr] = W(), Qn = (se) => {
    Er(!0), Rr(se);
  }, Dr = () => {
    Er(!1), Rr(void 0);
  }, qn = async (se) => {
    try {
      Nr(!0);
      const Xe = await Tt(() => {
      }).upload({
        file: se,
        source: i
      });
      if (!Xe) throw new Error();
      const si = Lo(Xe, i);
      o(si), x(), Dr();
    } catch {
      ye.error(l("file_manager.error"));
    } finally {
      Nr(!1);
    }
  }, Yn = async () => {
    var Ne, Xe;
    if (!m) return;
    const se = (Xe = (Ne = t == null ? void 0 : t.imageCropperModalProps) == null ? void 0 : Ne.imageCropperProps) == null ? void 0 : Xe.aspectRatio;
    if (!e || !Ui(m) || !se || isNaN(se)) {
      o(m);
      return;
    }
    try {
      _r(!0);
      const [si, Xn] = await Zs(m.path);
      if (en(Xn, se)) {
        o(m);
        return;
      }
      ye(To(se));
      const Gn = await ko(si, m.name, m.type);
      Qn(Gn);
    } catch {
      ye.error(l("file_manager.error"));
    } finally {
      _r(!1);
    }
  };
  return /* @__PURE__ */ A("div", { className: "flex gap-5", children: [
    /* @__PURE__ */ y(
      "div",
      {
        className: ie(
          g ? "w-1/2" : "w-full",
          c < 1024 && g ? "hidden" : "auto"
        ),
        children: /* @__PURE__ */ A("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ y(
            Rl,
            {
              isFetching: w.isFetching,
              values: h,
              disabledFileSourceSelect: n,
              disabledFileTypeSelect: s,
              onChange: d,
              onSubmit: () => {
                f(h);
              }
            }
          ),
          /* @__PURE__ */ y(
            Wl,
            {
              dataFilesApi: w,
              onDetails: b,
              onSelect: S,
              onDelete: O,
              onDownload: k,
              onRename: (se) => {
                E(se), R(se.name);
              },
              specialElementInGrid: /* @__PURE__ */ y(
                En,
                {
                  className: "h-full w-full",
                  dropZoneClassName: "w-full h-full items-center",
                  labelClassName: "text-text-primary",
                  onSelectFile: we
                }
              )
            }
          ),
          /* @__PURE__ */ A("div", { className: "sticky bottom-4 flex items-center justify-between sm:relative sm:bottom-0", children: [
            /* @__PURE__ */ A("div", { className: "text-text-tertiary text-sm", children: [
              +!!m,
              " ",
              l("file_manager.file_selector.files_selected")
            ] }),
            /* @__PURE__ */ y(
              ti,
              {
                className: "min-w-14",
                disabled: m === void 0,
                isFetching: Vn,
                onClick: () => Yn(),
                children: l("file_manager.select")
              }
            )
          ] })
        ] })
      }
    ),
    g && /* @__PURE__ */ y(
      zo,
      {
        className: ie(c < 1024 ? "w-full" : "max-w-[calc(50%-20px)]"),
        fileType: M == null ? void 0 : M.type,
        src: (M == null ? void 0 : M.path) ?? (M == null ? void 0 : M.thumbnail) ?? void 0,
        alt: M == null ? void 0 : M.name,
        name: M == null ? void 0 : M.name,
        size: M == null ? void 0 : M.size,
        onClose: () => b(void 0),
        isFetching: ee
      }
    ),
    /* @__PURE__ */ y(
      ns,
      {
        opened: !!v,
        onClose: () => O(void 0),
        confirmationText: l("file_manager.file_selector.file_deletion_confirmation_text", {
          file: v == null ? void 0 : v.name
        }),
        onConfirm: () => ae()
      }
    ),
    /* @__PURE__ */ y(
      ns,
      {
        opened: !!C,
        onClose: () => {
          E(void 0), G(void 0);
        },
        title: l("file_manager.file_selector.rename_file"),
        confirmButtonCaption: l("file_manager.rename"),
        confirmationContent: /* @__PURE__ */ y(
          sa,
          {
            label: l("file_manager.file_selector.file_name"),
            placeholder: l("file_manager.file_selector.enter_new_file_name"),
            value: N,
            onChange: (se) => R(se.target.value),
            error: q
          }
        ),
        onConfirm: () => K()
      }
    ),
    /* @__PURE__ */ y(
      Zc,
      {
        ...t,
        uploaderRef: D,
        opened: U,
        source: i,
        showCroppingNote: e,
        onClose: () => V(!1),
        onUploadFinish: () => {
          x(), V(!1);
        }
      }
    ),
    /* @__PURE__ */ y(
      Hn,
      {
        isFetching: Wn,
        imageFile: Kn,
        opened: ri,
        onClose: Dr,
        onCrop: qn,
        actionButtonLabel: l("file_manager.file_upload.crop_and_select_file"),
        ...t == null ? void 0 : t.imageCropperModalProps
      }
    )
  ] });
}
function gu({
  title: i,
  opened: e,
  onClose: t,
  onSelect: r,
  ...s
}) {
  const { t: n } = fe();
  return /* @__PURE__ */ y(
    bi,
    {
      title: i ?? n("file_manager.file_selector.choose_file"),
      opened: e,
      isCentered: !0,
      size: na.big,
      onClose: t,
      children: /* @__PURE__ */ y(eu, { onSelect: r, ...s })
    }
  );
}
export {
  Ea as AudioFileIcon,
  ns as ConfirmationModal,
  kr as DocumentFileIcon,
  $o as FileActionMenuDeleteItem,
  Uo as FileActionMenuDetailsItem,
  Ho as FileActionMenuDownloadItem,
  Bo as FileActionMenuRenameItem,
  zo as FileDetails,
  On as FileDropZoneVariantEnum,
  ze as FileExtensionEnum,
  Wl as FileGrid,
  Da as FileItem,
  ot as FilePreview,
  rn as FilePreviewFromOS,
  Rl as FileSearch,
  eu as FileSelector,
  gu as FileSelectorModal,
  X as FileSourceEnum,
  Sa as FileSourceEnumLocoKeys,
  Y as FileTypeEnum,
  Oa as FileTypeEnumLocoKeys,
  En as FileUploaderDropZone,
  Fi as FileUploaderItem,
  Zc as FileUploaderModal,
  Bn as ImageCropper,
  Hn as ImageCropperModal,
  Na as ImageFileIcon,
  El as LocaleContext,
  fu as LocaleProvider,
  pr as PaginationOrderEnum,
  du as QueryClientProvider,
  Bs as SortDirectionEnum,
  _a as VideoFileIcon,
  es as appendAspectRatioToFileName,
  en as areAspectRatiosEqual,
  Lo as convertFileInfoToDataFile,
  Jl as createCanceler,
  Zl as createProgress,
  uu as fileInputAcceptTypes,
  jo as formatAcceptTypeForInput,
  Io as formatBytes,
  is as getArrayDifference,
  tn as getAspectRatioLabel,
  To as getAspectRatioNote,
  hu as getFileTypeFromName,
  Zs as getImageAspectRatio,
  ec as getMimeType,
  Ra as getThumbnailByType,
  Ao as hashFile,
  mr as httpClient,
  re as i18n,
  ko as imageToFile,
  ss as isAcceptTypeValid,
  Ca as isDataFileInterface,
  sc as isFileInfoInterface,
  Ui as isImageFile,
  ic as isOsFile,
  rc as isOsFileWithId,
  Fo as loadLangBundle,
  gr as namespace,
  rs as replaceImageFileBlob,
  Js as t,
  pu as useDataFiles,
  vt as useFetch,
  bn as useFileActions,
  _l as useFileDetails,
  Sn as useFileUploader,
  Gl as useFileUploaderActions,
  tc as useFileUploaderManager,
  Nl as useInfiniteDataFiles,
  ts as useStateWatcher,
  fe as useTranslation,
  ac as variantClassName
};
